import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  LocalDate: any;
  LocalTime: any;
  Long: any;
  OffsetDateTime: any;
  Period: any;
  YearMonth: any;
};



export type AcceptAssetOwnerInvitationCommand = {
  assetId: Scalars['ID'];
  invitationId: Scalars['String'];
};

export type AcceptBookingRequest = {
  bookingId: Scalars['String'];
  hostingTeamReturnUrl: Scalars['String'];
  returnUrl: Scalars['String'];
};

export type AcceptConsumerTermsAndConditionsCommand = {
  accepted: Scalars['Boolean'];
};

export type AcceptPropertyOwnerInvitationCommand = {
  invitationId: Scalars['String'];
  propertyId: Scalars['ID'];
};

export type AcceptStaffMemberInvitationCommand = {
  invitationId: Scalars['String'];
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
  tokenType: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  accountHolderId: Scalars['String'];
  accountId: Scalars['ID'];
  bankAccount: BankAccount;
  membership?: Maybe<Membership>;
  personalProfile: PersonalProfile;
};

export type AddApplicationPhotosCommand = {
  memberId: Scalars['ID'];
  photos?: Maybe<Array<Scalars['String']>>;
};

export type AddBusinessCustomerToClienteleCommand = {
  clienteleId: Scalars['String'];
  userId: Scalars['String'];
};

export type AddToFavouritesCommand = {
  referenceId: Scalars['String'];
  type: FavouriteType;
};

export type AddWishToWishlistCommand = {
  guestCounts?: Maybe<Array<GuestCountInput>>;
  listingId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  priceModification?: Maybe<PriceModification>;
  travelDates?: Maybe<TravelDatesInput>;
  wishId: Scalars['String'];
  wishlistId: Scalars['ID'];
};

export type Address = {
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  additionalInstructions?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type AgeRange = {
  __typename?: 'AgeRange';
  allowed: Scalars['Boolean'];
  key: Scalars['String'];
  labelPrefix: Scalars['String'];
  maxAge?: Maybe<Scalars['Int']>;
  maxNumberAllowed: Scalars['Int'];
  minAge?: Maybe<Scalars['Int']>;
  minNumberAllowed: Scalars['Int'];
};

export type Airport = {
  __typename?: 'Airport';
  distance?: Maybe<Scalars['Float']>;
  location: GeoLocation;
  name: Scalars['String'];
  type: AirportType;
};

export enum AirportType {
  LargeAirport = 'large_airport',
  MediumAirport = 'medium_airport'
}

export type AllocateDailyAvailabilityCommand = {
  dailyAvailabilities: Array<DailyAvailability>;
  listingId: Scalars['ID'];
};

export type AllocateInitialMonthlyAvailabilityRequest = {
  blockedDays?: Maybe<Array<Maybe<Scalars['LocalDate']>>>;
  listingId: Scalars['ID'];
};

export type AllocateMonthlyAvailabilityCommand = {
  activeMonths: Array<Maybe<Scalars['YearMonth']>>;
  blockedDays?: Maybe<Array<Maybe<Scalars['LocalDate']>>>;
  listingId: Scalars['ID'];
};

export type AmenitiesCriterion = {
  selectedAmenityIds?: Maybe<Array<Scalars['String']>>;
};

export type AmenityBundleSectionType = {
  __typename?: 'AmenityBundleSectionType';
  amenities: Array<AmenityType>;
  name: Scalars['String'];
  sectionId: Scalars['ID'];
};

export type AmenityBundleType = {
  __typename?: 'AmenityBundleType';
  bundleId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  sections: Array<AmenityBundleSectionType>;
};

export type AmenityType = {
  __typename?: 'AmenityType';
  amenityId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  iconName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum AnnualBookingRevenue {
  Between_20000And_500000 = 'BETWEEN_20000_AND_500000',
  GreaterThan_500000 = 'GREATER_THAN_500000',
  LessThan_20000 = 'LESS_THAN_20000'
}

export type ApplicationPhotoSignUrlRequest = {
  applicantId: Scalars['String'];
  filename: Scalars['String'];
};

export type ApproveListingCommand = {
  listingId: Scalars['ID'];
};

export type AreaType = {
  __typename?: 'AreaType';
  areaDefinitionId: Scalars['String'];
  size?: Maybe<Scalars['Float']>;
  unit?: Maybe<AreaUnit>;
};

export enum AreaUnit {
  Ft2 = 'ft2',
  M2 = 'm2'
}

export type Asset = {
  __typename?: 'Asset';
  assetId: Scalars['ID'];
  assetType?: Maybe<AssetType>;
  documentLibrary: DocumentLibrary;
};

export type AssetOnboardingStatus = {
  __typename?: 'AssetOnboardingStatus';
  amenitiesUpdated: Scalars['Boolean'];
  finished: Scalars['Boolean'];
  generalUpdated: Scalars['Boolean'];
  goodToKnowUpdated: Scalars['Boolean'];
  houseRulesUpdated: Scalars['Boolean'];
  locationUpdated: Scalars['Boolean'];
  ownerAssigned: Scalars['Boolean'];
  photosAdded: Scalars['Boolean'];
};

export type AssetOwner = {
  __typename?: 'AssetOwner';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  ownerId: Scalars['ID'];
  photoUrl?: Maybe<Scalars['String']>;
};

export enum AssetOwnerInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type AssetOwnerInvitationSummary = {
  __typename?: 'AssetOwnerInvitationSummary';
  assetId: Scalars['ID'];
  invitationId: Scalars['String'];
  status: AssetOwnerInvitationStatus;
};

export type AssetPhoto = {
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  useAsCover: Scalars['Boolean'];
  useAsFloorplan: Scalars['Boolean'];
};

export type AssetPhotoType = {
  __typename?: 'AssetPhotoType';
  description?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  useAsCover: Scalars['Boolean'];
  useAsFloorplan: Scalars['Boolean'];
};

export enum AssetType {
  Hotel = 'hotel',
  Property = 'property'
}

export type AssetTypesCriterion = {
  assetTypes?: Maybe<Array<Maybe<AssetType>>>;
};

export type AssignBookingReferenceCommand = {
  bookingId: Scalars['String'];
  bookingReference: Scalars['String'];
};

export type AssignPersonalStaffToMemberCommand = {
  staffId: Scalars['String'];
};

export type AssignStaffToBrandCommand = {
  brandId: Scalars['ID'];
  staffId: Scalars['String'];
};

export type AssignStaffToHotelCommand = {
  hotelId: Scalars['ID'];
  staffId: Scalars['String'];
};

export type AssignStaffToPmcCommand = {
  pmcId: Scalars['ID'];
  staffId: Scalars['String'];
};

export type AssignStaffToTravelAgentCommand = {
  staffId: Scalars['String'];
  travelAgentId: Scalars['ID'];
};

export type AssociatedBooking = {
  __typename?: 'AssociatedBooking';
  booking: Booking;
  bookingId: Scalars['ID'];
  commissionFees: CommissionFees;
  commissionPlan: CommissionPlan;
};

export type AvailabilityCalendar = {
  __typename?: 'AvailabilityCalendar';
  availabilityType?: Maybe<AvailabilityType>;
  dailyAllocations: Array<Maybe<DailyAllocationType>>;
};

export enum AvailabilityType {
  Exchange = 'exchange',
  Rental = 'rental'
}

export type AvailabilityTypeCriterion = {
  availabilityType: AvailabilityType;
};

export type AvailableFromCriterion = {
  minimumConsecutiveNights: Scalars['Int'];
  start: Scalars['LocalDate'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<BankAccountType>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  transitNumber?: Maybe<Scalars['String']>;
};

export enum BankAccountType {
  Checking = 'checking',
  Saving = 'saving'
}

export type BedMeasurement = {
  __typename?: 'BedMeasurement';
  bedSize: BedSize;
  length: Scalars['Int'];
  width: Scalars['Int'];
};

export enum BedSize {
  Crib = 'crib',
  GrandKing = 'grand_king',
  King = 'king',
  ModernCot = 'modern_cot',
  OlympicQueen = 'olympic_queen',
  Queen = 'queen',
  RollawayExtra = 'rollaway_extra',
  Single = 'single',
  StandardDouble = 'standard_double',
  SuperKing = 'super_king',
  Twin = 'twin'
}

export type Bedroom = {
  bedSizes?: Maybe<Array<Maybe<BedSize>>>;
};

export type BedroomType = {
  __typename?: 'BedroomType';
  bedSizes?: Maybe<Array<Maybe<BedSize>>>;
};

export enum BillingPeriod {
  Yearly = 'yearly'
}

export type BlobUploadUrlSigner = {
  __typename?: 'BlobUploadUrlSigner';
  contentType: Scalars['String'];
  httpMethod: HttpMethod;
  signedUrl: Scalars['String'];
  url: Scalars['String'];
};

export type BlockAvailabilityCommand = {
  blockedDays?: Maybe<Array<Maybe<Scalars['LocalDate']>>>;
  listingId: Scalars['ID'];
  reason: BlockReason;
};

export enum BlockReason {
  Booked = 'booked',
  External = 'external',
  Manual = 'manual'
}

export type BookedBy = {
  __typename?: 'BookedBy';
  bookedByType?: Maybe<BookedByType>;
  resellerId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export enum BookedByType {
  Admin = 'admin',
  Consumer = 'consumer',
  Reseller = 'reseller'
}

export type Booking = {
  __typename?: 'Booking';
  bookedBy?: Maybe<BookedBy>;
  bookingId: Scalars['ID'];
  bookingReference?: Maybe<Scalars['String']>;
  bookingSupplementsDetails?: Maybe<BookingSupplementsDetails>;
  bookingTimestamp: Scalars['OffsetDateTime'];
  checkin?: Maybe<Scalars['LocalDate']>;
  checkout?: Maybe<Scalars['LocalDate']>;
  confirmationFlow?: Maybe<BookingConfirmationFlow>;
  fees: Fees;
  guest: Guest;
  installments?: Maybe<Array<BookingInstallment>>;
  listingId: Scalars['ID'];
  nights?: Maybe<Scalars['Int']>;
  numberOfGuests?: Maybe<Scalars['Int']>;
  originalFees?: Maybe<Fees>;
  paymentLink?: Maybe<PaymentLink>;
  paymentStatus?: Maybe<PaymentStatus>;
  priceModification?: Maybe<PriceModificationType>;
  status?: Maybe<BookingStatus>;
  summary: TripSummary;
  tripId: Scalars['ID'];
};

export type BookingCheckoutRequest = {
  bookingId: Scalars['String'];
  /**
   * In case of installments, the specified installment is the one that
   * is being paid, or null if the booking is paid in full.
   */
  installmentId?: Maybe<Scalars['String']>;
  psp: Psp;
  redirects: Redirects;
};

export enum BookingConfirmationFlow {
  InstantBook = 'instant_book',
  RequestToBook = 'request_to_book'
}

export type BookingInstallment = {
  __typename?: 'BookingInstallment';
  bookingFeeInstallment: CurrencyAmountType;
  commissionFeesInstallment?: Maybe<CommissionFees>;
  daysPriorTo?: Maybe<Scalars['Period']>;
  installmentId: Scalars['ID'];
  installmentScheduleId: Scalars['String'];
  paymentStatus?: Maybe<PaymentStatus>;
  percentage: Scalars['Int'];
};

export enum BookingStatus {
  Booked = 'booked',
  Cancelled = 'cancelled',
  Closed = 'closed',
  ConfirmationExpired = 'confirmation_expired',
  Rejected = 'rejected',
  StayCompleted = 'stay_completed',
  StayShortened = 'stay_shortened',
  StayStarted = 'stay_started',
  Unconfirmed = 'unconfirmed'
}

export type BookingSupplementType = {
  __typename?: 'BookingSupplementType';
  description?: Maybe<Scalars['String']>;
  iconName: Scalars['String'];
  name: Scalars['String'];
  price: CurrencyAmountType;
  supplementId: Scalars['String'];
};

export type BookingSupplementsDetails = {
  __typename?: 'BookingSupplementsDetails';
  supplementDetails: Array<BookingSupplementType>;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  neLat: Scalars['Float'];
  neLng: Scalars['Float'];
  swLat: Scalars['Float'];
  swLng: Scalars['Float'];
};

export type Brand = {
  __typename?: 'Brand';
  brandId: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BrandBusinessOwnerInvitation = {
  __typename?: 'BrandBusinessOwnerInvitation';
  businessOwnerId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  invitationId: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  status: BrandBusinessOwnerInvitationStatus;
  /** updateDate will be set when status is initially set or updated */
  updateDate: Scalars['OffsetDateTime'];
};

export enum BrandBusinessOwnerInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type BrandsCriterion = {
  brandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Represents a customer at a Travel Agent (or other partner).
 * Note - this is NOT a Flok customer, instead think of this as the C in B2B2C
 */
export type BusinessCustomer = {
  __typename?: 'BusinessCustomer';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber: PhoneNumberType;
  photoUrl?: Maybe<Scalars['String']>;
  trips: Array<Trip>;
  userId: Scalars['ID'];
};

export type CalendarReference = {
  provider: Scalars['String'];
  reference: Scalars['String'];
};

export type CalendarReferenceType = {
  __typename?: 'CalendarReferenceType';
  provider: Scalars['String'];
  reference: Scalars['String'];
};

export type CancelCheckoutRequest = {
  sessionId: Scalars['ID'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  psp: Psp;
  sessionId: Scalars['String'];
};

export type CleaningFee = {
  __typename?: 'CleaningFee';
  amount: CurrencyAmountType;
  description?: Maybe<Scalars['String']>;
};

export type CleaningFeeInput = {
  amount: CurrencyAmount;
  description?: Maybe<Scalars['String']>;
};

export type CleaningService = {
  __typename?: 'CleaningService';
  isUpdated?: Maybe<Scalars['Boolean']>;
  paymentMode?: Maybe<PaymentMode>;
  perDayCleaningFee?: Maybe<CleaningFee>;
  perStayCleaningFee?: Maybe<CleaningFee>;
};

/**
 * The clients or customers, as of a professional person or shop, considered collectively; a group or body of clients.
 * Clientele can be created for any of the partner businesses like PMC, Brand, TravelAgent, etc.
 * Currently only the TravelAgent exposes the Clientele in the UI. Other business require a bit more work
 */
export type Clientele = {
  __typename?: 'Clientele';
  businessId: Scalars['String'];
  clienteleId: Scalars['ID'];
  customers: Array<BusinessCustomer>;
};

export type Commission = {
  __typename?: 'Commission';
  /**
   * The commission rate the current user is eligible for.
   * Example value: 16.5 equals 16.5%
   */
  rate: Scalars['Float'];
};

export type CommissionFees = {
  __typename?: 'CommissionFees';
  commission: CurrencyAmountType;
  commissionRate: Scalars['Float'];
};

export enum CommissionModelType {
  FlatPercentage = 'flat_percentage'
}

export type CommissionPlan = {
  __typename?: 'CommissionPlan';
  commissionModelType: CommissionModelType;
  commissionPlanId: Scalars['ID'];
  /** Is set when commissionModelType is flat_percentage */
  flatPercentageCommissionPlan?: Maybe<FlatPercentageCommissionPlan>;
  vendorId: Scalars['String'];
};

/** Input for configuring white-label features for a travel agent */
export type ConfigureWhiteLabelCommand = {
  /** Body text font family */
  bodyFont?: Maybe<Scalars['String']>;
  /** Favicon URL */
  faviconUrl?: Maybe<Scalars['String']>;
  /** Header background color in hex format */
  headerColor?: Maybe<Scalars['String']>;
  /** Heading font family */
  headingFont?: Maybe<Scalars['String']>;
  /** Landscape/rectangle format logo URL */
  landscapeLogoUrl?: Maybe<Scalars['String']>;
  /** Primary brand color in hex format (e.g. #FF0000) */
  primaryColor: Scalars['String'];
  /** Primary green accent color in hex format */
  primaryGreen?: Maybe<Scalars['String']>;
  /** Quaternary brand color in hex format */
  quaternaryColor?: Maybe<Scalars['String']>;
  /** ID of the reseller this configuration belongs to */
  resellerId: Scalars['ID'];
  /** Secondary brand color in hex format */
  secondaryColor?: Maybe<Scalars['String']>;
  /** Square format logo URL */
  squareLogoUrl?: Maybe<Scalars['String']>;
  /** Custom subdomain prefix for the white-label site */
  subdomain: Scalars['String'];
  /** Tertiary brand color in hex format */
  tertiaryColor?: Maybe<Scalars['String']>;
};

export type ConnectLinkedinAccountCommand = {
  authorizationCode: Scalars['String'];
  memberId: Scalars['ID'];
};

export type ConnectSocialMediaAccountCommand = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  memberId: Scalars['ID'];
  provider: Scalars['String'];
  publicProfilePicture?: Maybe<Scalars['String']>;
  publicProfileUrl: Scalars['String'];
  reference: Scalars['String'];
};

export type ConversationToken = {
  flokId: Scalars['String'];
  identity: Scalars['String'];
  token: Scalars['String'];
};

export type ConversationTokenType = {
  __typename?: 'ConversationTokenType';
  flokId: Scalars['String'];
  identity: Scalars['String'];
  token: Scalars['String'];
};

export type CreateBookingRequest = {
  /**
   * An email is sent to the owner of the listing upon booking. The email
   * contains a link to accept or decline the booking.
   *
   * If the URL contains {BOOKING_ID} it will be replaced by the actual booking ID
   * If the URL contains {TRIP_ID} it will be replaced by the actual trip ID
   */
  acceptBookingUrl: Scalars['String'];
  bookingToken?: Maybe<Scalars['String']>;
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
  confirmationFlow: BookingConfirmationFlow;
  declineBookingUrl: Scalars['String'];
  guestCounts: Array<GuestCount>;
  /** Optional, in case the booking uses a payment plan */
  installmentScheduleId?: Maybe<Scalars['String']>;
  listingId: Scalars['String'];
  onBehalfOf?: Maybe<OnBehalfOf>;
  priceModification?: Maybe<PriceModification>;
};

export type CreateBusinessCustomerRequest = {
  businessId: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  userId: Scalars['String'];
};

export type CreateHotelRoomCommand = {
  description?: Maybe<Scalars['String']>;
  hotelId: Scalars['ID'];
  hotelRoomId: Scalars['String'];
  maximumOccupancy: Scalars['Int'];
  roomType: Scalars['String'];
};

export type CreateStaffCommand = {
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: PhoneNumber;
  photoUrl: Scalars['String'];
  staffId: Scalars['ID'];
};

export type CreateWishlistCommand = {
  /** Convenient name for the Travel Agent to distinguish between wishlists */
  name: Scalars['String'];
  /** The person the wishlist is for, or null if it's for the creator */
  onBehalfOf?: Maybe<Scalars['String']>;
  wishlistId: Scalars['ID'];
};

export type Criteria = {
  amenitiesCriterion?: Maybe<AmenitiesCriterion>;
  assetTypesCriterion?: Maybe<AssetTypesCriterion>;
  availabilityTypeCriterion?: Maybe<AvailabilityTypeCriterion>;
  /**
   * Oftentimes there's no point in showing a single available night as being
   * the next 'available from'. Use this field to set the
   * minimum for available consecutive nights
   */
  availableFromCriterion?: Maybe<AvailableFromCriterion>;
  brandsCriterion?: Maybe<BrandsCriterion>;
  datesCriterion?: Maybe<DatesCriterion>;
  guestCriterion?: Maybe<GuestCriterion>;
  listingFilter?: Maybe<ListingFilter>;
  locationCriterion?: Maybe<LocationCriterion>;
  metadata: CriteriaMetadata;
  minimumStayNightsCriterion?: Maybe<MinimumStayNightsCriterion>;
  paging: CriteriaPaging;
  priceRangeCriterion?: Maybe<PriceRangeCriterion>;
  regionCriterion?: Maybe<RegionCriterion>;
  roomsAndBedsCriterion?: Maybe<RoomsAndBedsCriterion>;
  /** AI search */
  searchText?: Maybe<Scalars['String']>;
  styleCriterion?: Maybe<StyleCriterion>;
};

export type CriteriaMetadata = {
  /**
   * Include additional listings that are
   * coming soon, but cannot be booked as of yet
   * Defaults to false
   */
  includeComingSoon?: Maybe<Scalars['Boolean']>;
  screenSize: ScreenSize;
};

export type CriteriaPaging = {
  offset: Scalars['Int'];
  size: Scalars['Int'];
};

export type CurrencyAmount = {
  amountMicros: Scalars['Long'];
  currency: Scalars['String'];
};

export type CurrencyAmountType = {
  __typename?: 'CurrencyAmountType';
  amountMicros: Scalars['Long'];
  currency: Scalars['String'];
};

export type DailyAllocationType = {
  __typename?: 'DailyAllocationType';
  allocated?: Maybe<Scalars['Int']>;
  consumed?: Maybe<Scalars['Int']>;
  day: Scalars['LocalDate'];
};

export type DailyAvailability = {
  allocated: Scalars['Int'];
  day: Scalars['LocalDate'];
};

export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['LocalDate'];
  start: Scalars['LocalDate'];
};

export type DatesCriterion = {
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
};

export type DecidingFactor = {
  __typename?: 'DecidingFactor';
  enabled: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DecidingFactors = {
  __typename?: 'DecidingFactors';
  primaryDecidingFactors: Array<DecidingFactor>;
};

export type DeclineBookingRequest = {
  bookingId: Scalars['String'];
  reason: Scalars['String'];
  returnUrl: Scalars['String'];
};

export type DisconnectSocialMediaAccountCommand = {
  memberId: Scalars['ID'];
  provider: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  documentCategoryId: Scalars['String'];
  documentId: Scalars['ID'];
  documentLibraryId: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  documentCategoryId: Scalars['ID'];
  documentLibraryId: Scalars['String'];
  documents?: Maybe<Array<Document>>;
  isDefaultCategory: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DocumentLibrary = {
  __typename?: 'DocumentLibrary';
  categories?: Maybe<Array<DocumentCategory>>;
  documentLibraryId: Scalars['String'];
};

export type ExchangeRateEntry = {
  __typename?: 'ExchangeRateEntry';
  currency?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
};

export type ExpireWishlistCommand = {
  wishlistId: Scalars['ID'];
};

export type Favourite = {
  __typename?: 'Favourite';
  /**
   * The amount of other people that added
   * the exact same 'thing' as favourite
   */
  addedAsFavouriteByOthers: Scalars['Int'];
  /** The 'thing' that is being added as favourite */
  reference?: Maybe<FavouriteReference>;
};

export type FavouriteReference = {
  __typename?: 'FavouriteReference';
  /** The ID of the 'thing' that is being added as favourite */
  referenceId: Scalars['String'];
  /** The type of 'thing' that is being added as favourite */
  type: FavouriteType;
};

export enum FavouriteType {
  Listing = 'listing'
}

export type Fees = {
  __typename?: 'Fees';
  bookingFee: CurrencyAmountType;
  bookingToken?: Maybe<Scalars['String']>;
};

export type FeesCalendar = {
  __typename?: 'FeesCalendar';
  perDayFees: Array<PerDayFees>;
};

export type FlatPercentageCommissionPlan = {
  __typename?: 'FlatPercentageCommissionPlan';
  commissionPlanId: Scalars['ID'];
  flatPercentage: Scalars['Float'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type Guest = {
  __typename?: 'Guest';
  externalReference?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  guestId?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type GuestCount = {
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type GuestCountInput = {
  count?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
};

export type GuestCountType = {
  __typename?: 'GuestCountType';
  count?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
};

export type GuestCriterion = {
  adults?: Maybe<Scalars['Int']>;
  children?: Maybe<Scalars['Int']>;
  infants?: Maybe<Scalars['Int']>;
};

export type GuestRestrictions = {
  __typename?: 'GuestRestrictions';
  ageRanges: Array<AgeRange>;
  maxOccupancy: Scalars['Int'];
};

export type HighlightedFeatures = {
  __typename?: 'HighlightedFeatures';
  features: Array<ListingHighlightedFeature>;
  listingId: Scalars['ID'];
};

export type Host = {
  __typename?: 'Host';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type Hotel = {
  __typename?: 'Hotel';
  amenities?: Maybe<HotelAmenities>;
  documentLibrary: DocumentLibrary;
  general?: Maybe<HotelGeneral>;
  goodToKnow?: Maybe<HotelGoodToKnow>;
  hotelId: Scalars['ID'];
  houseRules?: Maybe<HotelHouseRules>;
  imagery: HotelImagery;
  location?: Maybe<HotelLocation>;
  owner?: Maybe<AssetOwner>;
  rooms: Array<HotelRoom>;
  status: HotelStatus;
  suites: Array<HotelSuite>;
};

export type HotelAmenities = {
  __typename?: 'HotelAmenities';
  amenityIds?: Maybe<Array<Scalars['String']>>;
  hotelId: Scalars['ID'];
};

export type HotelGeneral = {
  __typename?: 'HotelGeneral';
  averageDailyRate?: Maybe<CurrencyAmountType>;
  description?: Maybe<Scalars['String']>;
  externalListingUrl?: Maybe<Scalars['String']>;
  hotelId: Scalars['ID'];
  name: Scalars['String'];
  stars?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

export type HotelGoodToKnow = {
  __typename?: 'HotelGoodToKnow';
  description: Scalars['String'];
  hotelId: Scalars['ID'];
};

export type HotelHouseRules = {
  __typename?: 'HotelHouseRules';
  allowsChildren: Scalars['Boolean'];
  earliestCheckin: Scalars['LocalTime'];
  hotelId: Scalars['ID'];
  latestCheckin: Scalars['LocalTime'];
  maximumStay: Scalars['Int'];
  minimumStay: Scalars['Int'];
};

export type HotelImagery = {
  __typename?: 'HotelImagery';
  hotelId: Scalars['ID'];
  photos?: Maybe<Array<Maybe<AssetPhotoType>>>;
};

export type HotelLocation = {
  __typename?: 'HotelLocation';
  address?: Maybe<AddressType>;
  geoLocation?: Maybe<GeoLocation>;
  hotelId: Scalars['ID'];
};

export type HotelPhotoSignUrlRequest = {
  filename: Scalars['String'];
  hotelId: Scalars['String'];
};

export type HotelRoom = {
  __typename?: 'HotelRoom';
  description?: Maybe<Scalars['String']>;
  guestRestrictions: GuestRestrictions;
  hotelRoomId: Scalars['ID'];
  imagery: HotelRoomImagery;
  packageDeal?: Maybe<PackageDeal>;
  roomType: Scalars['String'];
};

export type HotelRoomImagery = {
  __typename?: 'HotelRoomImagery';
  photos?: Maybe<Array<Maybe<AssetPhotoType>>>;
};

export type HotelRoomPhotoSignUrlRequest = {
  filename: Scalars['String'];
  hotelId: Scalars['String'];
  hotelRoomId: Scalars['String'];
};

export enum HotelStatus {
  OnboardingInProgress = 'onboarding_in_progress',
  ReadyForListing = 'ready_for_listing'
}

export type HotelSuite = {
  __typename?: 'HotelSuite';
  description?: Maybe<Scalars['String']>;
  guestRestrictions: GuestRestrictions;
  hotelSuiteId: Scalars['ID'];
  imagery: HotelSuiteImagery;
  packageDeal?: Maybe<PackageDeal>;
  rooms: HotelSuiteRooms;
  suiteName?: Maybe<Scalars['String']>;
  suiteType: HotelSuiteType;
};

export type HotelSuiteImagery = {
  __typename?: 'HotelSuiteImagery';
  photos?: Maybe<Array<Maybe<AssetPhotoType>>>;
};

export type HotelSuiteRooms = {
  __typename?: 'HotelSuiteRooms';
  areas: Array<Maybe<AreaType>>;
  bedrooms: Array<Maybe<BedroomType>>;
};

export enum HotelSuiteType {
  JuniorSuite = 'junior_suite',
  PresidentialSuite = 'presidential_suite',
  ResidentialSuite = 'residential_suite',
  Suite = 'suite'
}

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type Inbox = {
  __typename?: 'Inbox';
  messageThreads: Array<MessageThread>;
};

export type InputAcceptedResponse = {
  __typename?: 'InputAcceptedResponse';
  id: Scalars['ID'];
};

export type InputGeoLocation = {
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type Installment = {
  __typename?: 'Installment';
  daysPriorTo?: Maybe<Scalars['Period']>;
  installmentId: Scalars['ID'];
  installmentScheduleId: Scalars['String'];
  percentage: Scalars['Int'];
};

export type InstallmentSchedule = {
  __typename?: 'InstallmentSchedule';
  installmentScheduleId: Scalars['ID'];
  installments: Array<Installment>;
};

export type InviteStaffMemberCommand = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  host: Scalars['Boolean'];
  invitationId: Scalars['String'];
  lastName: Scalars['String'];
  manager: Scalars['Boolean'];
  returnUrl: Scalars['String'];
  staffId: Scalars['ID'];
};

export type LatestMessage = {
  __typename?: 'LatestMessage';
  created: Scalars['OffsetDateTime'];
  sender: Participant;
  text?: Maybe<Scalars['String']>;
};

export type LinkExternalCalendarCommand = {
  externalUrl: Scalars['String'];
  listingId: Scalars['ID'];
  name: Scalars['String'];
};

export type LinkedCalendar = {
  __typename?: 'LinkedCalendar';
  externalUrl: Scalars['String'];
  listingId: Scalars['ID'];
  name: Scalars['String'];
};

export type Listing = {
  __typename?: 'Listing';
  allowInstantBook: Scalars['Boolean'];
  asset: Asset;
  availabilityCalendar: AvailabilityCalendar;
  checkin?: Maybe<Scalars['LocalDate']>;
  checkout?: Maybe<Scalars['LocalDate']>;
  cleaningService: CleaningService;
  commission?: Maybe<Commission>;
  documentLibrary: DocumentLibrary;
  fees?: Maybe<Fees>;
  installmentSchedule?: Maybe<InstallmentSchedule>;
  listingId: Scalars['ID'];
  obfuscatedLocation: ObfuscatedLocation;
  operator?: Maybe<Operator>;
  priceRange?: Maybe<PriceRange>;
  status: ListingStatus;
  stayDurationConditions: StayDurationConditions;
  summary: ListingSummary;
  supplements: ListingSupplements;
};

export type ListingAvailabilityCriteria = {
  listingId: Scalars['String'];
  month: Scalars['YearMonth'];
};

export type ListingAvailabilityResults = {
  __typename?: 'ListingAvailabilityResults';
  availabilityCalendar: AvailabilityCalendar;
  firstMonthWithAvailability: Scalars['YearMonth'];
  lastMonthWithAvailability: Scalars['YearMonth'];
};

export type ListingDefinition = {
  __typename?: 'ListingDefinition';
  asset: Asset;
  listingId: Scalars['ID'];
  listingManagementId: Scalars['String'];
  obfuscatedLocation: ObfuscatedLocation;
  status: ListingStatus;
};

export type ListingFilter = {
  exclude: Scalars['Boolean'];
  listingId: Scalars['String'];
};

export type ListingHighlightedFeature = {
  __typename?: 'ListingHighlightedFeature';
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ListingHouseRule = {
  __typename?: 'ListingHouseRule';
  enabled: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ListingHouseRules = {
  __typename?: 'ListingHouseRules';
  otherRules?: Maybe<Scalars['String']>;
  rules: Array<ListingHouseRule>;
};

export type ListingId = {
  __typename?: 'ListingId';
  listingId: Scalars['ID'];
  listingManagementId: Scalars['String'];
};

export type ListingOnboardingStatus = {
  __typename?: 'ListingOnboardingStatus';
  assetOnboardingCompleted: Scalars['Boolean'];
  canInviteOwner: Scalars['Boolean'];
  completed: Scalars['Boolean'];
  hostingTeamAssigned: Scalars['Boolean'];
  meetsMinimumRequiredAvailability: Scalars['Boolean'];
  memberOnboardingCompleted: Scalars['Boolean'];
  ownerAssigned: Scalars['Boolean'];
  priceAssigned: Scalars['Boolean'];
  readyForPublishing: Scalars['Boolean'];
};

export enum ListingStatus {
  Draft = 'draft',
  Published = 'published'
}

export type ListingSummary = {
  __typename?: 'ListingSummary';
  assetDescription: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  decidingFactors: DecidingFactors;
  highlightedAmenities: Array<Scalars['String']>;
  highlightedFeatures: HighlightedFeatures;
  houseRules: ListingHouseRules;
  listingDescription: Scalars['String'];
  listingPhotos: Array<AssetPhotoType>;
  photos: Array<AssetPhotoType>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ListingSupplement = {
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: CurrencyAmount;
  sectionName: Scalars['String'];
};

export type ListingSupplementEntry = {
  __typename?: 'ListingSupplementEntry';
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: CurrencyAmountType;
  sectionName: Scalars['String'];
};

export type ListingSupplements = {
  __typename?: 'ListingSupplements';
  listingId: Scalars['ID'];
  mandatorySupplements?: Maybe<Array<ListingSupplementEntry>>;
  optionalSupplements?: Maybe<Array<ListingSupplementEntry>>;
};



export type Location = {
  __typename?: 'Location';
  address: AddressType;
  geoLocation: GeoLocation;
};

export type LocationCriterion = {
  neLat: Scalars['Float'];
  neLng: Scalars['Float'];
  qry?: Maybe<Scalars['String']>;
  swLat: Scalars['Float'];
  swLng: Scalars['Float'];
};


export type Member = {
  __typename?: 'Member';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['ID'];
  phoneNumber: PhoneNumberType;
  photoUrl?: Maybe<Scalars['String']>;
};

export type MemberApplication = {
  __typename?: 'MemberApplication';
  address?: Maybe<AddressType>;
  calendarReference?: Maybe<CalendarReferenceType>;
  connectedSocialAccounts?: Maybe<Array<Maybe<SocialReferenceType>>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  geoLocation?: Maybe<GeoLocation>;
  lastName: Scalars['String'];
  memberId: Scalars['ID'];
  phoneNumber: PhoneNumberType;
  photos?: Maybe<Array<Maybe<Scalars['String']>>>;
  preliminaryHotelDetails?: Maybe<PreliminaryHotelDetails>;
  preliminaryPropertyDetails?: Maybe<PreliminaryPropertyDetails>;
  status: MemberApplicationStatus;
};

export enum MemberApplicationStatus {
  Approved = 'approved',
  None = 'none',
  Preapproved = 'preapproved',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

export enum MemberApplicationType {
  Full = 'full',
  Invitation = 'invitation'
}

export type MemberOnboardingStatus = {
  __typename?: 'MemberOnboardingStatus';
  assetBeingOnboarded: Asset;
  completed: Scalars['Boolean'];
};

export type Membership = {
  __typename?: 'Membership';
  end: Scalars['LocalDate'];
  membershipPlan: MembershipPlan;
  start: Scalars['LocalDate'];
};

export type MembershipPlan = {
  __typename?: 'MembershipPlan';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  billingPeriod: BillingPeriod;
  membershipPlan: MembershipPlan;
  recurringPrice: CurrencyAmountType;
};

export type MessageThread = {
  __typename?: 'MessageThread';
  latestMessage?: Maybe<LatestMessage>;
  messageThreadId: Scalars['ID'];
  participants: Array<Participant>;
  subject?: Maybe<Subject>;
  type: MessageThreadType;
};

export enum MessageThreadType {
  Conversation = 'conversation'
}

export type MinimumRequiredAvailability = {
  __typename?: 'MinimumRequiredAvailability';
  required: Array<SeasonalMinimum>;
};

export type MinimumStayNightsCriterion = {
  minimumStayNights?: Maybe<Scalars['Int']>;
};

/** Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Invite hotel owner */
  acceptAssetOwnerInvitation: InputAcceptedResponse;
  /** @auth(scope: "write:confirm_booking") */
  acceptBooking: InputAcceptedResponse;
  acceptBrandBusinessOwnerInvitation: InputAcceptedResponse;
  acceptConsumerTermsAndConditions: InputAcceptedResponse;
  /** Invite Brand, PMC or TravelAgent business owner */
  acceptPmcBusinessOwnerInvitation: InputAcceptedResponse;
  /**
   * Invite property owner
   * @deprecated Field no longer supported
   */
  acceptPropertyOwnerInvitation: InputAcceptedResponse;
  acceptStaffMemberInvitation: InputAcceptedResponse;
  acceptTravelAgentBusinessOwnerInvitation: InputAcceptedResponse;
  addApplicationPhotos: InputAcceptedResponse;
  addBusinessCustomerToClientele: InputAcceptedResponse;
  addToFavourites: InputAcceptedResponse;
  addWishToWishlist: InputAcceptedResponse;
  allocateDailyAvailability: InputAcceptedResponse;
  /** Manage availability */
  allocateInitialMonthlyAvailability: InputAcceptedResponse;
  allocateMonthlyAvailability: InputAcceptedResponse;
  applicationPhotoSignUrl: BlobUploadUrlSigner;
  approveListing: InputAcceptedResponse;
  /**
   * When a booking is "Request to book", then the booking reference needs
   * to be retrieved from the hotel reception desk or villa hosts.
   * When it's "Instant book", then the platform generates a booking reference autamatically.
   */
  assignBookingReference: InputAcceptedResponse;
  assignPersonalStaffToMember: InputAcceptedResponse;
  assignStaffToBrand: InputAcceptedResponse;
  assignStaffToHotel: InputAcceptedResponse;
  assignStaffToPmc: InputAcceptedResponse;
  assignStaffToTravelAgent: InputAcceptedResponse;
  blockAvailability: InputAcceptedResponse;
  cancelCheckout: InputAcceptedResponse;
  /** Checkout */
  checkout: CheckoutSession;
  /** Configure white-label features for a travel agent */
  configureWhiteLabel: InputAcceptedResponse;
  connectLinkedinAccount: InputAcceptedResponse;
  connectSocialMediaAccount: InputAcceptedResponse;
  /** Travel agents to book "on behalf of" */
  createBooking: InputAcceptedResponse;
  /** Creating consumers for their clients -OR- adding business clients to their clientele */
  createBusinessCustomer: InputAcceptedResponse;
  createHotelRoom: InputAcceptedResponse;
  /** Staff */
  createStaff: InputAcceptedResponse;
  createWishlist: InputAcceptedResponse;
  /** @auth(scope: "write:confirm_booking") */
  declineBooking: InputAcceptedResponse;
  disconnectSocialMediaAccount: InputAcceptedResponse;
  expireWishlist: InputAcceptedResponse;
  hotelPhotoSignUrl: BlobUploadUrlSigner;
  hotelRoomPhotoSignUrl: BlobUploadUrlSigner;
  inviteStaffMember: InputAcceptedResponse;
  linkExternalCalendar: InputAcceptedResponse;
  payMembershipSubscription: CheckoutSession;
  /** Member profile, account settings, family members, etc. */
  profilePhotoSignUrl: BlobUploadUrlSigner;
  /** Inquiries */
  propertyInquiry: InputAcceptedResponse;
  propertyPhotoSignUrl: BlobUploadUrlSigner;
  publishListing: InputAcceptedResponse;
  /** Listing */
  recordListingVisit: InputAcceptedResponse;
  referMember: InputAcceptedResponse;
  removeFromFavourites: InputAcceptedResponse;
  removeMemberFromStaff: InputAcceptedResponse;
  removeWishFromWishlist: InputAcceptedResponse;
  /** Inbox & Conversations */
  sendConversationMessage: InputAcceptedResponse;
  signupConsumer: InputAcceptedResponse;
  signupHotel: InputAcceptedResponse;
  /**
   * Assumes user has signed up with identity provider (auth0), but
   * doesn't have a user account on our platform yet. This endpoint
   * creates a new user (consumer) and links it to the current access token.
   *
   * Also allows Travel Agents, to create a consumer for their clients.
   */
  signupTravelAgent: InputAcceptedResponse;
  staffPhotoSignUrl: BlobUploadUrlSigner;
  /** Onboard properties */
  startPropertyOnboarding: InputAcceptedResponse;
  /** Onboard members */
  submitMemberApplication: InputAcceptedResponse;
  unblockAvailability: InputAcceptedResponse;
  unlinkExternalCalendar: InputAcceptedResponse;
  updateBankAccount: InputAcceptedResponse;
  updateBookingSettings: InputAcceptedResponse;
  updateHotelAmenities: InputAcceptedResponse;
  /** Hotels */
  updateHotelGeneral: InputAcceptedResponse;
  updateHotelGoodToKnow: InputAcceptedResponse;
  updateHotelHouseRules: InputAcceptedResponse;
  updateHotelLocation: InputAcceptedResponse;
  updateHotelPhotos: InputAcceptedResponse;
  updateHotelRoom: InputAcceptedResponse;
  updateHotelRoomPhotos: InputAcceptedResponse;
  updateListingCleaningService: InputAcceptedResponse;
  updateListingSupplements: InputAcceptedResponse;
  updatePersonalAddress: InputAcceptedResponse;
  updatePersonalInformation: InputAcceptedResponse;
  updatePersonalPhoneNumber: InputAcceptedResponse;
  updatePersonalPhoto: InputAcceptedResponse;
  updatePropertyAmenities: InputAcceptedResponse;
  updatePropertyGeneral: InputAcceptedResponse;
  updatePropertyGoodToKnow: InputAcceptedResponse;
  updatePropertyHouseRules: InputAcceptedResponse;
  updatePropertyLocation: InputAcceptedResponse;
  updatePropertyPhotos: InputAcceptedResponse;
  updateStaff: InputAcceptedResponse;
  updateWishlist: InputAcceptedResponse;
  /** Generate a signed URL for uploading a white label logo */
  whiteLabelLogoSignUrl: BlobUploadUrlSigner;
};


/** Mutations */
export type MutationAcceptAssetOwnerInvitationArgs = {
  input: AcceptAssetOwnerInvitationCommand;
};


/** Mutations */
export type MutationAcceptBookingArgs = {
  input: AcceptBookingRequest;
};


/** Mutations */
export type MutationAcceptBrandBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Mutations */
export type MutationAcceptConsumerTermsAndConditionsArgs = {
  input: AcceptConsumerTermsAndConditionsCommand;
};


/** Mutations */
export type MutationAcceptPmcBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Mutations */
export type MutationAcceptPropertyOwnerInvitationArgs = {
  input: AcceptPropertyOwnerInvitationCommand;
};


/** Mutations */
export type MutationAcceptStaffMemberInvitationArgs = {
  input: AcceptStaffMemberInvitationCommand;
};


/** Mutations */
export type MutationAcceptTravelAgentBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Mutations */
export type MutationAddApplicationPhotosArgs = {
  input: AddApplicationPhotosCommand;
};


/** Mutations */
export type MutationAddBusinessCustomerToClienteleArgs = {
  input: AddBusinessCustomerToClienteleCommand;
};


/** Mutations */
export type MutationAddToFavouritesArgs = {
  input: AddToFavouritesCommand;
};


/** Mutations */
export type MutationAddWishToWishlistArgs = {
  input: AddWishToWishlistCommand;
};


/** Mutations */
export type MutationAllocateDailyAvailabilityArgs = {
  input: AllocateDailyAvailabilityCommand;
};


/** Mutations */
export type MutationAllocateInitialMonthlyAvailabilityArgs = {
  input: AllocateInitialMonthlyAvailabilityRequest;
};


/** Mutations */
export type MutationAllocateMonthlyAvailabilityArgs = {
  input: AllocateMonthlyAvailabilityCommand;
};


/** Mutations */
export type MutationApplicationPhotoSignUrlArgs = {
  input: ApplicationPhotoSignUrlRequest;
};


/** Mutations */
export type MutationApproveListingArgs = {
  input: ApproveListingCommand;
};


/** Mutations */
export type MutationAssignBookingReferenceArgs = {
  input: AssignBookingReferenceCommand;
};


/** Mutations */
export type MutationAssignPersonalStaffToMemberArgs = {
  input: AssignPersonalStaffToMemberCommand;
};


/** Mutations */
export type MutationAssignStaffToBrandArgs = {
  input: AssignStaffToBrandCommand;
};


/** Mutations */
export type MutationAssignStaffToHotelArgs = {
  input: AssignStaffToHotelCommand;
};


/** Mutations */
export type MutationAssignStaffToPmcArgs = {
  input: AssignStaffToPmcCommand;
};


/** Mutations */
export type MutationAssignStaffToTravelAgentArgs = {
  input: AssignStaffToTravelAgentCommand;
};


/** Mutations */
export type MutationBlockAvailabilityArgs = {
  input: BlockAvailabilityCommand;
};


/** Mutations */
export type MutationCancelCheckoutArgs = {
  input: CancelCheckoutRequest;
};


/** Mutations */
export type MutationCheckoutArgs = {
  input: BookingCheckoutRequest;
};


/** Mutations */
export type MutationConfigureWhiteLabelArgs = {
  input: ConfigureWhiteLabelCommand;
};


/** Mutations */
export type MutationConnectLinkedinAccountArgs = {
  input: ConnectLinkedinAccountCommand;
};


/** Mutations */
export type MutationConnectSocialMediaAccountArgs = {
  input: ConnectSocialMediaAccountCommand;
};


/** Mutations */
export type MutationCreateBookingArgs = {
  input: CreateBookingRequest;
};


/** Mutations */
export type MutationCreateBusinessCustomerArgs = {
  input: CreateBusinessCustomerRequest;
};


/** Mutations */
export type MutationCreateHotelRoomArgs = {
  input: CreateHotelRoomCommand;
};


/** Mutations */
export type MutationCreateStaffArgs = {
  input: CreateStaffCommand;
};


/** Mutations */
export type MutationCreateWishlistArgs = {
  input: CreateWishlistCommand;
};


/** Mutations */
export type MutationDeclineBookingArgs = {
  input: DeclineBookingRequest;
};


/** Mutations */
export type MutationDisconnectSocialMediaAccountArgs = {
  input: DisconnectSocialMediaAccountCommand;
};


/** Mutations */
export type MutationExpireWishlistArgs = {
  input: ExpireWishlistCommand;
};


/** Mutations */
export type MutationHotelPhotoSignUrlArgs = {
  input: HotelPhotoSignUrlRequest;
};


/** Mutations */
export type MutationHotelRoomPhotoSignUrlArgs = {
  input: HotelRoomPhotoSignUrlRequest;
};


/** Mutations */
export type MutationInviteStaffMemberArgs = {
  input?: Maybe<InviteStaffMemberCommand>;
};


/** Mutations */
export type MutationLinkExternalCalendarArgs = {
  input: LinkExternalCalendarCommand;
};


/** Mutations */
export type MutationPayMembershipSubscriptionArgs = {
  input: PayMembershipSubscriptionRequest;
};


/** Mutations */
export type MutationProfilePhotoSignUrlArgs = {
  input: ProfilePhotoSignUrlRequest;
};


/** Mutations */
export type MutationPropertyInquiryArgs = {
  input: PropertyInquiryRequest;
};


/** Mutations */
export type MutationPropertyPhotoSignUrlArgs = {
  input: PropertyPhotoSignUrlRequest;
};


/** Mutations */
export type MutationPublishListingArgs = {
  input: PublishListingCommand;
};


/** Mutations */
export type MutationRecordListingVisitArgs = {
  input: RecordListingVisit;
};


/** Mutations */
export type MutationReferMemberArgs = {
  input: ReferMemberCommand;
};


/** Mutations */
export type MutationRemoveFromFavouritesArgs = {
  input: RemoveFromFavouritesCommand;
};


/** Mutations */
export type MutationRemoveMemberFromStaffArgs = {
  input?: Maybe<RemoveMemberFromStaffCommand>;
};


/** Mutations */
export type MutationRemoveWishFromWishlistArgs = {
  input: RemoveWishFromWishlistCommand;
};


/** Mutations */
export type MutationSendConversationMessageArgs = {
  input: SendConversationMessageRequest;
};


/** Mutations */
export type MutationSignupConsumerArgs = {
  input: SignupConsumerRequest;
};


/** Mutations */
export type MutationSignupHotelArgs = {
  input: SignupHotelRequest;
};


/** Mutations */
export type MutationSignupTravelAgentArgs = {
  input: SignupTravelAgentRequest;
};


/** Mutations */
export type MutationStaffPhotoSignUrlArgs = {
  input: StaffPhotoSignUrlRequest;
};


/** Mutations */
export type MutationStartPropertyOnboardingArgs = {
  input: StartPropertyOnboardingCommand;
};


/** Mutations */
export type MutationSubmitMemberApplicationArgs = {
  input: SubmitMemberApplicationCommand;
};


/** Mutations */
export type MutationUnblockAvailabilityArgs = {
  input: UnblockAvailabilityCommand;
};


/** Mutations */
export type MutationUnlinkExternalCalendarArgs = {
  input: UnlinkExternalCalendarCommand;
};


/** Mutations */
export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountCommand;
};


/** Mutations */
export type MutationUpdateBookingSettingsArgs = {
  input: UpdateBookingSettingsCommand;
};


/** Mutations */
export type MutationUpdateHotelAmenitiesArgs = {
  input: UpdateHotelAmenitiesCommand;
};


/** Mutations */
export type MutationUpdateHotelGeneralArgs = {
  input: UpdateHotelGeneralCommand;
};


/** Mutations */
export type MutationUpdateHotelGoodToKnowArgs = {
  input: UpdateHotelGoodToKnowCommand;
};


/** Mutations */
export type MutationUpdateHotelHouseRulesArgs = {
  input: UpdateHotelHouseRulesCommand;
};


/** Mutations */
export type MutationUpdateHotelLocationArgs = {
  input: UpdateHotelLocationCommand;
};


/** Mutations */
export type MutationUpdateHotelPhotosArgs = {
  input: UpdateHotelPhotosCommand;
};


/** Mutations */
export type MutationUpdateHotelRoomArgs = {
  input: UpdateHotelRoomCommand;
};


/** Mutations */
export type MutationUpdateHotelRoomPhotosArgs = {
  input: UpdateHotelRoomPhotosCommand;
};


/** Mutations */
export type MutationUpdateListingCleaningServiceArgs = {
  input: UpdateListingCleaningServiceCommand;
};


/** Mutations */
export type MutationUpdateListingSupplementsArgs = {
  input: UpdateListingSupplementsCommand;
};


/** Mutations */
export type MutationUpdatePersonalAddressArgs = {
  input: UpdatePersonalAddressCommand;
};


/** Mutations */
export type MutationUpdatePersonalInformationArgs = {
  input: UpdatePersonalInformationCommand;
};


/** Mutations */
export type MutationUpdatePersonalPhoneNumberArgs = {
  input: UpdatePersonalPhoneNumberCommand;
};


/** Mutations */
export type MutationUpdatePersonalPhotoArgs = {
  input: UpdatePersonalPhotoCommand;
};


/** Mutations */
export type MutationUpdatePropertyAmenitiesArgs = {
  input: UpdatePropertyAmenitiesCommand;
};


/** Mutations */
export type MutationUpdatePropertyGeneralArgs = {
  input: UpdatePropertyGeneralCommand;
};


/** Mutations */
export type MutationUpdatePropertyGoodToKnowArgs = {
  input: UpdatePropertyGoodToKnowCommand;
};


/** Mutations */
export type MutationUpdatePropertyHouseRulesArgs = {
  input: UpdatePropertyHouseRulesCommand;
};


/** Mutations */
export type MutationUpdatePropertyLocationArgs = {
  input: UpdatePropertyLocationCommand;
};


/** Mutations */
export type MutationUpdatePropertyPhotosArgs = {
  input: UpdatePropertyPhotosCommand;
};


/** Mutations */
export type MutationUpdateStaffArgs = {
  input: UpdateStaffCommand;
};


/** Mutations */
export type MutationUpdateWishlistArgs = {
  input: UpdateWishlistCommand;
};


/** Mutations */
export type MutationWhiteLabelLogoSignUrlArgs = {
  input: WhiteLabelLogoSignUrlRequest;
};

export type ObfuscatedLocation = {
  __typename?: 'ObfuscatedLocation';
  location: GeoLocation;
  range: Scalars['Int'];
};


export type OnBehalfOf = {
  externalReference?: Maybe<Scalars['String']>;
  identityId?: Maybe<Scalars['String']>;
};

export type Operator = {
  __typename?: 'Operator';
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  operatorId: Scalars['ID'];
};

export type PackageDeal = {
  __typename?: 'PackageDeal';
  helpText: Scalars['String'];
  showCurrency: Scalars['Boolean'];
  text: Scalars['String'];
};

export type PageResult = Listing;

export type PagedList = {
  __typename?: 'PagedList';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  results: Array<PageResult>;
  searchTerm?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type Participant = {
  __typename?: 'Participant';
  chatServerIdentity?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  participantId: Scalars['ID'];
};

export type PayMembershipSubscriptionRequest = {
  cancelUrl: Scalars['String'];
  membershipPlanId: Scalars['String'];
  promotionalCodeId?: Maybe<Scalars['String']>;
  successUrl: Scalars['String'];
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  expiresAt?: Maybe<Scalars['OffsetDateTime']>;
  psp: Psp;
  url: Scalars['String'];
};

export enum PaymentMode {
  Cash = 'cash',
  Voucher = 'voucher'
}

export enum PaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid'
}

export type PerDayFees = {
  __typename?: 'PerDayFees';
  day: Scalars['LocalDate'];
  fees: Fees;
};


export type PersonalProfile = {
  __typename?: 'PersonalProfile';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber: PhoneNumberType;
  photoUrl?: Maybe<Scalars['String']>;
};

export type PhoneNumber = {
  countryCode: Scalars['String'];
  nationalNumber: Scalars['String'];
};

export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  countryCode: Scalars['String'];
  nationalNumber: Scalars['String'];
};

export type Pmc = {
  __typename?: 'Pmc';
  name: Scalars['String'];
  pmcId: Scalars['ID'];
};

export type PmcBusinessOwnerInvitation = {
  __typename?: 'PmcBusinessOwnerInvitation';
  businessOwnerId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  invitationId: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  status: PmcBusinessOwnerInvitationStatus;
  /** updateDate will be set when status is initially set or updated */
  updateDate: Scalars['OffsetDateTime'];
};

export enum PmcBusinessOwnerInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type PreliminaryHotelDetails = {
  __typename?: 'PreliminaryHotelDetails';
  averageDailyRate: CurrencyAmountType;
  hotelName: Scalars['String'];
  stars: Scalars['Int'];
  website: Scalars['String'];
};

export type PreliminaryPropertyDetails = {
  __typename?: 'PreliminaryPropertyDetails';
  approximateValue: CurrencyAmountType;
  bathrooms: Scalars['Int'];
  bedrooms: Scalars['Int'];
  propertyName: Scalars['String'];
  sleeps: Scalars['Int'];
};

export type PriceModification = {
  adjustedBookingFee?: Maybe<CurrencyAmount>;
};

export type PriceModificationType = {
  __typename?: 'PriceModificationType';
  adjustedBookingFee?: Maybe<CurrencyAmountType>;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  highest: Fees;
  lowest: Fees;
};

export type PriceRangeCriterion = {
  maximum?: Maybe<CurrencyAmount>;
  minimum?: Maybe<CurrencyAmount>;
};

export type ProfilePhotoSignUrlRequest = {
  filename: Scalars['String'];
};

export type Property = {
  __typename?: 'Property';
  amenities?: Maybe<PropertyAmenities>;
  created: Scalars['OffsetDateTime'];
  general?: Maybe<PropertyGeneral>;
  goodToKnow?: Maybe<PropertyGoodToKnow>;
  guestRestrictions: GuestRestrictions;
  houseRules?: Maybe<PropertyHouseRules>;
  imagery: PropertyImagery;
  location?: Maybe<PropertyLocation>;
  owner?: Maybe<AssetOwner>;
  propertyId: Scalars['ID'];
  status: PropertyStatus;
};

export type PropertyAmenities = {
  __typename?: 'PropertyAmenities';
  amenityIds?: Maybe<Array<Scalars['String']>>;
  propertyId: Scalars['ID'];
};

export type PropertyGeneral = {
  __typename?: 'PropertyGeneral';
  approximateValue?: Maybe<CurrencyAmountType>;
  bathrooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Array<Maybe<BedroomType>>>;
  description?: Maybe<Scalars['String']>;
  externalListingUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  propertyStyle?: Maybe<PropertyStyle>;
  propertyType?: Maybe<PropertyType>;
  sleeps?: Maybe<Scalars['Int']>;
};

export type PropertyGoodToKnow = {
  __typename?: 'PropertyGoodToKnow';
  description: Scalars['String'];
  propertyId: Scalars['ID'];
};

export type PropertyHouseRules = {
  __typename?: 'PropertyHouseRules';
  allowsChildren: Scalars['Boolean'];
  allowsEvents: Scalars['Boolean'];
  allowsInfants: Scalars['Boolean'];
  allowsPets: Scalars['Boolean'];
  allowsSmoking: Scalars['Boolean'];
  propertyId: Scalars['ID'];
};

export type PropertyImagery = {
  __typename?: 'PropertyImagery';
  photos?: Maybe<Array<Maybe<AssetPhotoType>>>;
  propertyId: Scalars['ID'];
};

export type PropertyInquiryRequest = {
  checkin?: Maybe<Scalars['LocalDate']>;
  checkout?: Maybe<Scalars['LocalDate']>;
  contactMethod: Scalars['String'];
  context: TrackingContext;
  numberOfGuests: Scalars['Int'];
  requirementsDescription: Scalars['String'];
  tripBudget: CurrencyAmount;
};

export type PropertyLocation = {
  __typename?: 'PropertyLocation';
  address?: Maybe<AddressType>;
  geoLocation?: Maybe<GeoLocation>;
  propertyId: Scalars['ID'];
};

export enum PropertyOwnerInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type PropertyOwnerInvitationSummary = {
  __typename?: 'PropertyOwnerInvitationSummary';
  invitationId: Scalars['String'];
  propertyId: Scalars['ID'];
  status: PropertyOwnerInvitationStatus;
};

export type PropertyPhotoSignUrlRequest = {
  filename: Scalars['String'];
  propertyId: Scalars['String'];
};

export enum PropertyStatus {
  Archived = 'archived',
  OnboardingInProgress = 'onboarding_in_progress',
  ReadyForListing = 'ready_for_listing'
}

export enum PropertyStyle {
  ByTheSea = 'by_the_sea',
  CityPad = 'city_pad',
  LeafySuburbs = 'leafy_suburbs',
  MountainView = 'mountain_view',
  OnTheRiver = 'on_the_river',
  RuralRetreat = 'rural_retreat',
  SafariLodge = 'safari_lodge',
  SkiChalet = 'ski_chalet'
}

export enum PropertyType {
  Apartment = 'apartment',
  BedAndBreakfast = 'bed_and_breakfast',
  Cabin = 'cabin',
  Chalet = 'chalet',
  Cottage = 'cottage',
  GuestSuite = 'guest_suite',
  Guesthouse = 'guesthouse',
  MainHome = 'main_home',
  Resort = 'resort',
  ServicedApartment = 'serviced_apartment',
  Villa = 'villa',
  Yacht = 'yacht'
}

export enum Psp {
  Backoffice = 'backoffice',
  Mock = 'mock',
  Stripe = 'stripe'
}

export type PublicBooking = {
  __typename?: 'PublicBooking';
  bookedBy?: Maybe<BookedBy>;
  bookingId: Scalars['ID'];
  bookingReference?: Maybe<Scalars['String']>;
  bookingTimestamp: Scalars['OffsetDateTime'];
  checkin?: Maybe<Scalars['LocalDate']>;
  checkout?: Maybe<Scalars['LocalDate']>;
  nights?: Maybe<Scalars['Int']>;
  numberOfGuests?: Maybe<Scalars['Int']>;
  originalFees?: Maybe<Fees>;
  status?: Maybe<BookingStatus>;
  summary: TripSummary;
  tripId: Scalars['String'];
};

export type PublicListing = {
  __typename?: 'PublicListing';
  listingCode: Scalars['String'];
  name: Scalars['String'];
  publicListingEntries?: Maybe<Array<PublicListingEntry>>;
};

export type PublicListingEntry = {
  __typename?: 'PublicListingEntry';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  decidingFactors: DecidingFactors;
  listingId: Scalars['String'];
  obfuscatedLocation: ObfuscatedLocation;
  operator?: Maybe<Operator>;
  photos: Array<AssetPhotoType>;
  title: Scalars['String'];
};

export type PublicWish = {
  __typename?: 'PublicWish';
  guestCounts?: Maybe<Array<GuestCountType>>;
  priceModification?: Maybe<PriceModificationType>;
  searchListing: SearchListing;
  travelDates?: Maybe<TravelDatesType>;
  wishId: Scalars['ID'];
};

export type PublicWishlist = {
  __typename?: 'PublicWishlist';
  name: Scalars['String'];
  wishes: Array<PublicWish>;
  wishlistId: Scalars['ID'];
};

export type PublishListingCommand = {
  listingId: Scalars['ID'];
};

/** Queries */
export type Query = {
  __typename?: 'Query';
  /** Account */
  account?: Maybe<Account>;
  /** Member application */
  activeMemberApplication?: Maybe<MemberApplication>;
  /** (scope: "module:search") needs custom handling */
  airports: Array<Airport>;
  /** Amenities */
  amenityBundleByAsset?: Maybe<AmenityBundleType>;
  assetOnboardingStatus: AssetOnboardingStatus;
  assetOwnerInvitationSummary?: Maybe<AssetOwnerInvitationSummary>;
  /** Returns the entire calendar for a listing */
  availabilityCalendar?: Maybe<ListingAvailabilityResults>;
  bankAccountDetails?: Maybe<Account>;
  bedMeasurements: Array<Maybe<BedMeasurement>>;
  booking: Booking;
  bookingFees: Fees;
  brandBusinessOwnerInvitation: BrandBusinessOwnerInvitation;
  brandByAssignedAsset?: Maybe<Brand>;
  brandStaff?: Maybe<Staff>;
  brands: Array<Brand>;
  /** (scope: "read:clientele") needs custom handling */
  businessCustomer: BusinessCustomer;
  /** Check if a subdomain is available for use */
  checkSubdomainAvailability: SubdomainAvailability;
  /** Clientele */
  clientele: Clientele;
  clienteleByBusinessId: Clientele;
  /** (scope: "read:clientele") needs custom handling */
  commission?: Maybe<CommissionFees>;
  connectedSocialAccount?: Maybe<SocialReferenceType>;
  /** Conversation */
  conversationToken: ConversationTokenType;
  eligibleMembershipSubscriptions: Array<MembershipSubscription>;
  /** Passwordless login for partner members */
  exchangeAuthCode: AccessToken;
  exportUrl: Scalars['String'];
  /** Will return a Favourite if the current user has referenceId as one of his/her favourites */
  favourite?: Maybe<Favourite>;
  /** Returns all favourites of all types for the current user */
  favourites: Array<Maybe<Favourite>>;
  /** Endpoints used during onboarding before the user is logged in */
  featuredListings: PublicListing;
  feesCalendar?: Maybe<FeesCalendar>;
  hostingTeam?: Maybe<Host>;
  hostingTeamByListing?: Maybe<Host>;
  /** Hotels */
  hotel: Hotel;
  hotelListing: Hotel;
  hotelStaff?: Maybe<Staff>;
  hotels: Array<Hotel>;
  inbox: Inbox;
  /**
   * (scope: "read:clientele") needs custom handling
   * Invitations
   */
  invitationStatus?: Maybe<RoleInvitation>;
  /** (scope: "module:search") needs custom handling */
  linkedCalendars: Array<Maybe<LinkedCalendar>>;
  listing: Listing;
  /** (scope: "read:listing") needs custom handling */
  listingByTravelDetails: Listing;
  listingDefinition?: Maybe<ListingDefinition>;
  /**
   * Wishlists (Proposals for Travel agents)
   *
   * Listing
   *
   * TODO: LEX-1186 Improve naming for propertyOrHotelRoomId
   */
  listingId?: Maybe<ListingId>;
  /** (scope: "read:listing") needs custom handling */
  listingOnboardingStatus?: Maybe<ListingOnboardingStatus>;
  listingOnboardingStatuses: Array<ListingOnboardingStatus>;
  /** @deprecated Use managedListings() instead */
  listingsByMember: Array<Listing>;
  managedListings: PagedList;
  memberOnboardingStatus: MemberOnboardingStatus;
  messageThread?: Maybe<MessageThread>;
  /** (scope: "read:listing") needs custom handling */
  minimumRequiredAvailability?: Maybe<MinimumRequiredAvailability>;
  myGuest?: Maybe<Booking>;
  myGuests: Array<Maybe<Booking>>;
  myPersonalStaff?: Maybe<Staff>;
  otherNests: SearchResults;
  ownedBrands?: Maybe<Array<Maybe<Brand>>>;
  ownedPmcs?: Maybe<Array<Maybe<Pmc>>>;
  ownedTravelAgents?: Maybe<Array<Maybe<TravelAgent>>>;
  /**
   * (scope: "write:hotel" OR "write:property") needs custom handling
   * PMC, Travel Agent and business owners
   */
  pmcBusinessOwnerInvitation: PmcBusinessOwnerInvitation;
  pmcStaff?: Maybe<Staff>;
  /** Exchange rates */
  presentmentCurrencyExchangeRates: Array<ExchangeRateEntry>;
  properties: Array<Property>;
  /** Property owners */
  property?: Maybe<Property>;
  /**
   * Users
   * @deprecated Field no longer supported
   */
  propertyOwnerInvitationSummary?: Maybe<PropertyOwnerInvitationSummary>;
  publicBooking: PublicBooking;
  publicWishlist?: Maybe<PublicWishlist>;
  /**
   * Custom scope handling for current user
   * TODO: RES-335 Confirm endpoints obsolete
   */
  rescheduleBookingOrder: RescheduleBookingOrderRequest;
  /** (scope: "read:reseller") needs custom handling */
  resellerByBookingId?: Maybe<Reseller>;
  resellerByBusinessId?: Maybe<Reseller>;
  resourceScopes: Array<Scalars['String']>;
  roles: Array<Role>;
  scopes: Array<Scalars['String']>;
  searchListings: SearchResults;
  /**
   * Custom scope handling for current user
   * TODO: Allow TAs to search for existing users??
   * @deprecated Field no longer supported
   */
  searchMembers: Array<Member>;
  searchOptions: SearchOptions;
  /** Staff */
  staffMemberInvitation: StaffMemberInvitation;
  /** @deprecated Field no longer supported */
  staffMemberInvitationSummary?: Maybe<StaffMemberInvitationSummary>;
  staffMemberInvitations: Array<StaffMemberInvitation>;
  staffMembers: Array<StaffMember>;
  /** Custom scope handling for current user */
  stayExtensionOrder: StayExtensionOrderRequest;
  supplementBundleByAsset?: Maybe<SupplementBundleType>;
  /** Supplements */
  supplementBundles: Array<SupplementBundleType>;
  supportChat?: Maybe<SupportChat>;
  textSearchIndex: TextSearchIndex;
  travelAgent?: Maybe<TravelAgent>;
  travelAgentBusinessOwnerInvitation: TravelAgentBusinessOwnerInvitation;
  travelAgentByStaffMember?: Maybe<TravelAgent>;
  travelAgentStaff?: Maybe<Staff>;
  trip: Trip;
  trips: Array<Trip>;
  userExists?: Maybe<UserIdentifier>;
  verifyPromotionalCode?: Maybe<VerifiedPromotionalCode>;
  /** Search, booking and checkout */
  visibilityConstraint: VisibilityConstraint;
  /** Get white label configuration for a reseller */
  whiteLabel?: Maybe<WhiteLabel>;
  /** Get white label configuration by subdomain */
  whiteLabelBySubdomain?: Maybe<WhiteLabel>;
  /** (scope: "write:wishlist") needs custom handling */
  wishlist?: Maybe<Wishlist>;
  wishlists?: Maybe<Array<Maybe<Wishlist>>>;
};


/** Queries */
export type QueryAirportsArgs = {
  location?: Maybe<InputGeoLocation>;
};


/** Queries */
export type QueryAmenityBundleByAssetArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryAssetOnboardingStatusArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryAssetOwnerInvitationSummaryArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryAvailabilityCalendarArgs = {
  input: ListingAvailabilityCriteria;
};


/** Queries */
export type QueryBookingArgs = {
  bookingId: Scalars['ID'];
};


/** Queries */
export type QueryBookingFeesArgs = {
  bookingId: Scalars['ID'];
};


/** Queries */
export type QueryBrandBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryBrandByAssignedAssetArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryBrandStaffArgs = {
  brandId: Scalars['ID'];
};


/** Queries */
export type QueryBusinessCustomerArgs = {
  businessId: Scalars['ID'];
  userId: Scalars['String'];
};


/** Queries */
export type QueryCheckSubdomainAvailabilityArgs = {
  subdomain: Scalars['String'];
};


/** Queries */
export type QueryClienteleArgs = {
  clienteleId: Scalars['ID'];
};


/** Queries */
export type QueryClienteleByBusinessIdArgs = {
  businessId: Scalars['ID'];
};


/** Queries */
export type QueryCommissionArgs = {
  adjustedPrice?: Maybe<CurrencyAmount>;
  listingId: Scalars['ID'];
  originalPrice?: Maybe<CurrencyAmount>;
};


/** Queries */
export type QueryConnectedSocialAccountArgs = {
  provider: Scalars['String'];
};


/** Queries */
export type QueryConversationTokenArgs = {
  conversationId: Scalars['ID'];
  device: Scalars['String'];
};


/** Queries */
export type QueryExchangeAuthCodeArgs = {
  code: Scalars['String'];
};


/** Queries */
export type QueryExportUrlArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryFavouriteArgs = {
  favouriteType?: Maybe<FavouriteType>;
  referenceId: Scalars['String'];
};


/** Queries */
export type QueryFeaturedListingsArgs = {
  featuredListingCode?: Maybe<Scalars['String']>;
};


/** Queries */
export type QueryFeesCalendarArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryHostingTeamArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryHostingTeamByListingArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryHotelArgs = {
  hotelId: Scalars['ID'];
};


/** Queries */
export type QueryHotelListingArgs = {
  hotelId: Scalars['ID'];
};


/** Queries */
export type QueryHotelStaffArgs = {
  hotelId: Scalars['ID'];
};


/** Queries */
export type QueryInvitationStatusArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryLinkedCalendarsArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryListingArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryListingByTravelDetailsArgs = {
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
  guestCounts: Array<GuestCount>;
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryListingDefinitionArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryListingIdArgs = {
  propertyOrHotelRoomId: Scalars['ID'];
};


/** Queries */
export type QueryListingOnboardingStatusArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryListingOnboardingStatusesArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryListingsByMemberArgs = {
  memberId: Scalars['ID'];
};


/** Queries */
export type QueryManagedListingsArgs = {
  memberId: Scalars['ID'];
  page: RequestedPage;
};


/** Queries */
export type QueryMessageThreadArgs = {
  subjectId: Scalars['ID'];
  subjectType: SubjectType;
};


/** Queries */
export type QueryMinimumRequiredAvailabilityArgs = {
  listingId: Scalars['ID'];
};


/** Queries */
export type QueryMyGuestArgs = {
  bookingId: Scalars['ID'];
};


/** Queries */
export type QueryOtherNestsArgs = {
  input?: Maybe<Criteria>;
};


/** Queries */
export type QueryPmcBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryPmcStaffArgs = {
  pmcId: Scalars['ID'];
};


/** Queries */
export type QueryPropertiesArgs = {
  limit: Scalars['Int'];
  skip: Scalars['Int'];
};


/** Queries */
export type QueryPropertyArgs = {
  propertyId: Scalars['ID'];
};


/** Queries */
export type QueryPropertyOwnerInvitationSummaryArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryPublicBookingArgs = {
  bookingId: Scalars['ID'];
};


/** Queries */
export type QueryPublicWishlistArgs = {
  wishlistId: Scalars['ID'];
};


/** Queries */
export type QueryRescheduleBookingOrderArgs = {
  orderId: Scalars['ID'];
};


/** Queries */
export type QueryResellerByBookingIdArgs = {
  bookingId: Scalars['ID'];
};


/** Queries */
export type QueryResellerByBusinessIdArgs = {
  businessId: Scalars['ID'];
};


/** Queries */
export type QueryResourceScopesArgs = {
  resourceId: Scalars['ID'];
};


/** Queries */
export type QuerySearchListingsArgs = {
  input?: Maybe<Criteria>;
};


/** Queries */
export type QuerySearchMembersArgs = {
  email?: Maybe<Scalars['String']>;
};


/** Queries */
export type QuerySearchOptionsArgs = {
  availabilityTypes: Array<Maybe<AvailabilityType>>;
  includeComingSoon: Scalars['Boolean'];
};


/** Queries */
export type QueryStaffMemberInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryStaffMemberInvitationSummaryArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryStaffMemberInvitationsArgs = {
  staffId: Scalars['ID'];
};


/** Queries */
export type QueryStaffMembersArgs = {
  staffId: Scalars['ID'];
};


/** Queries */
export type QueryStayExtensionOrderArgs = {
  orderId: Scalars['ID'];
};


/** Queries */
export type QuerySupplementBundleByAssetArgs = {
  assetId: Scalars['ID'];
};


/** Queries */
export type QueryTravelAgentArgs = {
  travelAgentId: Scalars['ID'];
};


/** Queries */
export type QueryTravelAgentBusinessOwnerInvitationArgs = {
  invitationId: Scalars['ID'];
};


/** Queries */
export type QueryTravelAgentByStaffMemberArgs = {
  staffMemberId: Scalars['ID'];
};


/** Queries */
export type QueryTravelAgentStaffArgs = {
  travelAgentId: Scalars['ID'];
};


/** Queries */
export type QueryTripArgs = {
  tripId: Scalars['ID'];
};


/** Queries */
export type QueryUserExistsArgs = {
  email?: Maybe<Scalars['String']>;
};


/** Queries */
export type QueryVerifyPromotionalCodeArgs = {
  promotionalCode: Scalars['String'];
};


/** Queries */
export type QueryWhiteLabelArgs = {
  resellerId: Scalars['ID'];
};


/** Queries */
export type QueryWhiteLabelBySubdomainArgs = {
  subdomain: Scalars['String'];
};


/** Queries */
export type QueryWishlistArgs = {
  wishlistId: Scalars['ID'];
};

export type RecordListingVisit = {
  checkin?: Maybe<Scalars['LocalDate']>;
  checkout?: Maybe<Scalars['LocalDate']>;
  listingId: Scalars['ID'];
  pageNumber?: Maybe<Scalars['Int']>;
  pageRank?: Maybe<Scalars['Int']>;
  searchId?: Maybe<Scalars['String']>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type Redirects = {
  cancelUrl: Scalars['String'];
  successUrl: Scalars['String'];
};

export type ReferMemberCommand = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type RegionCriterion = {
  regionId: Scalars['String'];
  subRegionId?: Maybe<Scalars['String']>;
};

export type RemoveFromFavouritesCommand = {
  referenceId: Scalars['String'];
  type: FavouriteType;
};

export type RemoveMemberFromStaffCommand = {
  staffId: Scalars['ID'];
  userId: Scalars['String'];
};

export type RemoveWishFromWishlistCommand = {
  wishId: Scalars['String'];
  wishlistId: Scalars['ID'];
};

export type RequestedPage = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: Maybe<Scalars['String']>;
};

export type RescheduleBookingOrderRequest = {
  __typename?: 'RescheduleBookingOrderRequest';
  bookingId: Scalars['String'];
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
  feesDue?: Maybe<Fees>;
};

export type Reseller = {
  __typename?: 'Reseller';
  associatedBookings: Array<AssociatedBooking>;
  businessId: Scalars['String'];
  name: Scalars['String'];
  resellerId: Scalars['ID'];
  verified: Scalars['Boolean'];
  verifiedBy?: Maybe<User>;
};

export enum Role {
  Admin = 'admin',
  Applicant = 'applicant',
  BrandAgent = 'brand_agent',
  BrandBusinessOwner = 'brand_business_owner',
  Consumer = 'consumer',
  Earner = 'earner',
  Owner = 'owner',
  PmcAgent = 'pmc_agent',
  PmcBusinessOwner = 'pmc_business_owner',
  Staffmember = 'staffmember',
  TravelAgent = 'travel_agent',
  TravelAgentBusinessOwner = 'travel_agent_business_owner',
  Traveller = 'traveller',
  User = 'user'
}

export type RoleInvitation = {
  __typename?: 'RoleInvitation';
  acceptedOn?: Maybe<Scalars['OffsetDateTime']>;
  assetId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role: Role;
  userExistsOnIdentityProvider?: Maybe<Scalars['Boolean']>;
};

export type RoomsAndBedsCriterion = {
  bathrooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  beds?: Maybe<Scalars['Int']>;
};

export enum ScreenSize {
  Large = 'large'
}

export type SearchGroupedRegions = {
  __typename?: 'SearchGroupedRegions';
  groupName: Scalars['String'];
  regions: Array<SearchRegion>;
};

export type SearchListing = {
  __typename?: 'SearchListing';
  asset: Asset;
  availabilityType?: Maybe<AvailabilityType>;
  /**
   * Indicates what's the earliest available
   * date that this listing can be booked for
   * a duration of at least 3 days.
   */
  availableFrom?: Maybe<DateRange>;
  /** Commission that a reseller (like travel agents) can earn */
  commission?: Maybe<Commission>;
  fees?: Maybe<Fees>;
  /**
   * If payments are to happen in installments, this will
   * be provided. If payment required in full, this will be null.
   */
  installmentSchedule?: Maybe<InstallmentSchedule>;
  listingId: Scalars['ID'];
  obfuscatedLocation: ObfuscatedLocation;
  /** The operator of this listing. Typically a hotel brand. */
  operator?: Maybe<Operator>;
  /**
   * Indicates the lowest and highest possible fees
   * for an asset
   */
  priceRange?: Maybe<PriceRange>;
  status: SearchListingStatus;
  summary: ListingSummary;
};

export enum SearchListingStatus {
  Available = 'available',
  AvailableOtherDates = 'available_other_dates',
  ComingSoon = 'coming_soon'
}

export type SearchOptions = {
  __typename?: 'SearchOptions';
  groupedRegions: Array<SearchGroupedRegions>;
};

export type SearchRegion = {
  __typename?: 'SearchRegion';
  boundingBox?: Maybe<BoundingBox>;
  name: Scalars['String'];
  parentRegionId?: Maybe<Scalars['ID']>;
  regionId: Scalars['ID'];
};

export type SearchResultPaging = {
  __typename?: 'SearchResultPaging';
  offset: Scalars['Int'];
  pageNumber: Scalars['Int'];
  size: Scalars['Int'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  count: Scalars['Int'];
  paging: SearchResultPaging;
  results: Array<SearchListing>;
  searchId: Scalars['ID'];
};

export type SeasonalMinimum = {
  __typename?: 'SeasonalMinimum';
  minimumDays: Scalars['Int'];
  seasonality: Seasonality;
};

export enum Seasonality {
  OffPeak = 'off_peak',
  Peak = 'peak',
  Shoulder = 'shoulder',
  SuperPeak = 'super_peak'
}

export type SendConversationMessageRequest = {
  conversationId: Scalars['ID'];
  conversationToken: ConversationToken;
  returnUrl: Scalars['String'];
  text: Scalars['String'];
};

export type SignupConsumerRequest = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  userId: Scalars['String'];
};

export type SignupHotelRequest = {
  context: TrackingContext;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: PhoneNumber;
  propertyDescription: Scalars['String'];
  website: Scalars['String'];
};

export type SignupTravelAgentRequest = {
  annualBookingRevenue?: Maybe<AnnualBookingRevenue>;
  buyerType: Scalars['String'];
  /** Mandatory if buyer type is "Travel Agent" */
  companyName?: Maybe<Scalars['String']>;
  consortiumMembershipNumber?: Maybe<Scalars['String']>;
  consortiumName?: Maybe<Scalars['String']>;
  context: TrackingContext;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: PhoneNumber;
};

export type SocialReferenceType = {
  __typename?: 'SocialReferenceType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  publicProfilePicture?: Maybe<Scalars['String']>;
  publicProfileUrl?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
};

export type Staff = {
  __typename?: 'Staff';
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber?: Maybe<PhoneNumberType>;
  photoUrl?: Maybe<Scalars['String']>;
  staffId: Scalars['ID'];
};

export type StaffMember = {
  __typename?: 'StaffMember';
  /**
   * Indicates if this member is the boss of this
   * staff, e.g. a Hotel owner in case of a reception,
   * a PMC's business owner, or a member/owner
   * himself in case of Personal Staff
   */
  boss: Scalars['Boolean'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  host: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  /**
   * Set to true if this member has management privileges on the assets
   * he/she is responsible for. Management privileges typically include
   * approving bookings and adjusting availability.
   */
  manager: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type StaffMemberInvitation = {
  __typename?: 'StaffMemberInvitation';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['Boolean']>;
  invitationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['Boolean']>;
  staffId: Scalars['ID'];
  status: StaffMemberInvitationStatus;
  /** updateDate will be set when status is initially set or updated */
  updateDate: Scalars['LocalDate'];
};

export enum StaffMemberInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type StaffMemberInvitationSummary = {
  __typename?: 'StaffMemberInvitationSummary';
  invitationId: Scalars['String'];
  staffId: Scalars['ID'];
  status: StaffMemberInvitationStatus;
};

export type StaffPhotoSignUrlRequest = {
  filename: Scalars['String'];
  staffId: Scalars['String'];
};

export type StartPropertyOnboardingCommand = {
  name: Scalars['String'];
  propertyId: Scalars['ID'];
};

export type StayDurationConditions = {
  __typename?: 'StayDurationConditions';
  minimum: Scalars['Int'];
};

export type StayExtensionOrderRequest = {
  __typename?: 'StayExtensionOrderRequest';
  bookingId: Scalars['String'];
  checkout: Scalars['LocalDate'];
  feesDue?: Maybe<Fees>;
};

export type StyleCriterion = {
  propertyStyles?: Maybe<Array<Maybe<PropertyStyle>>>;
};

/** Response type for subdomain availability check */
export type SubdomainAvailability = {
  __typename?: 'SubdomainAvailability';
  /** Whether the subdomain is available (true) or taken (false) */
  available: Scalars['Boolean'];
};

export type Subject = {
  __typename?: 'Subject';
  subjectId: Scalars['ID'];
  subjectType: SubjectType;
};

export enum SubjectType {
  Booking = 'booking'
}

export type SubmitMemberApplicationCommand = {
  address: Address;
  applicationType: MemberApplicationType;
  approximateValue: CurrencyAmount;
  assetId: Scalars['String'];
  bathrooms: Scalars['Int'];
  bedrooms: Scalars['Int'];
  calendarReference?: Maybe<CalendarReference>;
  email: Scalars['String'];
  externalListingUrl?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  memberId: Scalars['String'];
  phoneNumber: PhoneNumber;
  propertyName: Scalars['String'];
  propertyType: PropertyType;
  sleeps: Scalars['Int'];
  termsAndConditionsAccepted: Scalars['Boolean'];
  welcomeReturnUrl: Scalars['String'];
};

export type SupplementBundleSectionType = {
  __typename?: 'SupplementBundleSectionType';
  name: Scalars['String'];
  sectionId: Scalars['ID'];
  supplementIds: Array<Scalars['String']>;
  supplements: Array<SupplementType>;
};

export type SupplementBundleType = {
  __typename?: 'SupplementBundleType';
  bundleId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  sections: Array<SupplementBundleSectionType>;
};

export type SupplementType = {
  __typename?: 'SupplementType';
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  iconName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price: CurrencyAmountType;
  supplementId: Scalars['ID'];
  usageCount: UsageCount;
};

export type SupportChat = {
  __typename?: 'SupportChat';
  identificationEmail?: Maybe<Scalars['String']>;
  identificationToken?: Maybe<Scalars['String']>;
};

export type TextSearchDestination = {
  __typename?: 'TextSearchDestination';
  boundingBox: BoundingBox;
  name: Scalars['String'];
};

export type TextSearchIndex = {
  __typename?: 'TextSearchIndex';
  destinations: Array<TextSearchDestination>;
  listings: Array<TextSearchListing>;
};

export type TextSearchListing = {
  __typename?: 'TextSearchListing';
  listingId: Scalars['ID'];
  locationName: Scalars['String'];
  name: Scalars['String'];
  nonDisplayFields?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
};

export type TrackingContext = {
  pageName?: Maybe<Scalars['String']>;
  /** For Hubspot the hutk cookie */
  pageUri?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type TravelAgent = {
  __typename?: 'TravelAgent';
  name: Scalars['String'];
  travelAgentId: Scalars['ID'];
};

export type TravelAgentBusinessOwnerInvitation = {
  __typename?: 'TravelAgentBusinessOwnerInvitation';
  businessOwnerId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  invitationId: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  status: TravelAgentBusinessOwnerInvitationStatus;
  /** updateDate will be set when status is initially set or updated */
  updateDate: Scalars['OffsetDateTime'];
};

export enum TravelAgentBusinessOwnerInvitationStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Invited = 'invited'
}

export type TravelDatesInput = {
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
};

export type TravelDatesType = {
  __typename?: 'TravelDatesType';
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
};

export type Trip = {
  __typename?: 'Trip';
  bookings: Array<Maybe<Booking>>;
  tripId: Scalars['ID'];
};

export type TripSummary = {
  __typename?: 'TripSummary';
  imageUrl: Scalars['String'];
  location: Location;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type UnblockAvailabilityCommand = {
  listingId: Scalars['ID'];
  unblockedDays?: Maybe<Array<Maybe<Scalars['LocalDate']>>>;
};

export type UnlinkExternalCalendarCommand = {
  externalUrl: Scalars['String'];
  listingId: Scalars['ID'];
};

export type UpdateBankAccountCommand = {
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<BankAccountType>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  transitNumber?: Maybe<Scalars['String']>;
};

export type UpdateBookingSettingsCommand = {
  allowInstantBook: Scalars['Boolean'];
  listingId: Scalars['ID'];
};

export type UpdateHotelAmenitiesCommand = {
  amenityIds?: Maybe<Array<Scalars['String']>>;
  hotelId: Scalars['ID'];
};

export type UpdateHotelGeneralCommand = {
  averageDailyRate: CurrencyAmount;
  description?: Maybe<Scalars['String']>;
  externalListingUrl?: Maybe<Scalars['String']>;
  hotelId: Scalars['ID'];
  name: Scalars['String'];
  stars: Scalars['Int'];
  website: Scalars['String'];
};

export type UpdateHotelGoodToKnowCommand = {
  description: Scalars['String'];
  hotelId: Scalars['ID'];
};

export type UpdateHotelHouseRulesCommand = {
  allowsChildren: Scalars['Boolean'];
  earliestCheckin: Scalars['LocalTime'];
  hotelId: Scalars['ID'];
  latestCheckin: Scalars['LocalTime'];
  maximumStay: Scalars['Int'];
  minimumStay: Scalars['Int'];
};

export type UpdateHotelLocationCommand = {
  additionalInstructions?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  hotelId: Scalars['ID'];
  lat?: Maybe<Scalars['Float']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type UpdateHotelPhotosCommand = {
  hotelId: Scalars['ID'];
  photos?: Maybe<Array<AssetPhoto>>;
};

export type UpdateHotelRoomCommand = {
  description?: Maybe<Scalars['String']>;
  hotelId: Scalars['ID'];
  hotelRoomId: Scalars['String'];
  maximumOccupancy: Scalars['Int'];
  roomType: Scalars['String'];
};

export type UpdateHotelRoomPhotosCommand = {
  hotelId: Scalars['ID'];
  hotelRoomId: Scalars['String'];
  photos?: Maybe<Array<AssetPhoto>>;
};

export type UpdateListingCleaningServiceCommand = {
  listingId: Scalars['ID'];
  paymentMode?: Maybe<PaymentMode>;
  perDayCleaningFee?: Maybe<CleaningFeeInput>;
  perStayCleaningFee?: Maybe<CleaningFeeInput>;
};

export type UpdateListingSupplementsCommand = {
  listingId: Scalars['ID'];
  mandatorySupplements: Array<ListingSupplement>;
  optionalSupplements: Array<ListingSupplement>;
};

export type UpdatePersonalAddressCommand = {
  city?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  lat: Scalars['Float'];
  line1?: Maybe<Scalars['String']>;
  lng: Scalars['Float'];
  postalCode?: Maybe<Scalars['String']>;
};

export type UpdatePersonalInformationCommand = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber: PhoneNumber;
};

export type UpdatePersonalPhoneNumberCommand = {
  phoneNumber: PhoneNumber;
};

export type UpdatePersonalPhotoCommand = {
  photoUrl: Scalars['String'];
};

export type UpdatePropertyAmenitiesCommand = {
  amenityIds?: Maybe<Array<Scalars['String']>>;
  propertyId: Scalars['ID'];
};

export type UpdatePropertyGeneralCommand = {
  approximateValue?: Maybe<CurrencyAmount>;
  bathrooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Array<Maybe<Bedroom>>>;
  description?: Maybe<Scalars['String']>;
  externalListingUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  propertyStyle?: Maybe<PropertyStyle>;
  propertyType?: Maybe<PropertyType>;
  sleeps?: Maybe<Scalars['Int']>;
};

export type UpdatePropertyGoodToKnowCommand = {
  description: Scalars['String'];
  propertyId: Scalars['ID'];
};

export type UpdatePropertyHouseRulesCommand = {
  allowsChildren: Scalars['Boolean'];
  allowsEvents: Scalars['Boolean'];
  allowsInfants: Scalars['Boolean'];
  allowsPets: Scalars['Boolean'];
  allowsSmoking: Scalars['Boolean'];
  propertyId: Scalars['ID'];
};

export type UpdatePropertyLocationCommand = {
  additionalInstructions?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  region?: Maybe<Scalars['String']>;
};

export type UpdatePropertyPhotosCommand = {
  photos?: Maybe<Array<AssetPhoto>>;
  propertyId: Scalars['ID'];
};

export type UpdateStaffCommand = {
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: PhoneNumber;
  photoUrl: Scalars['String'];
  staffId: Scalars['ID'];
};

export type UpdateWishlistCommand = {
  /** Convenient name for the Travel Agent to distinguish between wishlists */
  name: Scalars['String'];
  /** The person the wishlist is for, or null if it's for the creator */
  onBehalfOf?: Maybe<Scalars['String']>;
  wishlistId: Scalars['ID'];
};

export type UsageCount = {
  __typename?: 'UsageCount';
  mandatoryUsageCount: Scalars['Int'];
  optionalUsageCount: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserIdentifier = {
  __typename?: 'UserIdentifier';
  userId: Scalars['ID'];
};

export type VerifiedPromotionalCode = {
  __typename?: 'VerifiedPromotionalCode';
  promotionalCodeId: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type VisibilityConstraint = {
  __typename?: 'VisibilityConstraint';
  canSeeExchangeProperties: Scalars['Boolean'];
  canSeeHotels: Scalars['Boolean'];
  canSeeRentalProperties: Scalars['Boolean'];
};

/** White label configuration for a reseller */
export type WhiteLabel = {
  __typename?: 'WhiteLabel';
  /** Body text font family */
  bodyFont?: Maybe<Scalars['String']>;
  /** Business ID associated with this white label config */
  businessId: Scalars['ID'];
  /** Favicon URL */
  faviconUrl?: Maybe<Scalars['String']>;
  /** Header background color in hex format */
  headerColor?: Maybe<Scalars['String']>;
  /** Heading font family */
  headingFont?: Maybe<Scalars['String']>;
  /** Landscape/rectangle format logo URL */
  landscapeLogoUrl?: Maybe<Scalars['String']>;
  /** Primary brand color in hex format */
  primaryColor: Scalars['String'];
  /** Primary green accent color in hex format */
  primaryGreen?: Maybe<Scalars['String']>;
  /** Quaternary brand color (Sand) in hex format */
  quaternaryColor?: Maybe<Scalars['String']>;
  /** ID of the reseller this white label config belongs to */
  resellerId: Scalars['ID'];
  /** Secondary brand color (Wine) in hex format */
  secondaryColor?: Maybe<Scalars['String']>;
  /** Square format logo URL */
  squareLogoUrl?: Maybe<Scalars['String']>;
  /** Custom subdomain prefix for the white-label site */
  subdomain: Scalars['String'];
  /** Tertiary brand color (Terracotta) in hex format */
  tertiaryColor?: Maybe<Scalars['String']>;
};

/** Request input for generating a white label logo upload URL */
export type WhiteLabelLogoSignUrlRequest = {
  /** Original filename of the logo being uploaded */
  filename: Scalars['String'];
  /** ID of the reseller this logo belongs to */
  resellerId: Scalars['ID'];
};

export type Wish = {
  __typename?: 'Wish';
  guestCounts?: Maybe<Array<GuestCountType>>;
  notes?: Maybe<Scalars['String']>;
  priceModification?: Maybe<PriceModificationType>;
  searchListing: SearchListing;
  travelDates?: Maybe<TravelDatesType>;
  wishId: Scalars['ID'];
};

export type Wishlist = {
  __typename?: 'Wishlist';
  name: Scalars['String'];
  status: WishlistStatus;
  /** Creator of the wishlist */
  userId: Scalars['String'];
  wishes: Array<Wish>;
  wishlistId: Scalars['ID'];
};

export enum WishlistStatus {
  Active = 'active',
  Expired = 'expired'
}


export type PresentmentCurrencyExchangeRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type PresentmentCurrencyExchangeRatesQuery = (
  { __typename?: 'Query' }
  & { presentmentCurrencyExchangeRates: Array<(
    { __typename?: 'ExchangeRateEntry' }
    & Pick<ExchangeRateEntry, 'currency' | 'rate'>
  )> }
);

export type InvitationServiceInvitationStatusQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceInvitationStatusQuery = (
  { __typename?: 'Query' }
  & { invitationStatus?: Maybe<(
    { __typename?: 'RoleInvitation' }
    & Pick<RoleInvitation, 'acceptedOn' | 'role' | 'assetId' | 'email' | 'firstName' | 'lastName' | 'userExistsOnIdentityProvider'>
  )> }
);

export type InvitationServiceAssetOwnerInvitationSummaryQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceAssetOwnerInvitationSummaryQuery = (
  { __typename?: 'Query' }
  & { assetOwnerInvitationSummary?: Maybe<(
    { __typename?: 'AssetOwnerInvitationSummary' }
    & Pick<AssetOwnerInvitationSummary, 'invitationId' | 'assetId' | 'status'>
  )> }
);

export type InvitationServiceBrandBusinessOwnerInvitationStatusQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceBrandBusinessOwnerInvitationStatusQuery = (
  { __typename?: 'Query' }
  & { brandBusinessOwnerInvitation: (
    { __typename?: 'BrandBusinessOwnerInvitation' }
    & Pick<BrandBusinessOwnerInvitation, 'status'>
  ) }
);

export type InvitationServicePmcBusinessOwnerInvitationStatusQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServicePmcBusinessOwnerInvitationStatusQuery = (
  { __typename?: 'Query' }
  & { pmcBusinessOwnerInvitation: (
    { __typename?: 'PmcBusinessOwnerInvitation' }
    & Pick<PmcBusinessOwnerInvitation, 'status'>
  ) }
);

export type InvitationServiceStaffMemberInvitationSummaryQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceStaffMemberInvitationSummaryQuery = (
  { __typename?: 'Query' }
  & { staffMemberInvitationSummary?: Maybe<(
    { __typename?: 'StaffMemberInvitationSummary' }
    & Pick<StaffMemberInvitationSummary, 'invitationId' | 'staffId' | 'status'>
  )> }
);

export type InvitationServiceTravelAgentBusinessOwnerInvitationStatusQueryVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceTravelAgentBusinessOwnerInvitationStatusQuery = (
  { __typename?: 'Query' }
  & { travelAgentBusinessOwnerInvitation: (
    { __typename?: 'TravelAgentBusinessOwnerInvitation' }
    & Pick<TravelAgentBusinessOwnerInvitation, 'status'>
  ) }
);

export type InvitationServiceAcceptAssetOwnerInvitationMutationVariables = Exact<{
  input: AcceptAssetOwnerInvitationCommand;
}>;


export type InvitationServiceAcceptAssetOwnerInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptAssetOwnerInvitation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceAcceptBrandBusinessOwnerInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceAcceptBrandBusinessOwnerInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptBrandBusinessOwnerInvitation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceAcceptPmcBusinessOwnerInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceAcceptPmcBusinessOwnerInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptPmcBusinessOwnerInvitation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceAcceptStaffMemberInvitationMutationVariables = Exact<{
  input: AcceptStaffMemberInvitationCommand;
}>;


export type InvitationServiceAcceptStaffMemberInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptStaffMemberInvitation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceAcceptTravelAgentBusinessOwnerInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID'];
}>;


export type InvitationServiceAcceptTravelAgentBusinessOwnerInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptTravelAgentBusinessOwnerInvitation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceUpdatePhoneMutationVariables = Exact<{
  input: UpdatePersonalPhoneNumberCommand;
}>;


export type InvitationServiceUpdatePhoneMutation = (
  { __typename?: 'Mutation' }
  & { updatePersonalPhoneNumber: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InvitationServiceAcceptTermsMutationVariables = Exact<{
  input: AcceptConsumerTermsAndConditionsCommand;
}>;


export type InvitationServiceAcceptTermsMutation = (
  { __typename?: 'Mutation' }
  & { acceptConsumerTermsAndConditions: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type TextSearchIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type TextSearchIndexQuery = (
  { __typename?: 'Query' }
  & { textSearchIndex: (
    { __typename?: 'TextSearchIndex' }
    & { listings: Array<(
      { __typename?: 'TextSearchListing' }
      & Pick<TextSearchListing, 'name' | 'listingId' | 'locationName' | 'operatorName' | 'nonDisplayFields'>
    )>, destinations: Array<(
      { __typename?: 'TextSearchDestination' }
      & Pick<TextSearchDestination, 'name'>
      & { boundingBox: (
        { __typename?: 'BoundingBox' }
        & Pick<BoundingBox, 'swLat' | 'swLng' | 'neLat' | 'neLng'>
      ) }
    )> }
  ) }
);

export type RoleManagerAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleManagerAccountQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId' | 'accountHolderId'>
    & { personalProfile: (
      { __typename?: 'PersonalProfile' }
      & Pick<PersonalProfile, 'email' | 'firstName' | 'lastName' | 'photoUrl'>
    ) }
  )> }
);

export type RoleManagerRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleManagerRolesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'roles'>
);

export type RoleManagerMemberOnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleManagerMemberOnboardingStatusQuery = (
  { __typename?: 'Query' }
  & { memberOnboardingStatus: (
    { __typename?: 'MemberOnboardingStatus' }
    & Pick<MemberOnboardingStatus, 'completed'>
    & { assetBeingOnboarded: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
    ) }
  ) }
);

export type ScopeManagerScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScopeManagerScopesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'scopes'>
);

export type ScopeManagerResourceScopesQueryVariables = Exact<{
  resourceId: Scalars['ID'];
}>;


export type ScopeManagerResourceScopesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'resourceScopes'>
);

export type SupportChatQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportChatQuery = (
  { __typename?: 'Query' }
  & { supportChat?: Maybe<(
    { __typename?: 'SupportChat' }
    & Pick<SupportChat, 'identificationToken' | 'identificationEmail'>
  )> }
);

export type TravelAgentByStaffMemberQueryVariables = Exact<{
  staffMemberId: Scalars['ID'];
}>;


export type TravelAgentByStaffMemberQuery = (
  { __typename?: 'Query' }
  & { travelAgentByStaffMember?: Maybe<(
    { __typename?: 'TravelAgent' }
    & Pick<TravelAgent, 'travelAgentId' | 'name'>
  )> }
);

export type TravelAgentClienteleByBusinessIdQueryVariables = Exact<{
  businessId: Scalars['ID'];
}>;


export type TravelAgentClienteleByBusinessIdQuery = (
  { __typename?: 'Query' }
  & { clienteleByBusinessId: (
    { __typename?: 'Clientele' }
    & Pick<Clientele, 'clienteleId' | 'businessId'>
    & { customers: Array<(
      { __typename?: 'BusinessCustomer' }
      & Pick<BusinessCustomer, 'userId' | 'firstName' | 'lastName' | 'email' | 'photoUrl'>
      & { phoneNumber: (
        { __typename?: 'PhoneNumberType' }
        & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
      ) }
    )> }
  ) }
);

export type TravelAgentResellerByBusinessIdQueryVariables = Exact<{
  businessId: Scalars['ID'];
}>;


export type TravelAgentResellerByBusinessIdQuery = (
  { __typename?: 'Query' }
  & { resellerByBusinessId?: Maybe<(
    { __typename?: 'Reseller' }
    & Pick<Reseller, 'resellerId' | 'businessId' | 'name'>
  )> }
);

export type AcceptBookingMutationVariables = Exact<{
  input: AcceptBookingRequest;
}>;


export type AcceptBookingMutation = (
  { __typename?: 'Mutation' }
  & { acceptBooking: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type AcceptBookingBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type AcceptBookingBookingQuery = (
  { __typename?: 'Query' }
  & { booking: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'status'>
  ) }
);

export type BusinessCustomerAutocompleteAddBusinessCustomerToClienteleMutationVariables = Exact<{
  input: AddBusinessCustomerToClienteleCommand;
}>;


export type BusinessCustomerAutocompleteAddBusinessCustomerToClienteleMutation = (
  { __typename?: 'Mutation' }
  & { addBusinessCustomerToClientele: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type BusinessCustomerUserExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type BusinessCustomerUserExistsQuery = (
  { __typename?: 'Query' }
  & { userExists?: Maybe<(
    { __typename?: 'UserIdentifier' }
    & Pick<UserIdentifier, 'userId'>
  )> }
);

export type CreateBusinessCustomerMutationVariables = Exact<{
  input: CreateBusinessCustomerRequest;
}>;


export type CreateBusinessCustomerMutation = (
  { __typename?: 'Mutation' }
  & { createBusinessCustomer: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CalendarListingAllocateDailyAvailabilityMutationVariables = Exact<{
  input: AllocateDailyAvailabilityCommand;
}>;


export type CalendarListingAllocateDailyAvailabilityMutation = (
  { __typename?: 'Mutation' }
  & { allocateDailyAvailability: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CalendarListingAllocateMonthlyAvailabilityMutationVariables = Exact<{
  input: AllocateMonthlyAvailabilityCommand;
}>;


export type CalendarListingAllocateMonthlyAvailabilityMutation = (
  { __typename?: 'Mutation' }
  & { allocateMonthlyAvailability: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CalendarListingAllocateInitialMonthlyAvailabilityMutationVariables = Exact<{
  input: AllocateInitialMonthlyAvailabilityRequest;
}>;


export type CalendarListingAllocateInitialMonthlyAvailabilityMutation = (
  { __typename?: 'Mutation' }
  & { allocateInitialMonthlyAvailability: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CalendarListingMinimumRequiredAvailabilityQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type CalendarListingMinimumRequiredAvailabilityQuery = (
  { __typename?: 'Query' }
  & { minimumRequiredAvailability?: Maybe<(
    { __typename?: 'MinimumRequiredAvailability' }
    & { required: Array<(
      { __typename?: 'SeasonalMinimum' }
      & Pick<SeasonalMinimum, 'minimumDays' | 'seasonality'>
    )> }
  )> }
);

export type DepositCalendarListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type DepositCalendarListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'listingId' | 'status'>
    & { availabilityCalendar: (
      { __typename?: 'AvailabilityCalendar' }
      & { dailyAllocations: Array<Maybe<(
        { __typename?: 'DailyAllocationType' }
        & Pick<DailyAllocationType, 'allocated' | 'consumed' | 'day'>
      )>> }
    ) }
  ) }
);

export type DepositCalendarLinkedCalendarsQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type DepositCalendarLinkedCalendarsQuery = (
  { __typename?: 'Query' }
  & { linkedCalendars: Array<Maybe<(
    { __typename?: 'LinkedCalendar' }
    & Pick<LinkedCalendar, 'externalUrl' | 'name'>
  )>> }
);

export type LinkExternalCalendarMutationVariables = Exact<{
  input: LinkExternalCalendarCommand;
}>;


export type LinkExternalCalendarMutation = (
  { __typename?: 'Mutation' }
  & { linkExternalCalendar: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type LinkedCalendarsQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type LinkedCalendarsQuery = (
  { __typename?: 'Query' }
  & { linkedCalendars: Array<Maybe<(
    { __typename?: 'LinkedCalendar' }
    & Pick<LinkedCalendar, 'externalUrl' | 'name'>
  )>> }
);

export type LinkCalendarsUnlinkExternalCalendarMutationVariables = Exact<{
  input: UnlinkExternalCalendarCommand;
}>;


export type LinkCalendarsUnlinkExternalCalendarMutation = (
  { __typename?: 'Mutation' }
  & { unlinkExternalCalendar: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ListingsWithCleaningByMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type ListingsWithCleaningByMemberQuery = (
  { __typename?: 'Query' }
  & { listingsByMember: Array<(
    { __typename?: 'Listing' }
    & { asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
    ), summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'title'>
    ), operator?: Maybe<(
      { __typename?: 'Operator' }
      & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
    )>, cleaningService: (
      { __typename?: 'CleaningService' }
      & Pick<CleaningService, 'paymentMode' | 'isUpdated'>
      & { perStayCleaningFee?: Maybe<(
        { __typename?: 'CleaningFee' }
        & { amount: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>, perDayCleaningFee?: Maybe<(
        { __typename?: 'CleaningFee' }
        & { amount: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )> }
    ) }
  )> }
);

export type BankAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountDetailsQuery = (
  { __typename?: 'Query' }
  & { bankAccountDetails?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
  )> }
);

export type ConnectFacebookAccountMutationVariables = Exact<{
  input: ConnectSocialMediaAccountCommand;
}>;


export type ConnectFacebookAccountMutation = (
  { __typename?: 'Mutation' }
  & { connectSocialMediaAccount: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConnectFacebookConnectedSocialAccountQueryVariables = Exact<{
  provider: Scalars['String'];
}>;


export type ConnectFacebookConnectedSocialAccountQuery = (
  { __typename?: 'Query' }
  & { connectedSocialAccount?: Maybe<(
    { __typename?: 'SocialReferenceType' }
    & Pick<SocialReferenceType, 'provider'>
  )> }
);

export type ConnectLinkedinAccountMutationVariables = Exact<{
  input: ConnectLinkedinAccountCommand;
}>;


export type ConnectLinkedinAccountMutation = (
  { __typename?: 'Mutation' }
  & { connectLinkedinAccount: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConnectLinkedinConnectedSocialAccountQueryVariables = Exact<{
  provider: Scalars['String'];
}>;


export type ConnectLinkedinConnectedSocialAccountQuery = (
  { __typename?: 'Query' }
  & { connectedSocialAccount?: Maybe<(
    { __typename?: 'SocialReferenceType' }
    & Pick<SocialReferenceType, 'provider'>
  )> }
);

export type DeclineBookingMutationVariables = Exact<{
  input: DeclineBookingRequest;
}>;


export type DeclineBookingMutation = (
  { __typename?: 'Mutation' }
  & { declineBooking: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type DeclineBookingBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type DeclineBookingBookingQuery = (
  { __typename?: 'Query' }
  & { booking: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'status'>
  ) }
);

export type ListingAvailabilityCalendarQueryVariables = Exact<{
  input: ListingAvailabilityCriteria;
}>;


export type ListingAvailabilityCalendarQuery = (
  { __typename?: 'Query' }
  & { availabilityCalendar?: Maybe<(
    { __typename?: 'ListingAvailabilityResults' }
    & Pick<ListingAvailabilityResults, 'lastMonthWithAvailability' | 'firstMonthWithAvailability'>
    & { availabilityCalendar: (
      { __typename?: 'AvailabilityCalendar' }
      & { dailyAllocations: Array<Maybe<(
        { __typename?: 'DailyAllocationType' }
        & Pick<DailyAllocationType, 'allocated' | 'consumed' | 'day'>
      )>> }
    ) }
  )> }
);

export type ListingAvailabilityFeesCalendarQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingAvailabilityFeesCalendarQuery = (
  { __typename?: 'Query' }
  & { feesCalendar?: Maybe<(
    { __typename?: 'FeesCalendar' }
    & { perDayFees: Array<(
      { __typename?: 'PerDayFees' }
      & Pick<PerDayFees, 'day'>
      & { fees: (
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ) }
      ) }
    )> }
  )> }
);

export type ListingHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type ListingHotelQuery = (
  { __typename?: 'Query' }
  & { hotelListing: (
    { __typename?: 'Hotel' }
    & { general?: Maybe<(
      { __typename?: 'HotelGeneral' }
      & Pick<HotelGeneral, 'description' | 'name'>
    )>, goodToKnow?: Maybe<(
      { __typename?: 'HotelGoodToKnow' }
      & Pick<HotelGoodToKnow, 'description'>
    )>, location?: Maybe<(
      { __typename?: 'HotelLocation' }
      & { geoLocation?: Maybe<(
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      )> }
    )>, amenities?: Maybe<(
      { __typename?: 'HotelAmenities' }
      & Pick<HotelAmenities, 'amenityIds'>
    )>, houseRules?: Maybe<(
      { __typename?: 'HotelHouseRules' }
      & Pick<HotelHouseRules, 'allowsChildren' | 'earliestCheckin' | 'latestCheckin' | 'maximumStay' | 'minimumStay'>
    )>, rooms: Array<(
      { __typename?: 'HotelRoom' }
      & Pick<HotelRoom, 'hotelRoomId' | 'roomType' | 'description'>
      & { guestRestrictions: (
        { __typename?: 'GuestRestrictions' }
        & Pick<GuestRestrictions, 'maxOccupancy'>
        & { ageRanges: Array<(
          { __typename?: 'AgeRange' }
          & Pick<AgeRange, 'key' | 'labelPrefix' | 'allowed' | 'maxAge' | 'minAge' | 'maxNumberAllowed' | 'minNumberAllowed'>
        )> }
      ), packageDeal?: Maybe<(
        { __typename?: 'PackageDeal' }
        & Pick<PackageDeal, 'text' | 'helpText' | 'showCurrency'>
      )>, imagery: (
        { __typename?: 'HotelRoomImagery' }
        & { photos?: Maybe<Array<Maybe<(
          { __typename?: 'AssetPhotoType' }
          & Pick<AssetPhotoType, 'url' | 'description' | 'useAsCover' | 'useAsFloorplan'>
        )>>> }
      ) }
    )>, suites: Array<(
      { __typename?: 'HotelSuite' }
      & Pick<HotelSuite, 'hotelSuiteId' | 'suiteType' | 'suiteName' | 'description'>
      & { imagery: (
        { __typename?: 'HotelSuiteImagery' }
        & { photos?: Maybe<Array<Maybe<(
          { __typename?: 'AssetPhotoType' }
          & Pick<AssetPhotoType, 'description' | 'url' | 'useAsCover' | 'useAsFloorplan'>
        )>>> }
      ), guestRestrictions: (
        { __typename?: 'GuestRestrictions' }
        & Pick<GuestRestrictions, 'maxOccupancy'>
        & { ageRanges: Array<(
          { __typename?: 'AgeRange' }
          & Pick<AgeRange, 'key' | 'labelPrefix' | 'allowed' | 'maxAge' | 'minAge' | 'maxNumberAllowed' | 'minNumberAllowed'>
        )> }
      ), packageDeal?: Maybe<(
        { __typename?: 'PackageDeal' }
        & Pick<PackageDeal, 'text' | 'helpText' | 'showCurrency'>
      )>, rooms: (
        { __typename?: 'HotelSuiteRooms' }
        & { bedrooms: Array<Maybe<(
          { __typename?: 'BedroomType' }
          & Pick<BedroomType, 'bedSizes'>
        )>>, areas: Array<Maybe<(
          { __typename?: 'AreaType' }
          & Pick<AreaType, 'areaDefinitionId' | 'size' | 'unit'>
        )>> }
      ) }
    )> }
  ) }
);

export type ListingAmenitiesAmenityBundleByAssetQueryVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type ListingAmenitiesAmenityBundleByAssetQuery = (
  { __typename?: 'Query' }
  & { amenityBundleByAsset?: Maybe<(
    { __typename?: 'AmenityBundleType' }
    & Pick<AmenityBundleType, 'bundleId' | 'name' | 'enabled'>
    & { sections: Array<(
      { __typename?: 'AmenityBundleSectionType' }
      & Pick<AmenityBundleSectionType, 'sectionId' | 'name'>
      & { amenities: Array<(
        { __typename?: 'AmenityType' }
        & Pick<AmenityType, 'amenityId' | 'name' | 'description' | 'iconName' | 'enabled'>
      )> }
    )> }
  )> }
);

export type ListingPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type ListingPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & { amenities?: Maybe<(
      { __typename?: 'PropertyAmenities' }
      & Pick<PropertyAmenities, 'amenityIds'>
    )>, general?: Maybe<(
      { __typename?: 'PropertyGeneral' }
      & Pick<PropertyGeneral, 'bathrooms' | 'description' | 'name' | 'propertyStyle'>
      & { bedrooms?: Maybe<Array<Maybe<(
        { __typename?: 'BedroomType' }
        & Pick<BedroomType, 'bedSizes'>
      )>>> }
    )>, guestRestrictions: (
      { __typename?: 'GuestRestrictions' }
      & Pick<GuestRestrictions, 'maxOccupancy'>
      & { ageRanges: Array<(
        { __typename?: 'AgeRange' }
        & Pick<AgeRange, 'key' | 'labelPrefix' | 'allowed' | 'maxAge' | 'minAge' | 'maxNumberAllowed' | 'minNumberAllowed'>
      )> }
    ), goodToKnow?: Maybe<(
      { __typename?: 'PropertyGoodToKnow' }
      & Pick<PropertyGoodToKnow, 'description'>
    )>, houseRules?: Maybe<(
      { __typename?: 'PropertyHouseRules' }
      & Pick<PropertyHouseRules, 'allowsChildren' | 'allowsEvents' | 'allowsInfants' | 'allowsPets' | 'allowsSmoking'>
    )>, location?: Maybe<(
      { __typename?: 'PropertyLocation' }
      & { geoLocation?: Maybe<(
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      )> }
    )>, owner?: Maybe<(
      { __typename?: 'AssetOwner' }
      & Pick<AssetOwner, 'firstName' | 'lastName' | 'photoUrl'>
    )> }
  )> }
);

export type ListingTravelDatesQueryVariables = Exact<{
  listingId: Scalars['ID'];
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
  guestCounts: Array<GuestCount> | GuestCount;
}>;


export type ListingTravelDatesQuery = (
  { __typename?: 'Query' }
  & { listingByTravelDetails: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'allowInstantBook'>
    & { asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetType'>
    ), fees?: Maybe<(
      { __typename?: 'Fees' }
      & Pick<Fees, 'bookingToken'>
      & { bookingFee: (
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      ) }
    )>, commission?: Maybe<(
      { __typename?: 'Commission' }
      & Pick<Commission, 'rate'>
    )>, stayDurationConditions: (
      { __typename?: 'StayDurationConditions' }
      & Pick<StayDurationConditions, 'minimum'>
    ) }
  ) }
);

export type ListingTravelDatesByIdQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingTravelDatesByIdQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'allowInstantBook'>
    & { commission?: Maybe<(
      { __typename?: 'Commission' }
      & Pick<Commission, 'rate'>
    )>, priceRange?: Maybe<(
      { __typename?: 'PriceRange' }
      & { lowest: (
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      ) }
    )>, stayDurationConditions: (
      { __typename?: 'StayDurationConditions' }
      & Pick<StayDurationConditions, 'minimum'>
    ) }
  ) }
);

export type ListingTravelDatesFetchCommissionQueryVariables = Exact<{
  listingId: Scalars['ID'];
  adjustedPrice: CurrencyAmount;
  originalPrice: CurrencyAmount;
}>;


export type ListingTravelDatesFetchCommissionQuery = (
  { __typename?: 'Query' }
  & { commission?: Maybe<(
    { __typename?: 'CommissionFees' }
    & Pick<CommissionFees, 'commissionRate'>
    & { commission: (
      { __typename?: 'CurrencyAmountType' }
      & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
    ) }
  )> }
);

export type ListingCreateBookingMutationVariables = Exact<{
  input: CreateBookingRequest;
}>;


export type ListingCreateBookingMutation = (
  { __typename?: 'Mutation' }
  & { createBooking: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ListingBookingCheckoutMutationVariables = Exact<{
  input: BookingCheckoutRequest;
}>;


export type ListingBookingCheckoutMutation = (
  { __typename?: 'Mutation' }
  & { checkout: (
    { __typename?: 'CheckoutSession' }
    & Pick<CheckoutSession, 'sessionId'>
  ) }
);

export type ListingCancelCheckoutSessionMutationVariables = Exact<{
  input: CancelCheckoutRequest;
}>;


export type ListingCancelCheckoutSessionMutation = (
  { __typename?: 'Mutation' }
  & { cancelCheckout: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ListingBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type ListingBookingQuery = (
  { __typename?: 'Query' }
  & { booking: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'bookingId' | 'tripId'>
  ) }
);

export type ListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'listingId' | 'status' | 'allowInstantBook'>
    & { asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
      & { documentLibrary: (
        { __typename?: 'DocumentLibrary' }
        & Pick<DocumentLibrary, 'documentLibraryId'>
        & { categories?: Maybe<Array<(
          { __typename?: 'DocumentCategory' }
          & Pick<DocumentCategory, 'documentCategoryId' | 'documentLibraryId' | 'name' | 'isDefaultCategory'>
          & { documents?: Maybe<Array<(
            { __typename?: 'Document' }
            & Pick<Document, 'documentId' | 'documentCategoryId' | 'documentLibraryId' | 'name' | 'url'>
          )>> }
        )>> }
      ) }
    ), availabilityCalendar: (
      { __typename?: 'AvailabilityCalendar' }
      & { dailyAllocations: Array<Maybe<(
        { __typename?: 'DailyAllocationType' }
        & Pick<DailyAllocationType, 'allocated' | 'day' | 'consumed'>
      )>> }
    ), obfuscatedLocation: (
      { __typename?: 'ObfuscatedLocation' }
      & Pick<ObfuscatedLocation, 'range'>
      & { location: (
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      ) }
    ), summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle' | 'highlightedAmenities'>
      & { highlightedFeatures: (
        { __typename?: 'HighlightedFeatures' }
        & { features: Array<(
          { __typename?: 'ListingHighlightedFeature' }
          & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
        )> }
      ), houseRules: (
        { __typename?: 'ListingHouseRules' }
        & Pick<ListingHouseRules, 'otherRules'>
        & { rules: Array<(
          { __typename?: 'ListingHouseRule' }
          & Pick<ListingHouseRule, 'enabled' | 'icon' | 'subtitle' | 'title'>
        )> }
      ), photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover' | 'description'>
      )> }
    ), stayDurationConditions: (
      { __typename?: 'StayDurationConditions' }
      & Pick<StayDurationConditions, 'minimum'>
    ), operator?: Maybe<(
      { __typename?: 'Operator' }
      & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
    )>, installmentSchedule?: Maybe<(
      { __typename?: 'InstallmentSchedule' }
      & Pick<InstallmentSchedule, 'installmentScheduleId'>
      & { installments: Array<(
        { __typename?: 'Installment' }
        & Pick<Installment, 'installmentScheduleId' | 'installmentId' | 'daysPriorTo' | 'percentage'>
      )> }
    )>, documentLibrary: (
      { __typename?: 'DocumentLibrary' }
      & Pick<DocumentLibrary, 'documentLibraryId'>
      & { categories?: Maybe<Array<(
        { __typename?: 'DocumentCategory' }
        & Pick<DocumentCategory, 'documentCategoryId' | 'documentLibraryId' | 'name' | 'isDefaultCategory'>
        & { documents?: Maybe<Array<(
          { __typename?: 'Document' }
          & Pick<Document, 'documentId' | 'documentCategoryId' | 'documentLibraryId' | 'name' | 'url'>
        )>> }
      )>> }
    ) }
  ) }
);

export type ListingIdQueryVariables = Exact<{
  propertyOrHotelRoomId: Scalars['ID'];
}>;


export type ListingIdQuery = (
  { __typename?: 'Query' }
  & { listingId?: Maybe<(
    { __typename?: 'ListingId' }
    & Pick<ListingId, 'listingId'>
  )> }
);

export type ListingManagementIdQueryVariables = Exact<{
  propertyOrHotelRoomId: Scalars['ID'];
}>;


export type ListingManagementIdQuery = (
  { __typename?: 'Query' }
  & { listingId?: Maybe<(
    { __typename?: 'ListingId' }
    & Pick<ListingId, 'listingManagementId'>
  )> }
);

export type ListingHostQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingHostQuery = (
  { __typename?: 'Query' }
  & { hostingTeamByListing?: Maybe<(
    { __typename?: 'Host' }
    & Pick<Host, 'displayName' | 'imageUrl'>
  )> }
);

export type ListingTransportAirportsQueryVariables = Exact<{
  location: InputGeoLocation;
}>;


export type ListingTransportAirportsQuery = (
  { __typename?: 'Query' }
  & { airports: Array<(
    { __typename?: 'Airport' }
    & Pick<Airport, 'distance' | 'name' | 'type'>
  )> }
);

export type SignupConsumerMutationVariables = Exact<{
  input: SignupConsumerRequest;
}>;


export type SignupConsumerMutation = (
  { __typename?: 'Mutation' }
  & { signupConsumer: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type SignupTravelAgentMutationVariables = Exact<{
  input: SignupTravelAgentRequest;
}>;


export type SignupTravelAgentMutation = (
  { __typename?: 'Mutation' }
  & { signupTravelAgent: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type SignupHotelMutationVariables = Exact<{
  input: SignupHotelRequest;
}>;


export type SignupHotelMutation = (
  { __typename?: 'Mutation' }
  & { signupHotel: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type VerifyPromotionalCodeQueryVariables = Exact<{
  promotionalCode: Scalars['String'];
}>;


export type VerifyPromotionalCodeQuery = (
  { __typename?: 'Query' }
  & { verifyPromotionalCode?: Maybe<(
    { __typename?: 'VerifiedPromotionalCode' }
    & Pick<VerifiedPromotionalCode, 'promotionalCodeId' | 'valid'>
  )> }
);

export type PropertyInquiryMutationVariables = Exact<{
  input: PropertyInquiryRequest;
}>;


export type PropertyInquiryMutation = (
  { __typename?: 'Mutation' }
  & { propertyInquiry: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ResellerCommissionQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type ResellerCommissionQuery = (
  { __typename?: 'Query' }
  & { resellerByBookingId?: Maybe<(
    { __typename?: 'Reseller' }
    & Pick<Reseller, 'resellerId' | 'businessId' | 'name' | 'verified'>
    & { associatedBookings: Array<(
      { __typename?: 'AssociatedBooking' }
      & Pick<AssociatedBooking, 'bookingId'>
      & { commissionFees: (
        { __typename?: 'CommissionFees' }
        & { commission: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      ), commissionPlan: (
        { __typename?: 'CommissionPlan' }
        & Pick<CommissionPlan, 'commissionPlanId' | 'vendorId' | 'commissionModelType'>
        & { flatPercentageCommissionPlan?: Maybe<(
          { __typename?: 'FlatPercentageCommissionPlan' }
          & Pick<FlatPercentageCommissionPlan, 'flatPercentage'>
        )> }
      ), booking: (
        { __typename?: 'Booking' }
        & Pick<Booking, 'bookingId' | 'bookingReference' | 'checkin' | 'checkout' | 'status'>
        & { bookingSupplementsDetails?: Maybe<(
          { __typename?: 'BookingSupplementsDetails' }
          & { supplementDetails: Array<(
            { __typename?: 'BookingSupplementType' }
            & Pick<BookingSupplementType, 'supplementId' | 'iconName' | 'name' | 'description'>
            & { price: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
            ) }
          )> }
        )>, fees: (
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
          ) }
        ), guest: (
          { __typename?: 'Guest' }
          & Pick<Guest, 'firstName' | 'imageUrl' | 'lastName'>
        ), summary: (
          { __typename?: 'TripSummary' }
          & Pick<TripSummary, 'imageUrl' | 'name'>
          & { location: (
            { __typename?: 'Location' }
            & { address: (
              { __typename?: 'AddressType' }
              & Pick<AddressType, 'city' | 'countryCode'>
            ) }
          ) }
        ) }
      ) }
    )> }
  )> }
);

export type UpdatePropertyAmenitiesMutationVariables = Exact<{
  input: UpdatePropertyAmenitiesCommand;
}>;


export type UpdatePropertyAmenitiesMutation = (
  { __typename?: 'Mutation' }
  & { updatePropertyAmenities: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyAmenitiesPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type UpdatePropertyAmenitiesPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & { amenities?: Maybe<(
      { __typename?: 'PropertyAmenities' }
      & Pick<PropertyAmenities, 'amenityIds'>
    )> }
  )> }
);

export type UpdatePropertyAmenityBundleByAssetQueryVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type UpdatePropertyAmenityBundleByAssetQuery = (
  { __typename?: 'Query' }
  & { amenityBundleByAsset?: Maybe<(
    { __typename?: 'AmenityBundleType' }
    & Pick<AmenityBundleType, 'bundleId' | 'name' | 'enabled'>
    & { sections: Array<(
      { __typename?: 'AmenityBundleSectionType' }
      & Pick<AmenityBundleSectionType, 'sectionId' | 'name'>
      & { amenities: Array<(
        { __typename?: 'AmenityType' }
        & Pick<AmenityType, 'amenityId' | 'name' | 'description' | 'iconName' | 'enabled'>
      )> }
    )> }
  )> }
);

export type UpdatePropertyCleaningFeesListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type UpdatePropertyCleaningFeesListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & { cleaningService: (
      { __typename?: 'CleaningService' }
      & Pick<CleaningService, 'paymentMode'>
      & { perDayCleaningFee?: Maybe<(
        { __typename?: 'CleaningFee' }
        & Pick<CleaningFee, 'description'>
        & { amount: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>, perStayCleaningFee?: Maybe<(
        { __typename?: 'CleaningFee' }
        & Pick<CleaningFee, 'description'>
        & { amount: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )> }
    ) }
  ) }
);

export type UpdatePropertyCleaningServiceMutationVariables = Exact<{
  input: UpdateListingCleaningServiceCommand;
}>;


export type UpdatePropertyCleaningServiceMutation = (
  { __typename?: 'Mutation' }
  & { updateListingCleaningService: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyGeneralMutationVariables = Exact<{
  input: UpdatePropertyGeneralCommand;
}>;


export type UpdatePropertyGeneralMutation = (
  { __typename?: 'Mutation' }
  & { updatePropertyGeneral: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyGeneralPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type UpdatePropertyGeneralPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & Pick<Property, 'propertyId'>
    & { general?: Maybe<(
      { __typename?: 'PropertyGeneral' }
      & Pick<PropertyGeneral, 'bathrooms' | 'description' | 'name' | 'propertyStyle' | 'propertyType' | 'sleeps'>
      & { approximateValue?: Maybe<(
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      )>, bedrooms?: Maybe<Array<Maybe<(
        { __typename?: 'BedroomType' }
        & Pick<BedroomType, 'bedSizes'>
      )>>> }
    )>, location?: Maybe<(
      { __typename?: 'PropertyLocation' }
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'line1'>
      )> }
    )> }
  )> }
);

export type UpdatePropertyHouseRulesMutationVariables = Exact<{
  input: UpdatePropertyHouseRulesCommand;
}>;


export type UpdatePropertyHouseRulesMutation = (
  { __typename?: 'Mutation' }
  & { updatePropertyHouseRules: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyHouseRulesPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type UpdatePropertyHouseRulesPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & { houseRules?: Maybe<(
      { __typename?: 'PropertyHouseRules' }
      & Pick<PropertyHouseRules, 'allowsChildren' | 'allowsEvents' | 'allowsInfants' | 'allowsPets' | 'allowsSmoking'>
    )> }
  )> }
);

export type UpdatePropertyLocationMutationVariables = Exact<{
  input: UpdatePropertyLocationCommand;
}>;


export type UpdatePropertyLocationMutation = (
  { __typename?: 'Mutation' }
  & { updatePropertyLocation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyLocationPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type UpdatePropertyLocationPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & { location?: Maybe<(
      { __typename?: 'PropertyLocation' }
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'additionalInstructions' | 'city' | 'countryCode' | 'line1' | 'line2' | 'postalCode' | 'region'>
      )>, geoLocation?: Maybe<(
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      )> }
    )> }
  )> }
);

export type UpdatePropertyPhotosMutationVariables = Exact<{
  input: UpdatePropertyPhotosCommand;
}>;


export type UpdatePropertyPhotosMutation = (
  { __typename?: 'Mutation' }
  & { updatePropertyPhotos: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePropertyPhotosPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type UpdatePropertyPhotosPropertyQuery = (
  { __typename?: 'Query' }
  & { property?: Maybe<(
    { __typename?: 'Property' }
    & { imagery: (
      { __typename?: 'PropertyImagery' }
      & { photos?: Maybe<Array<Maybe<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'description' | 'url' | 'useAsCover' | 'useAsFloorplan'>
      )>>> }
    ) }
  )> }
);

export type UpdatePropertyPhotosSignedUrlMutationVariables = Exact<{
  input: PropertyPhotoSignUrlRequest;
}>;


export type UpdatePropertyPhotosSignedUrlMutation = (
  { __typename?: 'Mutation' }
  & { propertyPhotoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type UpdatePropertySupplementBundlesQueryVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type UpdatePropertySupplementBundlesQuery = (
  { __typename?: 'Query' }
  & { supplementBundleByAsset?: Maybe<(
    { __typename?: 'SupplementBundleType' }
    & Pick<SupplementBundleType, 'bundleId' | 'name' | 'enabled'>
    & { sections: Array<(
      { __typename?: 'SupplementBundleSectionType' }
      & Pick<SupplementBundleSectionType, 'sectionId' | 'name'>
      & { supplements: Array<(
        { __typename?: 'SupplementType' }
        & Pick<SupplementType, 'supplementId' | 'name' | 'description' | 'iconName' | 'enabled'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )> }
    )> }
  )> }
);

export type UpdatePropertySupplementIdsListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type UpdatePropertySupplementIdsListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & { supplements: (
      { __typename?: 'ListingSupplements' }
      & Pick<ListingSupplements, 'listingId'>
      & { mandatorySupplements?: Maybe<Array<(
        { __typename?: 'ListingSupplementEntry' }
        & Pick<ListingSupplementEntry, 'id' | 'description'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>>, optionalSupplements?: Maybe<Array<(
        { __typename?: 'ListingSupplementEntry' }
        & Pick<ListingSupplementEntry, 'id' | 'description'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>> }
    ) }
  ) }
);

export type UpdatePropertySupplementsListingMutationVariables = Exact<{
  input: UpdateListingSupplementsCommand;
}>;


export type UpdatePropertySupplementsListingMutation = (
  { __typename?: 'Mutation' }
  & { updateListingSupplements: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InviteStaffMemberMutationVariables = Exact<{
  input: InviteStaffMemberCommand;
}>;


export type InviteStaffMemberMutation = (
  { __typename?: 'Mutation' }
  & { inviteStaffMember: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type RemoveMemberFromStaffMutationVariables = Exact<{
  input: RemoveMemberFromStaffCommand;
}>;


export type RemoveMemberFromStaffMutation = (
  { __typename?: 'Mutation' }
  & { removeMemberFromStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type StaffMemberInvitationsQueryVariables = Exact<{
  staffId: Scalars['ID'];
}>;


export type StaffMemberInvitationsQuery = (
  { __typename?: 'Query' }
  & { staffMemberInvitations: Array<(
    { __typename?: 'StaffMemberInvitation' }
    & Pick<StaffMemberInvitation, 'email' | 'firstName' | 'host' | 'invitationId' | 'lastName' | 'manager' | 'status'>
  )> }
);

export type StaffMembersQueryVariables = Exact<{
  staffId: Scalars['ID'];
}>;


export type StaffMembersQuery = (
  { __typename?: 'Query' }
  & { staffMembers: Array<(
    { __typename?: 'StaffMember' }
    & Pick<StaffMember, 'userId' | 'email' | 'firstName' | 'lastName' | 'host' | 'manager' | 'boss'>
  )> }
);

export type UpdateStaffPhotoSignedUrlMutationVariables = Exact<{
  input: StaffPhotoSignUrlRequest;
}>;


export type UpdateStaffPhotoSignedUrlMutation = (
  { __typename?: 'Mutation' }
  & { staffPhotoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type AccountOwnedPmcsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountOwnedPmcsQuery = (
  { __typename?: 'Query' }
  & { ownedPmcs?: Maybe<Array<Maybe<(
    { __typename?: 'Pmc' }
    & Pick<Pmc, 'pmcId' | 'name'>
  )>>> }
);

export type AccountOwnedTravelAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountOwnedTravelAgentsQuery = (
  { __typename?: 'Query' }
  & { ownedTravelAgents?: Maybe<Array<Maybe<(
    { __typename?: 'TravelAgent' }
    & Pick<TravelAgent, 'travelAgentId' | 'name'>
  )>>> }
);

export type UpdateBankAccountMutationVariables = Exact<{
  input: UpdateBankAccountCommand;
}>;


export type UpdateBankAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateBankAccount: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateBankAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateBankAccountDetailsQuery = (
  { __typename?: 'Query' }
  & { bankAccountDetails?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
    & { bankAccount: (
      { __typename?: 'BankAccount' }
      & Pick<BankAccount, 'accountType' | 'accountHolderName' | 'bankName' | 'countryCode' | 'bankCode' | 'transitNumber' | 'accountNumber'>
    ) }
  )> }
);

export type UpdatePersonalInformationMutationVariables = Exact<{
  input: UpdatePersonalInformationCommand;
}>;


export type UpdatePersonalInformationMutation = (
  { __typename?: 'Mutation' }
  & { updatePersonalInformation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePersonalInformationProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdatePersonalInformationProfileQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
    & { personalProfile: (
      { __typename?: 'PersonalProfile' }
      & Pick<PersonalProfile, 'email' | 'firstName' | 'lastName'>
      & { phoneNumber: (
        { __typename?: 'PhoneNumberType' }
        & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
      ) }
    ) }
  )> }
);

export type UpdatePersonalPhotoMutationVariables = Exact<{
  input: UpdatePersonalPhotoCommand;
}>;


export type UpdatePersonalPhotoMutation = (
  { __typename?: 'Mutation' }
  & { updatePersonalPhoto: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePersonalPhotoProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdatePersonalPhotoProfileQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
    & { personalProfile: (
      { __typename?: 'PersonalProfile' }
      & Pick<PersonalProfile, 'email' | 'photoUrl'>
    ) }
  )> }
);

export type UpdateMemberPhotoSignedUrlMutationVariables = Exact<{
  input: ProfilePhotoSignUrlRequest;
}>;


export type UpdateMemberPhotoSignedUrlMutation = (
  { __typename?: 'Mutation' }
  & { profilePhotoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type CreateStaffMutationVariables = Exact<{
  input: CreateStaffCommand;
}>;


export type CreateStaffMutation = (
  { __typename?: 'Mutation' }
  & { createStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type AssignPersonalStaffToMemberMutationVariables = Exact<{
  input: AssignPersonalStaffToMemberCommand;
}>;


export type AssignPersonalStaffToMemberMutation = (
  { __typename?: 'Mutation' }
  & { assignPersonalStaffToMember: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdatePersonalStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdatePersonalStaffQuery = (
  { __typename?: 'Query' }
  & { myPersonalStaff?: Maybe<(
    { __typename?: 'Staff' }
    & Pick<Staff, 'displayName' | 'email' | 'photoUrl' | 'staffId'>
    & { phoneNumber?: Maybe<(
      { __typename?: 'PhoneNumberType' }
      & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
    )> }
  )> }
);

export type UpdateStaffMutationVariables = Exact<{
  input: UpdateStaffCommand;
}>;


export type UpdateStaffMutation = (
  { __typename?: 'Mutation' }
  & { updateStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdatePmcAssignStaffToPmcMutationVariables = Exact<{
  input: AssignStaffToPmcCommand;
}>;


export type PartnerUpdatePmcAssignStaffToPmcMutation = (
  { __typename?: 'Mutation' }
  & { assignStaffToPmc: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdatePmcCreateStaffMutationVariables = Exact<{
  input: CreateStaffCommand;
}>;


export type PartnerUpdatePmcCreateStaffMutation = (
  { __typename?: 'Mutation' }
  & { createStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdatePmcListStaffQueryVariables = Exact<{
  pmcId: Scalars['ID'];
}>;


export type PartnerUpdatePmcListStaffQuery = (
  { __typename?: 'Query' }
  & { pmcStaff?: Maybe<(
    { __typename?: 'Staff' }
    & Pick<Staff, 'displayName' | 'email' | 'photoUrl' | 'staffId'>
    & { phoneNumber?: Maybe<(
      { __typename?: 'PhoneNumberType' }
      & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
    )> }
  )> }
);

export type PartnerUpdatePmcUpdateStaffMutationVariables = Exact<{
  input: UpdateStaffCommand;
}>;


export type PartnerUpdatePmcUpdateStaffMutation = (
  { __typename?: 'Mutation' }
  & { updateStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdateTravelAgentAssignStaffToTravelAgentMutationVariables = Exact<{
  input: AssignStaffToTravelAgentCommand;
}>;


export type PartnerUpdateTravelAgentAssignStaffToTravelAgentMutation = (
  { __typename?: 'Mutation' }
  & { assignStaffToTravelAgent: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdateTravelAgentCreateStaffMutationVariables = Exact<{
  input: CreateStaffCommand;
}>;


export type PartnerUpdateTravelAgentCreateStaffMutation = (
  { __typename?: 'Mutation' }
  & { createStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type PartnerUpdateTravelAgentListStaffQueryVariables = Exact<{
  travelAgentId: Scalars['ID'];
}>;


export type PartnerUpdateTravelAgentListStaffQuery = (
  { __typename?: 'Query' }
  & { travelAgentStaff?: Maybe<(
    { __typename?: 'Staff' }
    & Pick<Staff, 'displayName' | 'email' | 'photoUrl' | 'staffId'>
    & { phoneNumber?: Maybe<(
      { __typename?: 'PhoneNumberType' }
      & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
    )> }
  )> }
);

export type PartnerUpdateTravelAgentUpdateStaffMutationVariables = Exact<{
  input: UpdateStaffCommand;
}>;


export type PartnerUpdateTravelAgentUpdateStaffMutation = (
  { __typename?: 'Mutation' }
  & { updateStaff: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CheckSubdomainAvailabilityQueryVariables = Exact<{
  subdomain: Scalars['String'];
}>;


export type CheckSubdomainAvailabilityQuery = (
  { __typename?: 'Query' }
  & { checkSubdomainAvailability: (
    { __typename?: 'SubdomainAvailability' }
    & Pick<SubdomainAvailability, 'available'>
  ) }
);

export type WhiteLabelQueryVariables = Exact<{
  resellerId: Scalars['ID'];
}>;


export type WhiteLabelQuery = (
  { __typename?: 'Query' }
  & { whiteLabel?: Maybe<(
    { __typename?: 'WhiteLabel' }
    & Pick<WhiteLabel, 'resellerId' | 'primaryColor' | 'secondaryColor' | 'tertiaryColor' | 'quaternaryColor' | 'headerColor' | 'primaryGreen' | 'headingFont' | 'bodyFont' | 'subdomain' | 'squareLogoUrl' | 'landscapeLogoUrl' | 'faviconUrl'>
  )> }
);

export type WhiteLabelBySubdomainQueryVariables = Exact<{
  subdomain: Scalars['String'];
}>;


export type WhiteLabelBySubdomainQuery = (
  { __typename?: 'Query' }
  & { whiteLabelBySubdomain?: Maybe<(
    { __typename?: 'WhiteLabel' }
    & Pick<WhiteLabel, 'resellerId' | 'primaryColor' | 'secondaryColor' | 'tertiaryColor' | 'quaternaryColor' | 'headerColor' | 'primaryGreen' | 'headingFont' | 'bodyFont' | 'subdomain' | 'squareLogoUrl' | 'landscapeLogoUrl' | 'faviconUrl'>
  )> }
);

export type WhiteLabelLogoSignUrlMutationVariables = Exact<{
  input: WhiteLabelLogoSignUrlRequest;
}>;


export type WhiteLabelLogoSignUrlMutation = (
  { __typename?: 'Mutation' }
  & { whiteLabelLogoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type ConfigureWhiteLabelMutationVariables = Exact<{
  input: ConfigureWhiteLabelCommand;
}>;


export type ConfigureWhiteLabelMutation = (
  { __typename?: 'Mutation' }
  & { configureWhiteLabel: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type AddApplicationPhotosMutationVariables = Exact<{
  input: AddApplicationPhotosCommand;
}>;


export type AddApplicationPhotosMutation = (
  { __typename?: 'Mutation' }
  & { addApplicationPhotos: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ApplicationPhotosSignedUrlMutationVariables = Exact<{
  input: ApplicationPhotoSignUrlRequest;
}>;


export type ApplicationPhotosSignedUrlMutation = (
  { __typename?: 'Mutation' }
  & { applicationPhotoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type ApplicationMutationVariables = Exact<{
  input: SubmitMemberApplicationCommand;
}>;


export type ApplicationMutation = (
  { __typename?: 'Mutation' }
  & { submitMemberApplication: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ApplicationActiveMemberApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationActiveMemberApplicationQuery = (
  { __typename?: 'Query' }
  & { activeMemberApplication?: Maybe<(
    { __typename?: 'MemberApplication' }
    & Pick<MemberApplication, 'status'>
  )> }
);

export type CalendarListingsQueryVariables = Exact<{
  memberId: Scalars['ID'];
  page: RequestedPage;
}>;


export type CalendarListingsQuery = (
  { __typename?: 'Query' }
  & { managedListings: (
    { __typename?: 'PagedList' }
    & Pick<PagedList, 'total' | 'page' | 'pageSize' | 'searchTerm'>
    & { results: Array<(
      { __typename: 'Listing' }
      & Pick<Listing, 'status' | 'listingId'>
      & { asset: (
        { __typename?: 'Asset' }
        & Pick<Asset, 'assetId' | 'assetType'>
      ), summary: (
        { __typename?: 'ListingSummary' }
        & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle'>
        & { photos: Array<(
          { __typename?: 'AssetPhotoType' }
          & Pick<AssetPhotoType, 'url' | 'useAsCover'>
        )> }
      ) }
    )> }
  ) }
);

export type GuestbookBusinessCustomerQueryVariables = Exact<{
  businessId: Scalars['ID'];
  userId: Scalars['String'];
}>;


export type GuestbookBusinessCustomerQuery = (
  { __typename?: 'Query' }
  & { businessCustomer: (
    { __typename?: 'BusinessCustomer' }
    & Pick<BusinessCustomer, 'userId' | 'email' | 'firstName' | 'lastName' | 'photoUrl'>
    & { phoneNumber: (
      { __typename?: 'PhoneNumberType' }
      & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
    ), trips: Array<(
      { __typename?: 'Trip' }
      & Pick<Trip, 'tripId'>
      & { bookings: Array<Maybe<(
        { __typename?: 'Booking' }
        & Pick<Booking, 'tripId' | 'bookingId' | 'listingId' | 'status' | 'bookingReference' | 'checkin' | 'checkout' | 'nights' | 'numberOfGuests'>
        & { fees: (
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
          ) }
        ), guest: (
          { __typename?: 'Guest' }
          & Pick<Guest, 'guestId' | 'firstName' | 'lastName' | 'imageUrl'>
        ), summary: (
          { __typename?: 'TripSummary' }
          & Pick<TripSummary, 'name' | 'imageUrl'>
          & { location: (
            { __typename?: 'Location' }
            & { geoLocation: (
              { __typename?: 'GeoLocation' }
              & Pick<GeoLocation, 'lat' | 'lng'>
            ), address: (
              { __typename?: 'AddressType' }
              & Pick<AddressType, 'line1' | 'line2' | 'city' | 'postalCode' | 'countryCode' | 'additionalInstructions'>
            ) }
          ) }
        ), bookingSupplementsDetails?: Maybe<(
          { __typename?: 'BookingSupplementsDetails' }
          & { supplementDetails: Array<(
            { __typename?: 'BookingSupplementType' }
            & Pick<BookingSupplementType, 'supplementId' | 'iconName' | 'name' | 'description'>
            & { price: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
            ) }
          )> }
        )> }
      )>> }
    )> }
  ) }
);

export type TripSummaryHostQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type TripSummaryHostQuery = (
  { __typename?: 'Query' }
  & { hostingTeamByListing?: Maybe<(
    { __typename?: 'Host' }
    & Pick<Host, 'displayName' | 'imageUrl'>
  )> }
);

export type GuestbookClienteleByBusinessIdQueryVariables = Exact<{
  businessId: Scalars['ID'];
}>;


export type GuestbookClienteleByBusinessIdQuery = (
  { __typename?: 'Query' }
  & { clienteleByBusinessId: (
    { __typename?: 'Clientele' }
    & Pick<Clientele, 'clienteleId' | 'businessId'>
    & { customers: Array<(
      { __typename?: 'BusinessCustomer' }
      & Pick<BusinessCustomer, 'userId' | 'firstName' | 'lastName' | 'email' | 'photoUrl'>
      & { phoneNumber: (
        { __typename?: 'PhoneNumberType' }
        & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
      ) }
    )> }
  ) }
);

export type ConfirmBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type ConfirmBookingQuery = (
  { __typename?: 'Query' }
  & { publicBooking: (
    { __typename?: 'PublicBooking' }
    & Pick<PublicBooking, 'tripId' | 'bookingId' | 'status' | 'bookingReference' | 'checkin' | 'checkout' | 'nights' | 'numberOfGuests' | 'bookingTimestamp'>
    & { summary: (
      { __typename?: 'TripSummary' }
      & Pick<TripSummary, 'imageUrl' | 'name'>
      & { location: (
        { __typename?: 'Location' }
        & { address: (
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'city' | 'countryCode'>
        ) }
      ) }
    ), originalFees?: Maybe<(
      { __typename?: 'Fees' }
      & { bookingFee: (
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      ) }
    )> }
  ) }
);

export type ConfirmBookingAcceptMutationVariables = Exact<{
  input: AcceptBookingRequest;
}>;


export type ConfirmBookingAcceptMutation = (
  { __typename?: 'Mutation' }
  & { acceptBooking: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConfirmBookingDeclineMutationVariables = Exact<{
  input: DeclineBookingRequest;
}>;


export type ConfirmBookingDeclineMutation = (
  { __typename?: 'Mutation' }
  & { declineBooking: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConfirmBookingAssignReferenceMutationVariables = Exact<{
  input: AssignBookingReferenceCommand;
}>;


export type ConfirmBookingAssignReferenceMutation = (
  { __typename?: 'Mutation' }
  & { assignBookingReference: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConfirmListingByTravelDatesQueryVariables = Exact<{
  listingId: Scalars['ID'];
  checkin: Scalars['LocalDate'];
  checkout: Scalars['LocalDate'];
  guestCounts: Array<GuestCount> | GuestCount;
}>;


export type ConfirmListingByTravelDatesQuery = (
  { __typename?: 'Query' }
  & { listingByTravelDetails: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'checkin' | 'checkout' | 'listingId'>
    & { asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
    ), fees?: Maybe<(
      { __typename?: 'Fees' }
      & { bookingFee: (
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      ) }
    )>, summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle'>
      & { houseRules: (
        { __typename?: 'ListingHouseRules' }
        & Pick<ListingHouseRules, 'otherRules'>
        & { rules: Array<(
          { __typename?: 'ListingHouseRule' }
          & Pick<ListingHouseRule, 'enabled' | 'icon' | 'subtitle' | 'title'>
        )> }
      ), photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url'>
      )> }
    ) }
  ) }
);

export type ConfirmBookingCancelCheckoutMutationVariables = Exact<{
  input: CancelCheckoutRequest;
}>;


export type ConfirmBookingCancelCheckoutMutation = (
  { __typename?: 'Mutation' }
  & { cancelCheckout: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConsumerSignupMutationVariables = Exact<{
  input: SignupConsumerRequest;
}>;


export type ConsumerSignupMutation = (
  { __typename?: 'Mutation' }
  & { signupConsumer: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConsumerSignupUpdatePersonalInformationMutationVariables = Exact<{
  input: UpdatePersonalInformationCommand;
}>;


export type ConsumerSignupUpdatePersonalInformationMutation = (
  { __typename?: 'Mutation' }
  & { updatePersonalInformation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConsumerSignupAcceptTermsMutationVariables = Exact<{
  input: AcceptConsumerTermsAndConditionsCommand;
}>;


export type ConsumerSignupAcceptTermsMutation = (
  { __typename?: 'Mutation' }
  & { acceptConsumerTermsAndConditions: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ConsumerSignupAccountExistsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerSignupAccountExistsQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId' | 'accountHolderId'>
    & { personalProfile: (
      { __typename?: 'PersonalProfile' }
      & Pick<PersonalProfile, 'email' | 'firstName' | 'lastName'>
      & { phoneNumber: (
        { __typename?: 'PhoneNumberType' }
        & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
      ) }
    ) }
  )> }
);

export type FeaturedListingListingsQueryVariables = Exact<{
  featuredListingCode: Scalars['String'];
}>;


export type FeaturedListingListingsQuery = (
  { __typename?: 'Query' }
  & { featuredListings: (
    { __typename?: 'PublicListing' }
    & Pick<PublicListing, 'listingCode' | 'name'>
    & { publicListingEntries?: Maybe<Array<(
      { __typename?: 'PublicListingEntry' }
      & Pick<PublicListingEntry, 'listingId' | 'city' | 'countryCode' | 'title'>
      & { photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'description' | 'useAsCover'>
      )>, decidingFactors: (
        { __typename?: 'DecidingFactors' }
        & { primaryDecidingFactors: Array<(
          { __typename?: 'DecidingFactor' }
          & Pick<DecidingFactor, 'enabled' | 'icon' | 'title' | 'subtitle'>
        )> }
      ), operator?: Maybe<(
        { __typename?: 'Operator' }
        & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
      )> }
    )>> }
  ) }
);

export type HotelHeaderHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type HotelHeaderHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { general?: Maybe<(
      { __typename?: 'HotelGeneral' }
      & Pick<HotelGeneral, 'name'>
    )>, imagery: (
      { __typename?: 'HotelImagery' }
      & { photos?: Maybe<Array<Maybe<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url'>
      )>>> }
    ), location?: Maybe<(
      { __typename?: 'HotelLocation' }
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'city' | 'countryCode'>
      )> }
    )> }
  ) }
);

export type UpdateHotelAmenitiesMutationVariables = Exact<{
  input: UpdateHotelAmenitiesCommand;
}>;


export type UpdateHotelAmenitiesMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelAmenities: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelAmenitiesHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelAmenitiesHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { amenities?: Maybe<(
      { __typename?: 'HotelAmenities' }
      & Pick<HotelAmenities, 'amenityIds'>
    )> }
  ) }
);

export type UpdateHotelAmenityBundleByAssetQueryVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type UpdateHotelAmenityBundleByAssetQuery = (
  { __typename?: 'Query' }
  & { amenityBundleByAsset?: Maybe<(
    { __typename?: 'AmenityBundleType' }
    & Pick<AmenityBundleType, 'bundleId' | 'name' | 'enabled'>
    & { sections: Array<(
      { __typename?: 'AmenityBundleSectionType' }
      & Pick<AmenityBundleSectionType, 'sectionId' | 'name'>
      & { amenities: Array<(
        { __typename?: 'AmenityType' }
        & Pick<AmenityType, 'amenityId' | 'name' | 'description' | 'iconName' | 'enabled'>
      )> }
    )> }
  )> }
);

export type UpdateHotelGeneralMutationVariables = Exact<{
  input: UpdateHotelGeneralCommand;
}>;


export type UpdateHotelGeneralMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelGeneral: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelGeneralHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelGeneralHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'hotelId'>
    & { general?: Maybe<(
      { __typename?: 'HotelGeneral' }
      & Pick<HotelGeneral, 'description' | 'name' | 'stars' | 'website'>
      & { averageDailyRate?: Maybe<(
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      )> }
    )>, location?: Maybe<(
      { __typename?: 'HotelLocation' }
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'line1'>
      )> }
    )> }
  ) }
);

export type UpdateHotelHouseRulesMutationVariables = Exact<{
  input: UpdateHotelHouseRulesCommand;
}>;


export type UpdateHotelHouseRulesMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelHouseRules: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelHouseRulesHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelHouseRulesHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { houseRules?: Maybe<(
      { __typename?: 'HotelHouseRules' }
      & Pick<HotelHouseRules, 'allowsChildren' | 'earliestCheckin' | 'latestCheckin' | 'maximumStay' | 'minimumStay'>
    )> }
  ) }
);

export type UpdateHotelLocationMutationVariables = Exact<{
  input: UpdateHotelLocationCommand;
}>;


export type UpdateHotelLocationMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelLocation: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelLocationHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelLocationHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { location?: Maybe<(
      { __typename?: 'HotelLocation' }
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'additionalInstructions' | 'city' | 'countryCode' | 'line1' | 'line2' | 'postalCode' | 'region'>
      )>, geoLocation?: Maybe<(
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      )> }
    )> }
  ) }
);

export type UpdateHotelPhotosMutationVariables = Exact<{
  input: UpdateHotelPhotosCommand;
}>;


export type UpdateHotelPhotosMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelPhotos: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelPhotosHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelPhotosHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { imagery: (
      { __typename?: 'HotelImagery' }
      & { photos?: Maybe<Array<Maybe<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'description' | 'url' | 'useAsCover' | 'useAsFloorplan'>
      )>>> }
    ) }
  ) }
);

export type UpdateHotelPhotosSignedUrlMutationVariables = Exact<{
  input: HotelPhotoSignUrlRequest;
}>;


export type UpdateHotelPhotosSignedUrlMutation = (
  { __typename?: 'Mutation' }
  & { hotelPhotoSignUrl: (
    { __typename?: 'BlobUploadUrlSigner' }
    & Pick<BlobUploadUrlSigner, 'contentType' | 'httpMethod' | 'signedUrl' | 'url'>
  ) }
);

export type UpdateHotelGoodToKnowMutationVariables = Exact<{
  input: UpdateHotelGoodToKnowCommand;
}>;


export type UpdateHotelGoodToKnowMutation = (
  { __typename?: 'Mutation' }
  & { updateHotelGoodToKnow: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelGoodToKnowHotelQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelGoodToKnowHotelQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { goodToKnow?: Maybe<(
      { __typename?: 'HotelGoodToKnow' }
      & Pick<HotelGoodToKnow, 'description'>
    )> }
  ) }
);

export type AssignStaffToHotelMutationVariables = Exact<{
  input: AssignStaffToHotelCommand;
}>;


export type AssignStaffToHotelMutation = (
  { __typename?: 'Mutation' }
  & { assignStaffToHotel: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateHotelStaffQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelStaffQuery = (
  { __typename?: 'Query' }
  & { hotelStaff?: Maybe<(
    { __typename?: 'Staff' }
    & Pick<Staff, 'displayName' | 'email' | 'photoUrl' | 'staffId'>
    & { phoneNumber?: Maybe<(
      { __typename?: 'PhoneNumberType' }
      & Pick<PhoneNumberType, 'countryCode' | 'nationalNumber'>
    )> }
  )> }
);

export type UpdateHotelSupplementsQueryVariables = Exact<{
  hotelId: Scalars['ID'];
}>;


export type UpdateHotelSupplementsQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & { rooms: Array<(
      { __typename?: 'HotelRoom' }
      & Pick<HotelRoom, 'hotelRoomId' | 'roomType'>
    )> }
  ) }
);

export type UpdateHotelSupplementBundlesQueryVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type UpdateHotelSupplementBundlesQuery = (
  { __typename?: 'Query' }
  & { supplementBundleByAsset?: Maybe<(
    { __typename?: 'SupplementBundleType' }
    & Pick<SupplementBundleType, 'bundleId' | 'name' | 'enabled'>
    & { sections: Array<(
      { __typename?: 'SupplementBundleSectionType' }
      & Pick<SupplementBundleSectionType, 'sectionId' | 'name'>
      & { supplements: Array<(
        { __typename?: 'SupplementType' }
        & Pick<SupplementType, 'supplementId' | 'name' | 'description' | 'iconName' | 'enabled'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )> }
    )> }
  )> }
);

export type UpdateHotelSupplementIdsListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type UpdateHotelSupplementIdsListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & { supplements: (
      { __typename?: 'ListingSupplements' }
      & Pick<ListingSupplements, 'listingId'>
      & { mandatorySupplements?: Maybe<Array<(
        { __typename?: 'ListingSupplementEntry' }
        & Pick<ListingSupplementEntry, 'id' | 'description'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>>, optionalSupplements?: Maybe<Array<(
        { __typename?: 'ListingSupplementEntry' }
        & Pick<ListingSupplementEntry, 'id' | 'description'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      )>> }
    ) }
  ) }
);

export type UpdateHotelSupplementsListingMutationVariables = Exact<{
  input: UpdateListingSupplementsCommand;
}>;


export type UpdateHotelSupplementsListingMutation = (
  { __typename?: 'Mutation' }
  & { updateListingSupplements: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type HotelsQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelsQuery = (
  { __typename?: 'Query' }
  & { hotels: Array<(
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'hotelId'>
    & { general?: Maybe<(
      { __typename?: 'HotelGeneral' }
      & Pick<HotelGeneral, 'name'>
    )>, imagery: (
      { __typename?: 'HotelImagery' }
      & { photos?: Maybe<Array<Maybe<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover'>
      )>>> }
    ) }
  )> }
);

export type ConversationQueryVariables = Exact<{
  conversationId: Scalars['ID'];
  device: Scalars['String'];
}>;


export type ConversationQuery = (
  { __typename?: 'Query' }
  & { conversationToken: (
    { __typename?: 'ConversationTokenType' }
    & Pick<ConversationTokenType, 'identity' | 'token' | 'flokId'>
  ) }
);

export type SendConversationMessageRequestMutationVariables = Exact<{
  input: SendConversationMessageRequest;
}>;


export type SendConversationMessageRequestMutation = (
  { __typename?: 'Mutation' }
  & { sendConversationMessage: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type InboxQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxQuery = (
  { __typename?: 'Query' }
  & { inbox: (
    { __typename?: 'Inbox' }
    & { messageThreads: Array<(
      { __typename?: 'MessageThread' }
      & Pick<MessageThread, 'messageThreadId'>
      & { latestMessage?: Maybe<(
        { __typename?: 'LatestMessage' }
        & Pick<LatestMessage, 'text' | 'created'>
        & { sender: (
          { __typename?: 'Participant' }
          & Pick<Participant, 'displayName' | 'imageUrl' | 'participantId'>
        ) }
      )>, participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'chatServerIdentity' | 'displayName' | 'imageUrl' | 'participantId'>
      )>, subject?: Maybe<(
        { __typename?: 'Subject' }
        & Pick<Subject, 'subjectId' | 'subjectType'>
      )> }
    )> }
  ) }
);

export type MessageThreadBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type MessageThreadBookingQuery = (
  { __typename?: 'Query' }
  & { booking: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'bookingId' | 'tripId' | 'checkin' | 'checkout' | 'nights' | 'status'>
    & { summary: (
      { __typename?: 'TripSummary' }
      & Pick<TripSummary, 'imageUrl' | 'name'>
      & { location: (
        { __typename?: 'Location' }
        & { address: (
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'city' | 'countryCode'>
        ) }
      ) }
    ) }
  ) }
);

export type MessageThreadResourceScopesQueryVariables = Exact<{
  resourceId: Scalars['ID'];
}>;


export type MessageThreadResourceScopesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'resourceScopes'>
);

export type MyGuestQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type MyGuestQuery = (
  { __typename?: 'Query' }
  & { myGuest?: Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'bookingId' | 'listingId' | 'tripId' | 'bookingReference' | 'checkin' | 'checkout' | 'nights' | 'status'>
    & { guest: (
      { __typename?: 'Guest' }
      & Pick<Guest, 'firstName' | 'imageUrl' | 'lastName'>
    ), summary: (
      { __typename?: 'TripSummary' }
      & Pick<TripSummary, 'imageUrl' | 'name'>
      & { location: (
        { __typename?: 'Location' }
        & { address: (
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'city' | 'countryCode'>
        ) }
      ) }
    ), bookingSupplementsDetails?: Maybe<(
      { __typename?: 'BookingSupplementsDetails' }
      & { supplementDetails: Array<(
        { __typename?: 'BookingSupplementType' }
        & Pick<BookingSupplementType, 'supplementId' | 'iconName' | 'name' | 'description'>
        & { price: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ) }
      )> }
    )> }
  )> }
);

export type MyGuestResourceScopesQueryVariables = Exact<{
  resourceId: Scalars['ID'];
}>;


export type MyGuestResourceScopesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'resourceScopes'>
);

export type MyGuestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGuestsQuery = (
  { __typename?: 'Query' }
  & { myGuests: Array<Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'bookingId' | 'bookingReference' | 'checkin' | 'checkout' | 'listingId' | 'nights' | 'status' | 'tripId'>
    & { guest: (
      { __typename?: 'Guest' }
      & Pick<Guest, 'firstName' | 'imageUrl' | 'lastName'>
    ), summary: (
      { __typename?: 'TripSummary' }
      & Pick<TripSummary, 'imageUrl' | 'name'>
      & { location: (
        { __typename?: 'Location' }
        & { address: (
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'city' | 'countryCode'>
        ) }
      ) }
    ) }
  )>> }
);

export type MyTripHostQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type MyTripHostQuery = (
  { __typename?: 'Query' }
  & { hostingTeamByListing?: Maybe<(
    { __typename?: 'Host' }
    & Pick<Host, 'displayName' | 'imageUrl'>
  )> }
);

export type MyTripQueryVariables = Exact<{
  tripId: Scalars['ID'];
}>;


export type MyTripQuery = (
  { __typename?: 'Query' }
  & { trip: (
    { __typename?: 'Trip' }
    & Pick<Trip, 'tripId'>
    & { bookings: Array<Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'tripId' | 'bookingId' | 'bookingReference' | 'checkin' | 'checkout' | 'listingId' | 'nights' | 'numberOfGuests' | 'status' | 'bookingTimestamp' | 'paymentStatus'>
      & { bookedBy?: Maybe<(
        { __typename?: 'BookedBy' }
        & Pick<BookedBy, 'userId' | 'resellerId'>
      )>, guest: (
        { __typename?: 'Guest' }
        & Pick<Guest, 'externalReference'>
      ), paymentLink?: Maybe<(
        { __typename?: 'PaymentLink' }
        & Pick<PaymentLink, 'psp' | 'url' | 'expiresAt'>
      )>, fees: (
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ) }
      ), summary: (
        { __typename?: 'TripSummary' }
        & Pick<TripSummary, 'imageUrl' | 'name' | 'subtitle'>
        & { location: (
          { __typename?: 'Location' }
          & { address: (
            { __typename?: 'AddressType' }
            & Pick<AddressType, 'city' | 'countryCode'>
          ) }
        ) }
      ), installments?: Maybe<Array<(
        { __typename?: 'BookingInstallment' }
        & Pick<BookingInstallment, 'installmentScheduleId' | 'installmentId' | 'daysPriorTo' | 'percentage' | 'paymentStatus'>
        & { bookingFeeInstallment: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ), commissionFeesInstallment?: Maybe<(
          { __typename?: 'CommissionFees' }
          & Pick<CommissionFees, 'commissionRate'>
          & { commission: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
          ) }
        )> }
      )>> }
    )>> }
  ) }
);

export type MyTripSummaryHostQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type MyTripSummaryHostQuery = (
  { __typename?: 'Query' }
  & { hostingTeamByListing?: Maybe<(
    { __typename?: 'Host' }
    & Pick<Host, 'displayName' | 'imageUrl'>
  )> }
);

export type MyTripsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTripsQuery = (
  { __typename?: 'Query' }
  & { trips: Array<(
    { __typename?: 'Trip' }
    & Pick<Trip, 'tripId'>
    & { bookings: Array<Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'bookingId' | 'bookingTimestamp' | 'listingId' | 'checkin' | 'checkout' | 'status' | 'paymentStatus'>
      & { paymentLink?: Maybe<(
        { __typename?: 'PaymentLink' }
        & Pick<PaymentLink, 'psp' | 'url' | 'expiresAt'>
      )>, summary: (
        { __typename?: 'TripSummary' }
        & Pick<TripSummary, 'imageUrl' | 'name' | 'subtitle'>
        & { location: (
          { __typename?: 'Location' }
          & { address: (
            { __typename?: 'AddressType' }
            & Pick<AddressType, 'city' | 'countryCode'>
          ) }
        ) }
      ) }
    )>> }
  )> }
);

export type PasswordlessLoginExchangeAuthCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type PasswordlessLoginExchangeAuthCodeQuery = (
  { __typename?: 'Query' }
  & { exchangeAuthCode: (
    { __typename?: 'AccessToken' }
    & Pick<AccessToken, 'accessToken' | 'expiresIn' | 'tokenType'>
  ) }
);

export type ListingsByMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type ListingsByMemberQuery = (
  { __typename?: 'Query' }
  & { listingsByMember: Array<(
    { __typename?: 'Listing' }
    & { summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'highlightedAmenities' | 'title' | 'subtitle'>
      & { highlightedFeatures: (
        { __typename?: 'HighlightedFeatures' }
        & { features: Array<(
          { __typename?: 'ListingHighlightedFeature' }
          & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
        )> }
      ), photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover'>
      )> }
    ) }
  )> }
);

export type PropertiesQueryVariables = Exact<{
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type PropertiesQuery = (
  { __typename?: 'Query' }
  & { properties: Array<(
    { __typename?: 'Property' }
    & Pick<Property, 'propertyId' | 'status'>
    & { general?: Maybe<(
      { __typename?: 'PropertyGeneral' }
      & Pick<PropertyGeneral, 'name'>
    )>, imagery: (
      { __typename?: 'PropertyImagery' }
      & { photos?: Maybe<Array<Maybe<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover'>
      )>>> }
    ) }
  )> }
);

export type PropertiesListingOnboardingStatusQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type PropertiesListingOnboardingStatusQuery = (
  { __typename?: 'Query' }
  & { listingOnboardingStatus?: Maybe<(
    { __typename?: 'ListingOnboardingStatus' }
    & Pick<ListingOnboardingStatus, 'completed'>
  )> }
);

export type StartPropertyOnboardingMutationVariables = Exact<{
  input: StartPropertyOnboardingCommand;
}>;


export type StartPropertyOnboardingMutation = (
  { __typename?: 'Mutation' }
  & { startPropertyOnboarding: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ExportUrlQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ExportUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'exportUrl'>
);

export type UpdateBookingSettingsMutationVariables = Exact<{
  input: UpdateBookingSettingsCommand;
}>;


export type UpdateBookingSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateBookingSettings: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type UpdateBookingSettingsListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type UpdateBookingSettingsListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'allowInstantBook'>
  ) }
);

export type PropertyHeaderListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type PropertyHeaderListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & { summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle'>
      & { photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url'>
      )> }
    ) }
  ) }
);

export type ListingOnboardingInProgressOnboardingStatusQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingOnboardingInProgressOnboardingStatusQuery = (
  { __typename?: 'Query' }
  & { listingOnboardingStatus?: Maybe<(
    { __typename?: 'ListingOnboardingStatus' }
    & Pick<ListingOnboardingStatus, 'completed'>
  )> }
);

export type DepositDaysListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type DepositDaysListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'status' | 'listingId'>
    & { asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
    ), summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle'>
      & { photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover'>
      )> }
    ) }
  ) }
);

export type PayMembershipSubscriptionMutationVariables = Exact<{
  input: PayMembershipSubscriptionRequest;
}>;


export type PayMembershipSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { payMembershipSubscription: (
    { __typename?: 'CheckoutSession' }
    & Pick<CheckoutSession, 'sessionId'>
  ) }
);

export type PayMembershipSubscriptionAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type PayMembershipSubscriptionAccountQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
    & { membership?: Maybe<(
      { __typename?: 'Membership' }
      & { membershipPlan: (
        { __typename?: 'MembershipPlan' }
        & Pick<MembershipPlan, 'id' | 'title' | 'description'>
      ) }
    )> }
  )> }
);

export type PayMembershipSubscriptionEligibleSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PayMembershipSubscriptionEligibleSubscriptionsQuery = (
  { __typename?: 'Query' }
  & { eligibleMembershipSubscriptions: Array<(
    { __typename?: 'MembershipSubscription' }
    & Pick<MembershipSubscription, 'billingPeriod'>
    & { membershipPlan: (
      { __typename?: 'MembershipPlan' }
      & Pick<MembershipPlan, 'id' | 'title' | 'description'>
    ), recurringPrice: (
      { __typename?: 'CurrencyAmountType' }
      & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
    ) }
  )> }
);

export type CompletePropertyOnboardingAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CompletePropertyOnboardingAccountQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'accountId'>
    & { membership?: Maybe<(
      { __typename?: 'Membership' }
      & { membershipPlan: (
        { __typename?: 'MembershipPlan' }
        & Pick<MembershipPlan, 'id' | 'title' | 'description'>
      ) }
    )> }
  )> }
);

export type CompletePropertyOnboardingStatusQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type CompletePropertyOnboardingStatusQuery = (
  { __typename?: 'Query' }
  & { listingOnboardingStatus?: Maybe<(
    { __typename?: 'ListingOnboardingStatus' }
    & Pick<ListingOnboardingStatus, 'assetOnboardingCompleted' | 'completed' | 'meetsMinimumRequiredAvailability' | 'memberOnboardingCompleted' | 'canInviteOwner' | 'ownerAssigned' | 'hostingTeamAssigned' | 'readyForPublishing'>
  )> }
);

export type CompletePropertyOnboardingPublishListingMutationVariables = Exact<{
  input: PublishListingCommand;
}>;


export type CompletePropertyOnboardingPublishListingMutation = (
  { __typename?: 'Mutation' }
  & { publishListing: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CompletePropertyOnboardingReferMemberMutationVariables = Exact<{
  input: ReferMemberCommand;
}>;


export type CompletePropertyOnboardingReferMemberMutation = (
  { __typename?: 'Mutation' }
  & { referMember: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type ListingOnboardingFinishedOnboardingStatusQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingOnboardingFinishedOnboardingStatusQuery = (
  { __typename?: 'Query' }
  & { listingOnboardingStatus?: Maybe<(
    { __typename?: 'ListingOnboardingStatus' }
    & Pick<ListingOnboardingStatus, 'completed'>
  )> }
);

export type PublicListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type PublicListingQuery = (
  { __typename?: 'Query' }
  & { listing: (
    { __typename?: 'Listing' }
    & Pick<Listing, 'listingId' | 'status' | 'allowInstantBook'>
    & { fees?: Maybe<(
      { __typename?: 'Fees' }
      & Pick<Fees, 'bookingToken'>
      & { bookingFee: (
        { __typename?: 'CurrencyAmountType' }
        & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
      ) }
    )>, priceRange?: Maybe<(
      { __typename?: 'PriceRange' }
      & { lowest: (
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        ) }
      ), highest: (
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ) }
      ) }
    )>, asset: (
      { __typename?: 'Asset' }
      & Pick<Asset, 'assetId' | 'assetType'>
      & { documentLibrary: (
        { __typename?: 'DocumentLibrary' }
        & Pick<DocumentLibrary, 'documentLibraryId'>
        & { categories?: Maybe<Array<(
          { __typename?: 'DocumentCategory' }
          & Pick<DocumentCategory, 'documentCategoryId' | 'documentLibraryId' | 'name' | 'isDefaultCategory'>
          & { documents?: Maybe<Array<(
            { __typename?: 'Document' }
            & Pick<Document, 'documentId' | 'documentCategoryId' | 'documentLibraryId' | 'name' | 'url'>
          )>> }
        )>> }
      ) }
    ), availabilityCalendar: (
      { __typename?: 'AvailabilityCalendar' }
      & { dailyAllocations: Array<Maybe<(
        { __typename?: 'DailyAllocationType' }
        & Pick<DailyAllocationType, 'allocated' | 'day' | 'consumed'>
      )>> }
    ), obfuscatedLocation: (
      { __typename?: 'ObfuscatedLocation' }
      & Pick<ObfuscatedLocation, 'range'>
      & { location: (
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lng'>
      ) }
    ), summary: (
      { __typename?: 'ListingSummary' }
      & Pick<ListingSummary, 'city' | 'countryCode' | 'title' | 'subtitle' | 'highlightedAmenities'>
      & { highlightedFeatures: (
        { __typename?: 'HighlightedFeatures' }
        & { features: Array<(
          { __typename?: 'ListingHighlightedFeature' }
          & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
        )> }
      ), houseRules: (
        { __typename?: 'ListingHouseRules' }
        & Pick<ListingHouseRules, 'otherRules'>
        & { rules: Array<(
          { __typename?: 'ListingHouseRule' }
          & Pick<ListingHouseRule, 'enabled' | 'icon' | 'subtitle' | 'title'>
        )> }
      ), photos: Array<(
        { __typename?: 'AssetPhotoType' }
        & Pick<AssetPhotoType, 'url' | 'useAsCover' | 'description'>
      )> }
    ), stayDurationConditions: (
      { __typename?: 'StayDurationConditions' }
      & Pick<StayDurationConditions, 'minimum'>
    ), operator?: Maybe<(
      { __typename?: 'Operator' }
      & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
    )>, installmentSchedule?: Maybe<(
      { __typename?: 'InstallmentSchedule' }
      & Pick<InstallmentSchedule, 'installmentScheduleId'>
      & { installments: Array<(
        { __typename?: 'Installment' }
        & Pick<Installment, 'installmentScheduleId' | 'installmentId' | 'daysPriorTo' | 'percentage'>
      )> }
    )>, documentLibrary: (
      { __typename?: 'DocumentLibrary' }
      & Pick<DocumentLibrary, 'documentLibraryId'>
      & { categories?: Maybe<Array<(
        { __typename?: 'DocumentCategory' }
        & Pick<DocumentCategory, 'documentCategoryId' | 'documentLibraryId' | 'name' | 'isDefaultCategory'>
        & { documents?: Maybe<Array<(
          { __typename?: 'Document' }
          & Pick<Document, 'documentId' | 'documentCategoryId' | 'documentLibraryId' | 'name' | 'url'>
        )>> }
      )>> }
    ) }
  ) }
);

export type PublicWishlistListingsQueryVariables = Exact<{
  wishlistId: Scalars['ID'];
}>;


export type PublicWishlistListingsQuery = (
  { __typename?: 'Query' }
  & { publicWishlist?: Maybe<(
    { __typename?: 'PublicWishlist' }
    & Pick<PublicWishlist, 'wishlistId' | 'name'>
    & { wishes: Array<(
      { __typename?: 'PublicWish' }
      & Pick<PublicWish, 'wishId'>
      & { travelDates?: Maybe<(
        { __typename?: 'TravelDatesType' }
        & Pick<TravelDatesType, 'checkin' | 'checkout'>
      )>, guestCounts?: Maybe<Array<(
        { __typename?: 'GuestCountType' }
        & Pick<GuestCountType, 'key' | 'count'>
      )>>, priceModification?: Maybe<(
        { __typename?: 'PriceModificationType' }
        & { adjustedBookingFee?: Maybe<(
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        )> }
      )>, searchListing: (
        { __typename?: 'SearchListing' }
        & Pick<SearchListing, 'listingId' | 'status' | 'availabilityType'>
        & { asset: (
          { __typename?: 'Asset' }
          & Pick<Asset, 'assetId'>
        ), fees?: Maybe<(
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
          ) }
        )>, priceRange?: Maybe<(
          { __typename?: 'PriceRange' }
          & { lowest: (
            { __typename?: 'Fees' }
            & { bookingFee: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
            ) }
          ), highest: (
            { __typename?: 'Fees' }
            & { bookingFee: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
            ) }
          ) }
        )>, availableFrom?: Maybe<(
          { __typename?: 'DateRange' }
          & Pick<DateRange, 'start' | 'end'>
        )>, summary: (
          { __typename?: 'ListingSummary' }
          & Pick<ListingSummary, 'city' | 'countryCode' | 'highlightedAmenities' | 'title' | 'subtitle' | 'assetDescription' | 'listingDescription'>
          & { highlightedFeatures: (
            { __typename?: 'HighlightedFeatures' }
            & { features: Array<(
              { __typename?: 'ListingHighlightedFeature' }
              & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
            )> }
          ), decidingFactors: (
            { __typename?: 'DecidingFactors' }
            & { primaryDecidingFactors: Array<(
              { __typename?: 'DecidingFactor' }
              & Pick<DecidingFactor, 'enabled' | 'icon' | 'title' | 'subtitle'>
            )> }
          ), photos: Array<(
            { __typename?: 'AssetPhotoType' }
            & Pick<AssetPhotoType, 'url' | 'useAsCover'>
          )>, listingPhotos: Array<(
            { __typename?: 'AssetPhotoType' }
            & Pick<AssetPhotoType, 'url' | 'useAsCover'>
          )> }
        ), operator?: Maybe<(
          { __typename?: 'Operator' }
          & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
        )> }
      ) }
    )> }
  )> }
);

export type SearchCriteriaBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchCriteriaBrandsQuery = (
  { __typename?: 'Query' }
  & { brands: Array<(
    { __typename?: 'Brand' }
    & Pick<Brand, 'brandId' | 'name' | 'logoUrl'>
  )> }
);

export type SearchCriteriaVisibilityConstraintQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchCriteriaVisibilityConstraintQuery = (
  { __typename?: 'Query' }
  & { visibilityConstraint: (
    { __typename?: 'VisibilityConstraint' }
    & Pick<VisibilityConstraint, 'canSeeExchangeProperties' | 'canSeeRentalProperties' | 'canSeeHotels'>
  ) }
);

export type SearchCriteriaWhereToMenuOptionsQueryVariables = Exact<{
  includeComingSoon: Scalars['Boolean'];
  availabilityTypes: Array<Maybe<AvailabilityType>> | Maybe<AvailabilityType>;
}>;


export type SearchCriteriaWhereToMenuOptionsQuery = (
  { __typename?: 'Query' }
  & { searchOptions: (
    { __typename?: 'SearchOptions' }
    & { groupedRegions: Array<(
      { __typename?: 'SearchGroupedRegions' }
      & Pick<SearchGroupedRegions, 'groupName'>
      & { regions: Array<(
        { __typename?: 'SearchRegion' }
        & Pick<SearchRegion, 'parentRegionId' | 'regionId' | 'name'>
        & { boundingBox?: Maybe<(
          { __typename?: 'BoundingBox' }
          & Pick<BoundingBox, 'swLat' | 'swLng' | 'neLat' | 'neLng'>
        )> }
      )> }
    )> }
  ) }
);

export type RecordListingVisitMutationVariables = Exact<{
  input: RecordListingVisit;
}>;


export type RecordListingVisitMutation = (
  { __typename?: 'Mutation' }
  & { recordListingVisit: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type SearchListingsQueryVariables = Exact<{
  input: Criteria;
}>;


export type SearchListingsQuery = (
  { __typename?: 'Query' }
  & { searchListings: (
    { __typename?: 'SearchResults' }
    & Pick<SearchResults, 'searchId' | 'count'>
    & { paging: (
      { __typename?: 'SearchResultPaging' }
      & Pick<SearchResultPaging, 'offset' | 'size' | 'pageNumber'>
    ), results: Array<(
      { __typename?: 'SearchListing' }
      & Pick<SearchListing, 'listingId' | 'status' | 'availabilityType'>
      & { fees?: Maybe<(
        { __typename?: 'Fees' }
        & { bookingFee: (
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
        ) }
      )>, priceRange?: Maybe<(
        { __typename?: 'PriceRange' }
        & { lowest: (
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
          ) }
        ), highest: (
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
          ) }
        ) }
      )>, commission?: Maybe<(
        { __typename?: 'Commission' }
        & Pick<Commission, 'rate'>
      )>, availableFrom?: Maybe<(
        { __typename?: 'DateRange' }
        & Pick<DateRange, 'start' | 'end'>
      )>, summary: (
        { __typename?: 'ListingSummary' }
        & Pick<ListingSummary, 'city' | 'countryCode' | 'highlightedAmenities' | 'title' | 'subtitle'>
        & { highlightedFeatures: (
          { __typename?: 'HighlightedFeatures' }
          & { features: Array<(
            { __typename?: 'ListingHighlightedFeature' }
            & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
          )> }
        ), decidingFactors: (
          { __typename?: 'DecidingFactors' }
          & { primaryDecidingFactors: Array<(
            { __typename?: 'DecidingFactor' }
            & Pick<DecidingFactor, 'enabled' | 'icon' | 'title' | 'subtitle'>
          )> }
        ), photos: Array<(
          { __typename?: 'AssetPhotoType' }
          & Pick<AssetPhotoType, 'url' | 'useAsCover'>
        )> }
      ), obfuscatedLocation: (
        { __typename?: 'ObfuscatedLocation' }
        & { location: (
          { __typename?: 'GeoLocation' }
          & Pick<GeoLocation, 'lat' | 'lng'>
        ) }
      ), operator?: Maybe<(
        { __typename?: 'Operator' }
        & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
      )> }
    )> }
  ) }
);

export type AddToWishlistWishlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type AddToWishlistWishlistsQuery = (
  { __typename?: 'Query' }
  & { wishlists?: Maybe<Array<Maybe<(
    { __typename?: 'Wishlist' }
    & Pick<Wishlist, 'wishlistId' | 'userId' | 'name' | 'status'>
    & { wishes: Array<(
      { __typename?: 'Wish' }
      & Pick<Wish, 'wishId' | 'notes'>
      & { searchListing: (
        { __typename?: 'SearchListing' }
        & Pick<SearchListing, 'listingId'>
      ), travelDates?: Maybe<(
        { __typename?: 'TravelDatesType' }
        & Pick<TravelDatesType, 'checkin' | 'checkout'>
      )>, guestCounts?: Maybe<Array<(
        { __typename?: 'GuestCountType' }
        & Pick<GuestCountType, 'key' | 'count'>
      )>>, priceModification?: Maybe<(
        { __typename?: 'PriceModificationType' }
        & { adjustedBookingFee?: Maybe<(
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        )> }
      )> }
    )> }
  )>>> }
);

export type AddWishToWishlistMutationVariables = Exact<{
  input: AddWishToWishlistCommand;
}>;


export type AddWishToWishlistMutation = (
  { __typename?: 'Mutation' }
  & { addWishToWishlist: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type RemoveWishFromWishlistMutationVariables = Exact<{
  input: RemoveWishFromWishlistCommand;
}>;


export type RemoveWishFromWishlistMutation = (
  { __typename?: 'Mutation' }
  & { removeWishFromWishlist: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type CreateWishlistMutationVariables = Exact<{
  input: CreateWishlistCommand;
}>;


export type CreateWishlistMutation = (
  { __typename?: 'Mutation' }
  & { createWishlist: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type SelectWishlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectWishlistsQuery = (
  { __typename?: 'Query' }
  & { wishlists?: Maybe<Array<Maybe<(
    { __typename?: 'Wishlist' }
    & Pick<Wishlist, 'wishlistId' | 'userId' | 'name' | 'status'>
    & { wishes: Array<(
      { __typename?: 'Wish' }
      & Pick<Wish, 'wishId'>
      & { searchListing: (
        { __typename?: 'SearchListing' }
        & Pick<SearchListing, 'listingId'>
      ) }
    )> }
  )>>> }
);

export type UpdateWishlistMutationVariables = Exact<{
  input: UpdateWishlistCommand;
}>;


export type UpdateWishlistMutation = (
  { __typename?: 'Mutation' }
  & { updateWishlist: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export type WishlistQueryVariables = Exact<{
  wishlistId: Scalars['ID'];
}>;


export type WishlistQuery = (
  { __typename?: 'Query' }
  & { wishlist?: Maybe<(
    { __typename?: 'Wishlist' }
    & Pick<Wishlist, 'wishlistId' | 'userId' | 'name' | 'status'>
    & { wishes: Array<(
      { __typename?: 'Wish' }
      & Pick<Wish, 'wishId'>
      & { travelDates?: Maybe<(
        { __typename?: 'TravelDatesType' }
        & Pick<TravelDatesType, 'checkin' | 'checkout'>
      )>, guestCounts?: Maybe<Array<(
        { __typename?: 'GuestCountType' }
        & Pick<GuestCountType, 'key' | 'count'>
      )>>, priceModification?: Maybe<(
        { __typename?: 'PriceModificationType' }
        & { adjustedBookingFee?: Maybe<(
          { __typename?: 'CurrencyAmountType' }
          & Pick<CurrencyAmountType, 'currency' | 'amountMicros'>
        )> }
      )>, searchListing: (
        { __typename?: 'SearchListing' }
        & Pick<SearchListing, 'listingId' | 'status' | 'availabilityType'>
        & { fees?: Maybe<(
          { __typename?: 'Fees' }
          & { bookingFee: (
            { __typename?: 'CurrencyAmountType' }
            & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
          ) }
        )>, priceRange?: Maybe<(
          { __typename?: 'PriceRange' }
          & { lowest: (
            { __typename?: 'Fees' }
            & { bookingFee: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
            ) }
          ), highest: (
            { __typename?: 'Fees' }
            & { bookingFee: (
              { __typename?: 'CurrencyAmountType' }
              & Pick<CurrencyAmountType, 'amountMicros' | 'currency'>
            ) }
          ) }
        )>, availableFrom?: Maybe<(
          { __typename?: 'DateRange' }
          & Pick<DateRange, 'start' | 'end'>
        )>, summary: (
          { __typename?: 'ListingSummary' }
          & Pick<ListingSummary, 'city' | 'countryCode' | 'highlightedAmenities' | 'title' | 'subtitle'>
          & { highlightedFeatures: (
            { __typename?: 'HighlightedFeatures' }
            & { features: Array<(
              { __typename?: 'ListingHighlightedFeature' }
              & Pick<ListingHighlightedFeature, 'iconName' | 'title' | 'description'>
            )> }
          ), decidingFactors: (
            { __typename?: 'DecidingFactors' }
            & { primaryDecidingFactors: Array<(
              { __typename?: 'DecidingFactor' }
              & Pick<DecidingFactor, 'enabled' | 'icon' | 'title' | 'subtitle'>
            )> }
          ), photos: Array<(
            { __typename?: 'AssetPhotoType' }
            & Pick<AssetPhotoType, 'url' | 'useAsCover'>
          )>, listingPhotos: Array<(
            { __typename?: 'AssetPhotoType' }
            & Pick<AssetPhotoType, 'url' | 'useAsCover'>
          )> }
        ), operator?: Maybe<(
          { __typename?: 'Operator' }
          & Pick<Operator, 'operatorId' | 'name' | 'logoUrl'>
        )> }
      ) }
    )> }
  )> }
);

export type WishlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type WishlistsQuery = (
  { __typename?: 'Query' }
  & { wishlists?: Maybe<Array<Maybe<(
    { __typename?: 'Wishlist' }
    & Pick<Wishlist, 'wishlistId' | 'userId' | 'name' | 'status'>
    & { wishes: Array<(
      { __typename?: 'Wish' }
      & Pick<Wish, 'wishId'>
      & { travelDates?: Maybe<(
        { __typename?: 'TravelDatesType' }
        & Pick<TravelDatesType, 'checkin' | 'checkout'>
      )>, searchListing: (
        { __typename?: 'SearchListing' }
        & Pick<SearchListing, 'listingId'>
      ) }
    )> }
  )>>> }
);

export type ExpireWishlistMutationVariables = Exact<{
  input: ExpireWishlistCommand;
}>;


export type ExpireWishlistMutation = (
  { __typename?: 'Mutation' }
  & { expireWishlist: (
    { __typename?: 'InputAcceptedResponse' }
    & Pick<InputAcceptedResponse, 'id'>
  ) }
);

export const PresentmentCurrencyExchangeRatesDocument = gql`
    query PresentmentCurrencyExchangeRates {
  presentmentCurrencyExchangeRates {
    currency
    rate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PresentmentCurrencyExchangeRatesGQL extends Apollo.Query<PresentmentCurrencyExchangeRatesQuery, PresentmentCurrencyExchangeRatesQueryVariables> {
    document = PresentmentCurrencyExchangeRatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceInvitationStatusDocument = gql`
    query InvitationServiceInvitationStatus($invitationId: ID!) {
  invitationStatus(invitationId: $invitationId) {
    acceptedOn
    role
    assetId
    email
    firstName
    lastName
    userExistsOnIdentityProvider
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceInvitationStatusGQL extends Apollo.Query<InvitationServiceInvitationStatusQuery, InvitationServiceInvitationStatusQueryVariables> {
    document = InvitationServiceInvitationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAssetOwnerInvitationSummaryDocument = gql`
    query InvitationServiceAssetOwnerInvitationSummary($invitationId: ID!) {
  assetOwnerInvitationSummary(invitationId: $invitationId) {
    invitationId
    assetId
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAssetOwnerInvitationSummaryGQL extends Apollo.Query<InvitationServiceAssetOwnerInvitationSummaryQuery, InvitationServiceAssetOwnerInvitationSummaryQueryVariables> {
    document = InvitationServiceAssetOwnerInvitationSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceBrandBusinessOwnerInvitationStatusDocument = gql`
    query InvitationServiceBrandBusinessOwnerInvitationStatus($invitationId: ID!) {
  brandBusinessOwnerInvitation(invitationId: $invitationId) {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceBrandBusinessOwnerInvitationStatusGQL extends Apollo.Query<InvitationServiceBrandBusinessOwnerInvitationStatusQuery, InvitationServiceBrandBusinessOwnerInvitationStatusQueryVariables> {
    document = InvitationServiceBrandBusinessOwnerInvitationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServicePmcBusinessOwnerInvitationStatusDocument = gql`
    query InvitationServicePmcBusinessOwnerInvitationStatus($invitationId: ID!) {
  pmcBusinessOwnerInvitation(invitationId: $invitationId) {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServicePmcBusinessOwnerInvitationStatusGQL extends Apollo.Query<InvitationServicePmcBusinessOwnerInvitationStatusQuery, InvitationServicePmcBusinessOwnerInvitationStatusQueryVariables> {
    document = InvitationServicePmcBusinessOwnerInvitationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceStaffMemberInvitationSummaryDocument = gql`
    query InvitationServiceStaffMemberInvitationSummary($invitationId: ID!) {
  staffMemberInvitationSummary(invitationId: $invitationId) {
    invitationId
    staffId
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceStaffMemberInvitationSummaryGQL extends Apollo.Query<InvitationServiceStaffMemberInvitationSummaryQuery, InvitationServiceStaffMemberInvitationSummaryQueryVariables> {
    document = InvitationServiceStaffMemberInvitationSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceTravelAgentBusinessOwnerInvitationStatusDocument = gql`
    query InvitationServiceTravelAgentBusinessOwnerInvitationStatus($invitationId: ID!) {
  travelAgentBusinessOwnerInvitation(invitationId: $invitationId) {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceTravelAgentBusinessOwnerInvitationStatusGQL extends Apollo.Query<InvitationServiceTravelAgentBusinessOwnerInvitationStatusQuery, InvitationServiceTravelAgentBusinessOwnerInvitationStatusQueryVariables> {
    document = InvitationServiceTravelAgentBusinessOwnerInvitationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptAssetOwnerInvitationDocument = gql`
    mutation InvitationServiceAcceptAssetOwnerInvitation($input: AcceptAssetOwnerInvitationCommand!) {
  acceptAssetOwnerInvitation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptAssetOwnerInvitationGQL extends Apollo.Mutation<InvitationServiceAcceptAssetOwnerInvitationMutation, InvitationServiceAcceptAssetOwnerInvitationMutationVariables> {
    document = InvitationServiceAcceptAssetOwnerInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptBrandBusinessOwnerInvitationDocument = gql`
    mutation InvitationServiceAcceptBrandBusinessOwnerInvitation($invitationId: ID!) {
  acceptBrandBusinessOwnerInvitation(invitationId: $invitationId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptBrandBusinessOwnerInvitationGQL extends Apollo.Mutation<InvitationServiceAcceptBrandBusinessOwnerInvitationMutation, InvitationServiceAcceptBrandBusinessOwnerInvitationMutationVariables> {
    document = InvitationServiceAcceptBrandBusinessOwnerInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptPmcBusinessOwnerInvitationDocument = gql`
    mutation InvitationServiceAcceptPmcBusinessOwnerInvitation($invitationId: ID!) {
  acceptPmcBusinessOwnerInvitation(invitationId: $invitationId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptPmcBusinessOwnerInvitationGQL extends Apollo.Mutation<InvitationServiceAcceptPmcBusinessOwnerInvitationMutation, InvitationServiceAcceptPmcBusinessOwnerInvitationMutationVariables> {
    document = InvitationServiceAcceptPmcBusinessOwnerInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptStaffMemberInvitationDocument = gql`
    mutation InvitationServiceAcceptStaffMemberInvitation($input: AcceptStaffMemberInvitationCommand!) {
  acceptStaffMemberInvitation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptStaffMemberInvitationGQL extends Apollo.Mutation<InvitationServiceAcceptStaffMemberInvitationMutation, InvitationServiceAcceptStaffMemberInvitationMutationVariables> {
    document = InvitationServiceAcceptStaffMemberInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptTravelAgentBusinessOwnerInvitationDocument = gql`
    mutation InvitationServiceAcceptTravelAgentBusinessOwnerInvitation($invitationId: ID!) {
  acceptTravelAgentBusinessOwnerInvitation(invitationId: $invitationId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptTravelAgentBusinessOwnerInvitationGQL extends Apollo.Mutation<InvitationServiceAcceptTravelAgentBusinessOwnerInvitationMutation, InvitationServiceAcceptTravelAgentBusinessOwnerInvitationMutationVariables> {
    document = InvitationServiceAcceptTravelAgentBusinessOwnerInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceUpdatePhoneDocument = gql`
    mutation InvitationServiceUpdatePhone($input: UpdatePersonalPhoneNumberCommand!) {
  updatePersonalPhoneNumber(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceUpdatePhoneGQL extends Apollo.Mutation<InvitationServiceUpdatePhoneMutation, InvitationServiceUpdatePhoneMutationVariables> {
    document = InvitationServiceUpdatePhoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitationServiceAcceptTermsDocument = gql`
    mutation InvitationServiceAcceptTerms($input: AcceptConsumerTermsAndConditionsCommand!) {
  acceptConsumerTermsAndConditions(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitationServiceAcceptTermsGQL extends Apollo.Mutation<InvitationServiceAcceptTermsMutation, InvitationServiceAcceptTermsMutationVariables> {
    document = InvitationServiceAcceptTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TextSearchIndexDocument = gql`
    query TextSearchIndex {
  textSearchIndex {
    listings {
      name
      listingId
      locationName
      operatorName
      nonDisplayFields
    }
    destinations {
      name
      boundingBox {
        swLat
        swLng
        neLat
        neLng
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TextSearchIndexGQL extends Apollo.Query<TextSearchIndexQuery, TextSearchIndexQueryVariables> {
    document = TextSearchIndexDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleManagerAccountDocument = gql`
    query RoleManagerAccount {
  account {
    accountId
    accountHolderId
    personalProfile {
      email
      firstName
      lastName
      photoUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleManagerAccountGQL extends Apollo.Query<RoleManagerAccountQuery, RoleManagerAccountQueryVariables> {
    document = RoleManagerAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleManagerRolesDocument = gql`
    query RoleManagerRoles {
  roles
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleManagerRolesGQL extends Apollo.Query<RoleManagerRolesQuery, RoleManagerRolesQueryVariables> {
    document = RoleManagerRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleManagerMemberOnboardingStatusDocument = gql`
    query RoleManagerMemberOnboardingStatus {
  memberOnboardingStatus {
    completed
    assetBeingOnboarded {
      assetId
      assetType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleManagerMemberOnboardingStatusGQL extends Apollo.Query<RoleManagerMemberOnboardingStatusQuery, RoleManagerMemberOnboardingStatusQueryVariables> {
    document = RoleManagerMemberOnboardingStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeManagerScopesDocument = gql`
    query ScopeManagerScopes {
  scopes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeManagerScopesGQL extends Apollo.Query<ScopeManagerScopesQuery, ScopeManagerScopesQueryVariables> {
    document = ScopeManagerScopesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeManagerResourceScopesDocument = gql`
    query ScopeManagerResourceScopes($resourceId: ID!) {
  resourceScopes(resourceId: $resourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeManagerResourceScopesGQL extends Apollo.Query<ScopeManagerResourceScopesQuery, ScopeManagerResourceScopesQueryVariables> {
    document = ScopeManagerResourceScopesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupportChatDocument = gql`
    query SupportChat {
  supportChat {
    identificationToken
    identificationEmail
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupportChatGQL extends Apollo.Query<SupportChatQuery, SupportChatQueryVariables> {
    document = SupportChatDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TravelAgentByStaffMemberDocument = gql`
    query TravelAgentByStaffMember($staffMemberId: ID!) {
  travelAgentByStaffMember(staffMemberId: $staffMemberId) {
    travelAgentId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TravelAgentByStaffMemberGQL extends Apollo.Query<TravelAgentByStaffMemberQuery, TravelAgentByStaffMemberQueryVariables> {
    document = TravelAgentByStaffMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TravelAgentClienteleByBusinessIdDocument = gql`
    query TravelAgentClienteleByBusinessId($businessId: ID!) {
  clienteleByBusinessId(businessId: $businessId) {
    clienteleId
    businessId
    customers {
      userId
      firstName
      lastName
      email
      phoneNumber {
        countryCode
        nationalNumber
      }
      photoUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TravelAgentClienteleByBusinessIdGQL extends Apollo.Query<TravelAgentClienteleByBusinessIdQuery, TravelAgentClienteleByBusinessIdQueryVariables> {
    document = TravelAgentClienteleByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TravelAgentResellerByBusinessIdDocument = gql`
    query TravelAgentResellerByBusinessId($businessId: ID!) {
  resellerByBusinessId(businessId: $businessId) {
    resellerId
    businessId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TravelAgentResellerByBusinessIdGQL extends Apollo.Query<TravelAgentResellerByBusinessIdQuery, TravelAgentResellerByBusinessIdQueryVariables> {
    document = TravelAgentResellerByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptBookingDocument = gql`
    mutation AcceptBooking($input: AcceptBookingRequest!) {
  acceptBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptBookingGQL extends Apollo.Mutation<AcceptBookingMutation, AcceptBookingMutationVariables> {
    document = AcceptBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptBookingBookingDocument = gql`
    query AcceptBookingBooking($bookingId: ID!) {
  booking(bookingId: $bookingId) {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptBookingBookingGQL extends Apollo.Query<AcceptBookingBookingQuery, AcceptBookingBookingQueryVariables> {
    document = AcceptBookingBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusinessCustomerAutocompleteAddBusinessCustomerToClienteleDocument = gql`
    mutation BusinessCustomerAutocompleteAddBusinessCustomerToClientele($input: AddBusinessCustomerToClienteleCommand!) {
  addBusinessCustomerToClientele(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusinessCustomerAutocompleteAddBusinessCustomerToClienteleGQL extends Apollo.Mutation<BusinessCustomerAutocompleteAddBusinessCustomerToClienteleMutation, BusinessCustomerAutocompleteAddBusinessCustomerToClienteleMutationVariables> {
    document = BusinessCustomerAutocompleteAddBusinessCustomerToClienteleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusinessCustomerUserExistsDocument = gql`
    query BusinessCustomerUserExists($email: String!) {
  userExists(email: $email) {
    userId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusinessCustomerUserExistsGQL extends Apollo.Query<BusinessCustomerUserExistsQuery, BusinessCustomerUserExistsQueryVariables> {
    document = BusinessCustomerUserExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBusinessCustomerDocument = gql`
    mutation CreateBusinessCustomer($input: CreateBusinessCustomerRequest!) {
  createBusinessCustomer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBusinessCustomerGQL extends Apollo.Mutation<CreateBusinessCustomerMutation, CreateBusinessCustomerMutationVariables> {
    document = CreateBusinessCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarListingAllocateDailyAvailabilityDocument = gql`
    mutation CalendarListingAllocateDailyAvailability($input: AllocateDailyAvailabilityCommand!) {
  allocateDailyAvailability(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarListingAllocateDailyAvailabilityGQL extends Apollo.Mutation<CalendarListingAllocateDailyAvailabilityMutation, CalendarListingAllocateDailyAvailabilityMutationVariables> {
    document = CalendarListingAllocateDailyAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarListingAllocateMonthlyAvailabilityDocument = gql`
    mutation CalendarListingAllocateMonthlyAvailability($input: AllocateMonthlyAvailabilityCommand!) {
  allocateMonthlyAvailability(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarListingAllocateMonthlyAvailabilityGQL extends Apollo.Mutation<CalendarListingAllocateMonthlyAvailabilityMutation, CalendarListingAllocateMonthlyAvailabilityMutationVariables> {
    document = CalendarListingAllocateMonthlyAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarListingAllocateInitialMonthlyAvailabilityDocument = gql`
    mutation CalendarListingAllocateInitialMonthlyAvailability($input: AllocateInitialMonthlyAvailabilityRequest!) {
  allocateInitialMonthlyAvailability(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarListingAllocateInitialMonthlyAvailabilityGQL extends Apollo.Mutation<CalendarListingAllocateInitialMonthlyAvailabilityMutation, CalendarListingAllocateInitialMonthlyAvailabilityMutationVariables> {
    document = CalendarListingAllocateInitialMonthlyAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarListingMinimumRequiredAvailabilityDocument = gql`
    query CalendarListingMinimumRequiredAvailability($listingId: ID!) {
  minimumRequiredAvailability(listingId: $listingId) {
    required {
      minimumDays
      seasonality
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarListingMinimumRequiredAvailabilityGQL extends Apollo.Query<CalendarListingMinimumRequiredAvailabilityQuery, CalendarListingMinimumRequiredAvailabilityQueryVariables> {
    document = CalendarListingMinimumRequiredAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepositCalendarListingDocument = gql`
    query DepositCalendarListing($listingId: ID!) {
  listing(listingId: $listingId) {
    listingId
    status
    availabilityCalendar {
      dailyAllocations {
        allocated
        consumed
        day
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepositCalendarListingGQL extends Apollo.Query<DepositCalendarListingQuery, DepositCalendarListingQueryVariables> {
    document = DepositCalendarListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepositCalendarLinkedCalendarsDocument = gql`
    query DepositCalendarLinkedCalendars($listingId: ID!) {
  linkedCalendars(listingId: $listingId) {
    externalUrl
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepositCalendarLinkedCalendarsGQL extends Apollo.Query<DepositCalendarLinkedCalendarsQuery, DepositCalendarLinkedCalendarsQueryVariables> {
    document = DepositCalendarLinkedCalendarsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkExternalCalendarDocument = gql`
    mutation LinkExternalCalendar($input: LinkExternalCalendarCommand!) {
  linkExternalCalendar(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkExternalCalendarGQL extends Apollo.Mutation<LinkExternalCalendarMutation, LinkExternalCalendarMutationVariables> {
    document = LinkExternalCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkedCalendarsDocument = gql`
    query LinkedCalendars($listingId: ID!) {
  linkedCalendars(listingId: $listingId) {
    externalUrl
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkedCalendarsGQL extends Apollo.Query<LinkedCalendarsQuery, LinkedCalendarsQueryVariables> {
    document = LinkedCalendarsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkCalendarsUnlinkExternalCalendarDocument = gql`
    mutation LinkCalendarsUnlinkExternalCalendar($input: UnlinkExternalCalendarCommand!) {
  unlinkExternalCalendar(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkCalendarsUnlinkExternalCalendarGQL extends Apollo.Mutation<LinkCalendarsUnlinkExternalCalendarMutation, LinkCalendarsUnlinkExternalCalendarMutationVariables> {
    document = LinkCalendarsUnlinkExternalCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingsWithCleaningByMemberDocument = gql`
    query ListingsWithCleaningByMember($memberId: ID!) {
  listingsByMember(memberId: $memberId) {
    asset {
      assetId
      assetType
    }
    summary {
      title
    }
    operator {
      operatorId
      name
      logoUrl
    }
    cleaningService {
      perStayCleaningFee {
        amount {
          currency
          amountMicros
        }
      }
      perDayCleaningFee {
        amount {
          currency
          amountMicros
        }
      }
      paymentMode
      isUpdated
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingsWithCleaningByMemberGQL extends Apollo.Query<ListingsWithCleaningByMemberQuery, ListingsWithCleaningByMemberQueryVariables> {
    document = ListingsWithCleaningByMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BankAccountDetailsDocument = gql`
    query BankAccountDetails {
  bankAccountDetails {
    accountId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BankAccountDetailsGQL extends Apollo.Query<BankAccountDetailsQuery, BankAccountDetailsQueryVariables> {
    document = BankAccountDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectFacebookAccountDocument = gql`
    mutation ConnectFacebookAccount($input: ConnectSocialMediaAccountCommand!) {
  connectSocialMediaAccount(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectFacebookAccountGQL extends Apollo.Mutation<ConnectFacebookAccountMutation, ConnectFacebookAccountMutationVariables> {
    document = ConnectFacebookAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectFacebookConnectedSocialAccountDocument = gql`
    query ConnectFacebookConnectedSocialAccount($provider: String!) {
  connectedSocialAccount(provider: $provider) {
    provider
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectFacebookConnectedSocialAccountGQL extends Apollo.Query<ConnectFacebookConnectedSocialAccountQuery, ConnectFacebookConnectedSocialAccountQueryVariables> {
    document = ConnectFacebookConnectedSocialAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectLinkedinAccountDocument = gql`
    mutation ConnectLinkedinAccount($input: ConnectLinkedinAccountCommand!) {
  connectLinkedinAccount(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectLinkedinAccountGQL extends Apollo.Mutation<ConnectLinkedinAccountMutation, ConnectLinkedinAccountMutationVariables> {
    document = ConnectLinkedinAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectLinkedinConnectedSocialAccountDocument = gql`
    query ConnectLinkedinConnectedSocialAccount($provider: String!) {
  connectedSocialAccount(provider: $provider) {
    provider
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectLinkedinConnectedSocialAccountGQL extends Apollo.Query<ConnectLinkedinConnectedSocialAccountQuery, ConnectLinkedinConnectedSocialAccountQueryVariables> {
    document = ConnectLinkedinConnectedSocialAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeclineBookingDocument = gql`
    mutation DeclineBooking($input: DeclineBookingRequest!) {
  declineBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeclineBookingGQL extends Apollo.Mutation<DeclineBookingMutation, DeclineBookingMutationVariables> {
    document = DeclineBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeclineBookingBookingDocument = gql`
    query DeclineBookingBooking($bookingId: ID!) {
  booking(bookingId: $bookingId) {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeclineBookingBookingGQL extends Apollo.Query<DeclineBookingBookingQuery, DeclineBookingBookingQueryVariables> {
    document = DeclineBookingBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingAvailabilityCalendarDocument = gql`
    query ListingAvailabilityCalendar($input: ListingAvailabilityCriteria!) {
  availabilityCalendar(input: $input) {
    availabilityCalendar {
      dailyAllocations {
        allocated
        consumed
        day
      }
    }
    lastMonthWithAvailability
    firstMonthWithAvailability
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingAvailabilityCalendarGQL extends Apollo.Query<ListingAvailabilityCalendarQuery, ListingAvailabilityCalendarQueryVariables> {
    document = ListingAvailabilityCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingAvailabilityFeesCalendarDocument = gql`
    query ListingAvailabilityFeesCalendar($listingId: ID!) {
  feesCalendar(listingId: $listingId) {
    perDayFees {
      day
      fees {
        bookingFee {
          amountMicros
          currency
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingAvailabilityFeesCalendarGQL extends Apollo.Query<ListingAvailabilityFeesCalendarQuery, ListingAvailabilityFeesCalendarQueryVariables> {
    document = ListingAvailabilityFeesCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingHotelDocument = gql`
    query ListingHotel($hotelId: ID!) {
  hotelListing(hotelId: $hotelId) {
    general {
      description
      name
    }
    goodToKnow {
      description
    }
    location {
      geoLocation {
        lat
        lng
      }
    }
    amenities {
      amenityIds
    }
    houseRules {
      allowsChildren
      earliestCheckin
      latestCheckin
      maximumStay
      minimumStay
    }
    rooms {
      hotelRoomId
      roomType
      guestRestrictions {
        maxOccupancy
        ageRanges {
          key
          labelPrefix
          allowed
          maxAge
          minAge
          maxNumberAllowed
          minNumberAllowed
        }
      }
      packageDeal {
        text
        helpText
        showCurrency
      }
      description
      imagery {
        photos {
          url
          description
          useAsCover
          useAsFloorplan
        }
      }
    }
    suites {
      hotelSuiteId
      imagery {
        photos {
          description
          url
          useAsCover
          useAsFloorplan
        }
      }
      guestRestrictions {
        maxOccupancy
        ageRanges {
          key
          labelPrefix
          allowed
          maxAge
          minAge
          maxNumberAllowed
          minNumberAllowed
        }
      }
      packageDeal {
        text
        helpText
        showCurrency
      }
      suiteType
      suiteName
      description
      rooms {
        bedrooms {
          bedSizes
        }
        areas {
          areaDefinitionId
          size
          unit
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingHotelGQL extends Apollo.Query<ListingHotelQuery, ListingHotelQueryVariables> {
    document = ListingHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingAmenitiesAmenityBundleByAssetDocument = gql`
    query ListingAmenitiesAmenityBundleByAsset($assetId: ID!) {
  amenityBundleByAsset(assetId: $assetId) {
    bundleId
    name
    sections {
      sectionId
      name
      amenities {
        amenityId
        name
        description
        iconName
        enabled
      }
    }
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingAmenitiesAmenityBundleByAssetGQL extends Apollo.Query<ListingAmenitiesAmenityBundleByAssetQuery, ListingAmenitiesAmenityBundleByAssetQueryVariables> {
    document = ListingAmenitiesAmenityBundleByAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingPropertyDocument = gql`
    query ListingProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    amenities {
      amenityIds
    }
    general {
      bathrooms
      bedrooms {
        bedSizes
      }
      description
      name
      propertyStyle
    }
    guestRestrictions {
      maxOccupancy
      ageRanges {
        key
        labelPrefix
        allowed
        maxAge
        minAge
        maxNumberAllowed
        minNumberAllowed
      }
    }
    goodToKnow {
      description
    }
    houseRules {
      allowsChildren
      allowsEvents
      allowsInfants
      allowsPets
      allowsSmoking
    }
    location {
      geoLocation {
        lat
        lng
      }
    }
    owner {
      firstName
      lastName
      photoUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingPropertyGQL extends Apollo.Query<ListingPropertyQuery, ListingPropertyQueryVariables> {
    document = ListingPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingTravelDatesDocument = gql`
    query ListingTravelDates($listingId: ID!, $checkin: LocalDate!, $checkout: LocalDate!, $guestCounts: [GuestCount!]!) {
  listingByTravelDetails(
    listingId: $listingId
    checkin: $checkin
    checkout: $checkout
    guestCounts: $guestCounts
  ) {
    asset {
      assetType
    }
    fees {
      bookingFee {
        amountMicros
        currency
      }
      bookingToken
    }
    commission {
      rate
    }
    stayDurationConditions {
      minimum
    }
    allowInstantBook
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingTravelDatesGQL extends Apollo.Query<ListingTravelDatesQuery, ListingTravelDatesQueryVariables> {
    document = ListingTravelDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingTravelDatesByIdDocument = gql`
    query ListingTravelDatesById($listingId: ID!) {
  listing(listingId: $listingId) {
    commission {
      rate
    }
    priceRange {
      lowest {
        bookingFee {
          currency
          amountMicros
        }
      }
    }
    stayDurationConditions {
      minimum
    }
    allowInstantBook
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingTravelDatesByIdGQL extends Apollo.Query<ListingTravelDatesByIdQuery, ListingTravelDatesByIdQueryVariables> {
    document = ListingTravelDatesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingTravelDatesFetchCommissionDocument = gql`
    query ListingTravelDatesFetchCommission($listingId: ID!, $adjustedPrice: CurrencyAmount!, $originalPrice: CurrencyAmount!) {
  commission(
    listingId: $listingId
    adjustedPrice: $adjustedPrice
    originalPrice: $originalPrice
  ) {
    commission {
      amountMicros
      currency
    }
    commissionRate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingTravelDatesFetchCommissionGQL extends Apollo.Query<ListingTravelDatesFetchCommissionQuery, ListingTravelDatesFetchCommissionQueryVariables> {
    document = ListingTravelDatesFetchCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingCreateBookingDocument = gql`
    mutation ListingCreateBooking($input: CreateBookingRequest!) {
  createBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingCreateBookingGQL extends Apollo.Mutation<ListingCreateBookingMutation, ListingCreateBookingMutationVariables> {
    document = ListingCreateBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingBookingCheckoutDocument = gql`
    mutation ListingBookingCheckout($input: BookingCheckoutRequest!) {
  checkout(input: $input) {
    sessionId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingBookingCheckoutGQL extends Apollo.Mutation<ListingBookingCheckoutMutation, ListingBookingCheckoutMutationVariables> {
    document = ListingBookingCheckoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingCancelCheckoutSessionDocument = gql`
    mutation ListingCancelCheckoutSession($input: CancelCheckoutRequest!) {
  cancelCheckout(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingCancelCheckoutSessionGQL extends Apollo.Mutation<ListingCancelCheckoutSessionMutation, ListingCancelCheckoutSessionMutationVariables> {
    document = ListingCancelCheckoutSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingBookingDocument = gql`
    query ListingBooking($bookingId: ID!) {
  booking(bookingId: $bookingId) {
    bookingId
    tripId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingBookingGQL extends Apollo.Query<ListingBookingQuery, ListingBookingQueryVariables> {
    document = ListingBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingDocument = gql`
    query Listing($listingId: ID!) {
  listing(listingId: $listingId) {
    listingId
    asset {
      assetId
      assetType
      documentLibrary {
        documentLibraryId
        categories {
          documentCategoryId
          documentLibraryId
          name
          documents {
            documentId
            documentCategoryId
            documentLibraryId
            name
            url
          }
          isDefaultCategory
        }
      }
    }
    availabilityCalendar {
      dailyAllocations {
        allocated
        day
        consumed
      }
    }
    obfuscatedLocation {
      location {
        lat
        lng
      }
      range
    }
    summary {
      city
      countryCode
      title
      subtitle
      highlightedAmenities
      highlightedFeatures {
        features {
          iconName
          title
          description
        }
      }
      houseRules {
        otherRules
        rules {
          enabled
          icon
          subtitle
          title
        }
      }
      photos {
        url
        useAsCover
        description
      }
    }
    status
    allowInstantBook
    stayDurationConditions {
      minimum
    }
    operator {
      operatorId
      name
      logoUrl
    }
    installmentSchedule {
      installmentScheduleId
      installments {
        installmentScheduleId
        installmentId
        daysPriorTo
        percentage
      }
    }
    documentLibrary {
      documentLibraryId
      categories {
        documentCategoryId
        documentLibraryId
        name
        documents {
          documentId
          documentCategoryId
          documentLibraryId
          name
          url
        }
        isDefaultCategory
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingGQL extends Apollo.Query<ListingQuery, ListingQueryVariables> {
    document = ListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingIdDocument = gql`
    query ListingId($propertyOrHotelRoomId: ID!) {
  listingId(propertyOrHotelRoomId: $propertyOrHotelRoomId) {
    listingId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingIdGQL extends Apollo.Query<ListingIdQuery, ListingIdQueryVariables> {
    document = ListingIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingManagementIdDocument = gql`
    query ListingManagementId($propertyOrHotelRoomId: ID!) {
  listingId(propertyOrHotelRoomId: $propertyOrHotelRoomId) {
    listingManagementId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingManagementIdGQL extends Apollo.Query<ListingManagementIdQuery, ListingManagementIdQueryVariables> {
    document = ListingManagementIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingHostDocument = gql`
    query ListingHost($listingId: ID!) {
  hostingTeamByListing(listingId: $listingId) {
    displayName
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingHostGQL extends Apollo.Query<ListingHostQuery, ListingHostQueryVariables> {
    document = ListingHostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingTransportAirportsDocument = gql`
    query ListingTransportAirports($location: InputGeoLocation!) {
  airports(location: $location) {
    distance
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingTransportAirportsGQL extends Apollo.Query<ListingTransportAirportsQuery, ListingTransportAirportsQueryVariables> {
    document = ListingTransportAirportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignupConsumerDocument = gql`
    mutation SignupConsumer($input: SignupConsumerRequest!) {
  signupConsumer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignupConsumerGQL extends Apollo.Mutation<SignupConsumerMutation, SignupConsumerMutationVariables> {
    document = SignupConsumerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignupTravelAgentDocument = gql`
    mutation SignupTravelAgent($input: SignupTravelAgentRequest!) {
  signupTravelAgent(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignupTravelAgentGQL extends Apollo.Mutation<SignupTravelAgentMutation, SignupTravelAgentMutationVariables> {
    document = SignupTravelAgentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignupHotelDocument = gql`
    mutation SignupHotel($input: SignupHotelRequest!) {
  signupHotel(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignupHotelGQL extends Apollo.Mutation<SignupHotelMutation, SignupHotelMutationVariables> {
    document = SignupHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyPromotionalCodeDocument = gql`
    query VerifyPromotionalCode($promotionalCode: String!) {
  verifyPromotionalCode(promotionalCode: $promotionalCode) {
    promotionalCodeId
    valid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyPromotionalCodeGQL extends Apollo.Query<VerifyPromotionalCodeQuery, VerifyPromotionalCodeQueryVariables> {
    document = VerifyPromotionalCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyInquiryDocument = gql`
    mutation PropertyInquiry($input: PropertyInquiryRequest!) {
  propertyInquiry(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyInquiryGQL extends Apollo.Mutation<PropertyInquiryMutation, PropertyInquiryMutationVariables> {
    document = PropertyInquiryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResellerCommissionDocument = gql`
    query ResellerCommission($bookingId: ID!) {
  resellerByBookingId(bookingId: $bookingId) {
    resellerId
    businessId
    name
    verified
    associatedBookings {
      bookingId
      commissionFees {
        commission {
          currency
          amountMicros
        }
      }
      commissionPlan {
        commissionPlanId
        vendorId
        commissionModelType
        flatPercentageCommissionPlan {
          flatPercentage
        }
      }
      booking {
        bookingId
        bookingReference
        bookingSupplementsDetails {
          supplementDetails {
            supplementId
            iconName
            name
            description
            price {
              currency
              amountMicros
            }
          }
        }
        checkin
        checkout
        fees {
          bookingFee {
            currency
            amountMicros
          }
        }
        guest {
          firstName
          imageUrl
          lastName
        }
        status
        summary {
          imageUrl
          location {
            address {
              city
              countryCode
            }
          }
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResellerCommissionGQL extends Apollo.Query<ResellerCommissionQuery, ResellerCommissionQueryVariables> {
    document = ResellerCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyAmenitiesDocument = gql`
    mutation UpdatePropertyAmenities($input: UpdatePropertyAmenitiesCommand!) {
  updatePropertyAmenities(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyAmenitiesGQL extends Apollo.Mutation<UpdatePropertyAmenitiesMutation, UpdatePropertyAmenitiesMutationVariables> {
    document = UpdatePropertyAmenitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyAmenitiesPropertyDocument = gql`
    query UpdatePropertyAmenitiesProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    amenities {
      amenityIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyAmenitiesPropertyGQL extends Apollo.Query<UpdatePropertyAmenitiesPropertyQuery, UpdatePropertyAmenitiesPropertyQueryVariables> {
    document = UpdatePropertyAmenitiesPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyAmenityBundleByAssetDocument = gql`
    query UpdatePropertyAmenityBundleByAsset($assetId: ID!) {
  amenityBundleByAsset(assetId: $assetId) {
    bundleId
    name
    sections {
      sectionId
      name
      amenities {
        amenityId
        name
        description
        iconName
        enabled
      }
    }
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyAmenityBundleByAssetGQL extends Apollo.Query<UpdatePropertyAmenityBundleByAssetQuery, UpdatePropertyAmenityBundleByAssetQueryVariables> {
    document = UpdatePropertyAmenityBundleByAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyCleaningFeesListingDocument = gql`
    query UpdatePropertyCleaningFeesListing($listingId: ID!) {
  listing(listingId: $listingId) {
    cleaningService {
      perDayCleaningFee {
        amount {
          currency
          amountMicros
        }
        description
      }
      perStayCleaningFee {
        amount {
          currency
          amountMicros
        }
        description
      }
      paymentMode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyCleaningFeesListingGQL extends Apollo.Query<UpdatePropertyCleaningFeesListingQuery, UpdatePropertyCleaningFeesListingQueryVariables> {
    document = UpdatePropertyCleaningFeesListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyCleaningServiceDocument = gql`
    mutation UpdatePropertyCleaningService($input: UpdateListingCleaningServiceCommand!) {
  updateListingCleaningService(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyCleaningServiceGQL extends Apollo.Mutation<UpdatePropertyCleaningServiceMutation, UpdatePropertyCleaningServiceMutationVariables> {
    document = UpdatePropertyCleaningServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyGeneralDocument = gql`
    mutation UpdatePropertyGeneral($input: UpdatePropertyGeneralCommand!) {
  updatePropertyGeneral(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyGeneralGQL extends Apollo.Mutation<UpdatePropertyGeneralMutation, UpdatePropertyGeneralMutationVariables> {
    document = UpdatePropertyGeneralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyGeneralPropertyDocument = gql`
    query UpdatePropertyGeneralProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    general {
      approximateValue {
        amountMicros
        currency
      }
      bathrooms
      bedrooms {
        bedSizes
      }
      description
      name
      propertyStyle
      propertyType
      sleeps
    }
    location {
      address {
        line1
      }
    }
    propertyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyGeneralPropertyGQL extends Apollo.Query<UpdatePropertyGeneralPropertyQuery, UpdatePropertyGeneralPropertyQueryVariables> {
    document = UpdatePropertyGeneralPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyHouseRulesDocument = gql`
    mutation UpdatePropertyHouseRules($input: UpdatePropertyHouseRulesCommand!) {
  updatePropertyHouseRules(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyHouseRulesGQL extends Apollo.Mutation<UpdatePropertyHouseRulesMutation, UpdatePropertyHouseRulesMutationVariables> {
    document = UpdatePropertyHouseRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyHouseRulesPropertyDocument = gql`
    query UpdatePropertyHouseRulesProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    houseRules {
      allowsChildren
      allowsEvents
      allowsInfants
      allowsPets
      allowsSmoking
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyHouseRulesPropertyGQL extends Apollo.Query<UpdatePropertyHouseRulesPropertyQuery, UpdatePropertyHouseRulesPropertyQueryVariables> {
    document = UpdatePropertyHouseRulesPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyLocationDocument = gql`
    mutation UpdatePropertyLocation($input: UpdatePropertyLocationCommand!) {
  updatePropertyLocation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyLocationGQL extends Apollo.Mutation<UpdatePropertyLocationMutation, UpdatePropertyLocationMutationVariables> {
    document = UpdatePropertyLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyLocationPropertyDocument = gql`
    query UpdatePropertyLocationProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    location {
      address {
        additionalInstructions
        city
        countryCode
        line1
        line2
        postalCode
        region
      }
      geoLocation {
        lat
        lng
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyLocationPropertyGQL extends Apollo.Query<UpdatePropertyLocationPropertyQuery, UpdatePropertyLocationPropertyQueryVariables> {
    document = UpdatePropertyLocationPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyPhotosDocument = gql`
    mutation UpdatePropertyPhotos($input: UpdatePropertyPhotosCommand!) {
  updatePropertyPhotos(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyPhotosGQL extends Apollo.Mutation<UpdatePropertyPhotosMutation, UpdatePropertyPhotosMutationVariables> {
    document = UpdatePropertyPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyPhotosPropertyDocument = gql`
    query UpdatePropertyPhotosProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    imagery {
      photos {
        description
        url
        useAsCover
        useAsFloorplan
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyPhotosPropertyGQL extends Apollo.Query<UpdatePropertyPhotosPropertyQuery, UpdatePropertyPhotosPropertyQueryVariables> {
    document = UpdatePropertyPhotosPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertyPhotosSignedUrlDocument = gql`
    mutation UpdatePropertyPhotosSignedUrl($input: PropertyPhotoSignUrlRequest!) {
  propertyPhotoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertyPhotosSignedUrlGQL extends Apollo.Mutation<UpdatePropertyPhotosSignedUrlMutation, UpdatePropertyPhotosSignedUrlMutationVariables> {
    document = UpdatePropertyPhotosSignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertySupplementBundlesDocument = gql`
    query UpdatePropertySupplementBundles($assetId: ID!) {
  supplementBundleByAsset(assetId: $assetId) {
    bundleId
    name
    enabled
    sections {
      sectionId
      name
      supplements {
        supplementId
        name
        description
        iconName
        price {
          currency
          amountMicros
        }
        enabled
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertySupplementBundlesGQL extends Apollo.Query<UpdatePropertySupplementBundlesQuery, UpdatePropertySupplementBundlesQueryVariables> {
    document = UpdatePropertySupplementBundlesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertySupplementIdsListingDocument = gql`
    query UpdatePropertySupplementIdsListing($listingId: ID!) {
  listing(listingId: $listingId) {
    supplements {
      listingId
      mandatorySupplements {
        id
        price {
          currency
          amountMicros
        }
        description
      }
      optionalSupplements {
        id
        price {
          currency
          amountMicros
        }
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertySupplementIdsListingGQL extends Apollo.Query<UpdatePropertySupplementIdsListingQuery, UpdatePropertySupplementIdsListingQueryVariables> {
    document = UpdatePropertySupplementIdsListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePropertySupplementsListingDocument = gql`
    mutation UpdatePropertySupplementsListing($input: UpdateListingSupplementsCommand!) {
  updateListingSupplements(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePropertySupplementsListingGQL extends Apollo.Mutation<UpdatePropertySupplementsListingMutation, UpdatePropertySupplementsListingMutationVariables> {
    document = UpdatePropertySupplementsListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteStaffMemberDocument = gql`
    mutation InviteStaffMember($input: InviteStaffMemberCommand!) {
  inviteStaffMember(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteStaffMemberGQL extends Apollo.Mutation<InviteStaffMemberMutation, InviteStaffMemberMutationVariables> {
    document = InviteStaffMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMemberFromStaffDocument = gql`
    mutation RemoveMemberFromStaff($input: RemoveMemberFromStaffCommand!) {
  removeMemberFromStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMemberFromStaffGQL extends Apollo.Mutation<RemoveMemberFromStaffMutation, RemoveMemberFromStaffMutationVariables> {
    document = RemoveMemberFromStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StaffMemberInvitationsDocument = gql`
    query StaffMemberInvitations($staffId: ID!) {
  staffMemberInvitations(staffId: $staffId) {
    email
    firstName
    host
    invitationId
    lastName
    manager
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StaffMemberInvitationsGQL extends Apollo.Query<StaffMemberInvitationsQuery, StaffMemberInvitationsQueryVariables> {
    document = StaffMemberInvitationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StaffMembersDocument = gql`
    query StaffMembers($staffId: ID!) {
  staffMembers(staffId: $staffId) {
    userId
    email
    firstName
    lastName
    host
    manager
    boss
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StaffMembersGQL extends Apollo.Query<StaffMembersQuery, StaffMembersQueryVariables> {
    document = StaffMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStaffPhotoSignedUrlDocument = gql`
    mutation UpdateStaffPhotoSignedUrl($input: StaffPhotoSignUrlRequest!) {
  staffPhotoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStaffPhotoSignedUrlGQL extends Apollo.Mutation<UpdateStaffPhotoSignedUrlMutation, UpdateStaffPhotoSignedUrlMutationVariables> {
    document = UpdateStaffPhotoSignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountOwnedPmcsDocument = gql`
    query AccountOwnedPmcs {
  ownedPmcs {
    pmcId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountOwnedPmcsGQL extends Apollo.Query<AccountOwnedPmcsQuery, AccountOwnedPmcsQueryVariables> {
    document = AccountOwnedPmcsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountOwnedTravelAgentsDocument = gql`
    query AccountOwnedTravelAgents {
  ownedTravelAgents {
    travelAgentId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountOwnedTravelAgentsGQL extends Apollo.Query<AccountOwnedTravelAgentsQuery, AccountOwnedTravelAgentsQueryVariables> {
    document = AccountOwnedTravelAgentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBankAccountDocument = gql`
    mutation UpdateBankAccount($input: UpdateBankAccountCommand!) {
  updateBankAccount(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBankAccountGQL extends Apollo.Mutation<UpdateBankAccountMutation, UpdateBankAccountMutationVariables> {
    document = UpdateBankAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBankAccountDetailsDocument = gql`
    query UpdateBankAccountDetails {
  bankAccountDetails {
    accountId
    bankAccount {
      accountType
      accountHolderName
      bankName
      countryCode
      bankCode
      transitNumber
      accountNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBankAccountDetailsGQL extends Apollo.Query<UpdateBankAccountDetailsQuery, UpdateBankAccountDetailsQueryVariables> {
    document = UpdateBankAccountDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalInformationDocument = gql`
    mutation UpdatePersonalInformation($input: UpdatePersonalInformationCommand!) {
  updatePersonalInformation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalInformationGQL extends Apollo.Mutation<UpdatePersonalInformationMutation, UpdatePersonalInformationMutationVariables> {
    document = UpdatePersonalInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalInformationProfileDocument = gql`
    query UpdatePersonalInformationProfile {
  account {
    accountId
    personalProfile {
      email
      firstName
      lastName
      phoneNumber {
        countryCode
        nationalNumber
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalInformationProfileGQL extends Apollo.Query<UpdatePersonalInformationProfileQuery, UpdatePersonalInformationProfileQueryVariables> {
    document = UpdatePersonalInformationProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalPhotoDocument = gql`
    mutation UpdatePersonalPhoto($input: UpdatePersonalPhotoCommand!) {
  updatePersonalPhoto(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalPhotoGQL extends Apollo.Mutation<UpdatePersonalPhotoMutation, UpdatePersonalPhotoMutationVariables> {
    document = UpdatePersonalPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalPhotoProfileDocument = gql`
    query UpdatePersonalPhotoProfile {
  account {
    accountId
    personalProfile {
      email
      photoUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalPhotoProfileGQL extends Apollo.Query<UpdatePersonalPhotoProfileQuery, UpdatePersonalPhotoProfileQueryVariables> {
    document = UpdatePersonalPhotoProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMemberPhotoSignedUrlDocument = gql`
    mutation UpdateMemberPhotoSignedUrl($input: ProfilePhotoSignUrlRequest!) {
  profilePhotoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMemberPhotoSignedUrlGQL extends Apollo.Mutation<UpdateMemberPhotoSignedUrlMutation, UpdateMemberPhotoSignedUrlMutationVariables> {
    document = UpdateMemberPhotoSignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStaffDocument = gql`
    mutation CreateStaff($input: CreateStaffCommand!) {
  createStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStaffGQL extends Apollo.Mutation<CreateStaffMutation, CreateStaffMutationVariables> {
    document = CreateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignPersonalStaffToMemberDocument = gql`
    mutation AssignPersonalStaffToMember($input: AssignPersonalStaffToMemberCommand!) {
  assignPersonalStaffToMember(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignPersonalStaffToMemberGQL extends Apollo.Mutation<AssignPersonalStaffToMemberMutation, AssignPersonalStaffToMemberMutationVariables> {
    document = AssignPersonalStaffToMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalStaffDocument = gql`
    query UpdatePersonalStaff {
  myPersonalStaff {
    displayName
    email
    phoneNumber {
      countryCode
      nationalNumber
    }
    photoUrl
    staffId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalStaffGQL extends Apollo.Query<UpdatePersonalStaffQuery, UpdatePersonalStaffQueryVariables> {
    document = UpdatePersonalStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStaffDocument = gql`
    mutation UpdateStaff($input: UpdateStaffCommand!) {
  updateStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStaffGQL extends Apollo.Mutation<UpdateStaffMutation, UpdateStaffMutationVariables> {
    document = UpdateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdatePmcAssignStaffToPmcDocument = gql`
    mutation PartnerUpdatePmcAssignStaffToPmc($input: AssignStaffToPmcCommand!) {
  assignStaffToPmc(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdatePmcAssignStaffToPmcGQL extends Apollo.Mutation<PartnerUpdatePmcAssignStaffToPmcMutation, PartnerUpdatePmcAssignStaffToPmcMutationVariables> {
    document = PartnerUpdatePmcAssignStaffToPmcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdatePmcCreateStaffDocument = gql`
    mutation PartnerUpdatePmcCreateStaff($input: CreateStaffCommand!) {
  createStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdatePmcCreateStaffGQL extends Apollo.Mutation<PartnerUpdatePmcCreateStaffMutation, PartnerUpdatePmcCreateStaffMutationVariables> {
    document = PartnerUpdatePmcCreateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdatePmcListStaffDocument = gql`
    query PartnerUpdatePmcListStaff($pmcId: ID!) {
  pmcStaff(pmcId: $pmcId) {
    displayName
    email
    phoneNumber {
      countryCode
      nationalNumber
    }
    photoUrl
    staffId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdatePmcListStaffGQL extends Apollo.Query<PartnerUpdatePmcListStaffQuery, PartnerUpdatePmcListStaffQueryVariables> {
    document = PartnerUpdatePmcListStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdatePmcUpdateStaffDocument = gql`
    mutation PartnerUpdatePmcUpdateStaff($input: UpdateStaffCommand!) {
  updateStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdatePmcUpdateStaffGQL extends Apollo.Mutation<PartnerUpdatePmcUpdateStaffMutation, PartnerUpdatePmcUpdateStaffMutationVariables> {
    document = PartnerUpdatePmcUpdateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdateTravelAgentAssignStaffToTravelAgentDocument = gql`
    mutation PartnerUpdateTravelAgentAssignStaffToTravelAgent($input: AssignStaffToTravelAgentCommand!) {
  assignStaffToTravelAgent(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdateTravelAgentAssignStaffToTravelAgentGQL extends Apollo.Mutation<PartnerUpdateTravelAgentAssignStaffToTravelAgentMutation, PartnerUpdateTravelAgentAssignStaffToTravelAgentMutationVariables> {
    document = PartnerUpdateTravelAgentAssignStaffToTravelAgentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdateTravelAgentCreateStaffDocument = gql`
    mutation PartnerUpdateTravelAgentCreateStaff($input: CreateStaffCommand!) {
  createStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdateTravelAgentCreateStaffGQL extends Apollo.Mutation<PartnerUpdateTravelAgentCreateStaffMutation, PartnerUpdateTravelAgentCreateStaffMutationVariables> {
    document = PartnerUpdateTravelAgentCreateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdateTravelAgentListStaffDocument = gql`
    query PartnerUpdateTravelAgentListStaff($travelAgentId: ID!) {
  travelAgentStaff(travelAgentId: $travelAgentId) {
    displayName
    email
    phoneNumber {
      countryCode
      nationalNumber
    }
    photoUrl
    staffId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdateTravelAgentListStaffGQL extends Apollo.Query<PartnerUpdateTravelAgentListStaffQuery, PartnerUpdateTravelAgentListStaffQueryVariables> {
    document = PartnerUpdateTravelAgentListStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerUpdateTravelAgentUpdateStaffDocument = gql`
    mutation PartnerUpdateTravelAgentUpdateStaff($input: UpdateStaffCommand!) {
  updateStaff(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerUpdateTravelAgentUpdateStaffGQL extends Apollo.Mutation<PartnerUpdateTravelAgentUpdateStaffMutation, PartnerUpdateTravelAgentUpdateStaffMutationVariables> {
    document = PartnerUpdateTravelAgentUpdateStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckSubdomainAvailabilityDocument = gql`
    query CheckSubdomainAvailability($subdomain: String!) {
  checkSubdomainAvailability(subdomain: $subdomain) {
    available
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckSubdomainAvailabilityGQL extends Apollo.Query<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables> {
    document = CheckSubdomainAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhiteLabelDocument = gql`
    query WhiteLabel($resellerId: ID!) {
  whiteLabel(resellerId: $resellerId) {
    resellerId
    primaryColor
    secondaryColor
    tertiaryColor
    quaternaryColor
    headerColor
    primaryGreen
    headingFont
    bodyFont
    subdomain
    squareLogoUrl
    landscapeLogoUrl
    faviconUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhiteLabelGQL extends Apollo.Query<WhiteLabelQuery, WhiteLabelQueryVariables> {
    document = WhiteLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhiteLabelBySubdomainDocument = gql`
    query WhiteLabelBySubdomain($subdomain: String!) {
  whiteLabelBySubdomain(subdomain: $subdomain) {
    resellerId
    primaryColor
    secondaryColor
    tertiaryColor
    quaternaryColor
    headerColor
    primaryGreen
    headingFont
    bodyFont
    subdomain
    squareLogoUrl
    landscapeLogoUrl
    faviconUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhiteLabelBySubdomainGQL extends Apollo.Query<WhiteLabelBySubdomainQuery, WhiteLabelBySubdomainQueryVariables> {
    document = WhiteLabelBySubdomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhiteLabelLogoSignUrlDocument = gql`
    mutation WhiteLabelLogoSignUrl($input: WhiteLabelLogoSignUrlRequest!) {
  whiteLabelLogoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhiteLabelLogoSignUrlGQL extends Apollo.Mutation<WhiteLabelLogoSignUrlMutation, WhiteLabelLogoSignUrlMutationVariables> {
    document = WhiteLabelLogoSignUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfigureWhiteLabelDocument = gql`
    mutation ConfigureWhiteLabel($input: ConfigureWhiteLabelCommand!) {
  configureWhiteLabel(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfigureWhiteLabelGQL extends Apollo.Mutation<ConfigureWhiteLabelMutation, ConfigureWhiteLabelMutationVariables> {
    document = ConfigureWhiteLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddApplicationPhotosDocument = gql`
    mutation AddApplicationPhotos($input: AddApplicationPhotosCommand!) {
  addApplicationPhotos(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddApplicationPhotosGQL extends Apollo.Mutation<AddApplicationPhotosMutation, AddApplicationPhotosMutationVariables> {
    document = AddApplicationPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplicationPhotosSignedUrlDocument = gql`
    mutation ApplicationPhotosSignedUrl($input: ApplicationPhotoSignUrlRequest!) {
  applicationPhotoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplicationPhotosSignedUrlGQL extends Apollo.Mutation<ApplicationPhotosSignedUrlMutation, ApplicationPhotosSignedUrlMutationVariables> {
    document = ApplicationPhotosSignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplicationDocument = gql`
    mutation Application($input: SubmitMemberApplicationCommand!) {
  submitMemberApplication(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplicationGQL extends Apollo.Mutation<ApplicationMutation, ApplicationMutationVariables> {
    document = ApplicationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplicationActiveMemberApplicationDocument = gql`
    query ApplicationActiveMemberApplication {
  activeMemberApplication {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplicationActiveMemberApplicationGQL extends Apollo.Query<ApplicationActiveMemberApplicationQuery, ApplicationActiveMemberApplicationQueryVariables> {
    document = ApplicationActiveMemberApplicationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarListingsDocument = gql`
    query CalendarListings($memberId: ID!, $page: RequestedPage!) {
  managedListings(memberId: $memberId, page: $page) {
    total
    page
    pageSize
    searchTerm
    results {
      __typename
      ... on Listing {
        status
        asset {
          assetId
          assetType
        }
        listingId
        summary {
          city
          countryCode
          title
          subtitle
          photos {
            url
            useAsCover
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarListingsGQL extends Apollo.Query<CalendarListingsQuery, CalendarListingsQueryVariables> {
    document = CalendarListingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GuestbookBusinessCustomerDocument = gql`
    query GuestbookBusinessCustomer($businessId: ID!, $userId: String!) {
  businessCustomer(businessId: $businessId, userId: $userId) {
    userId
    email
    firstName
    lastName
    phoneNumber {
      countryCode
      nationalNumber
    }
    photoUrl
    trips {
      tripId
      bookings {
        tripId
        bookingId
        listingId
        status
        bookingReference
        checkin
        checkout
        nights
        numberOfGuests
        fees {
          bookingFee {
            amountMicros
            currency
          }
        }
        guest {
          guestId
          firstName
          lastName
          imageUrl
        }
        summary {
          name
          imageUrl
          location {
            geoLocation {
              lat
              lng
            }
            address {
              line1
              line2
              city
              postalCode
              countryCode
              additionalInstructions
            }
          }
        }
        bookingSupplementsDetails {
          supplementDetails {
            supplementId
            iconName
            name
            description
            price {
              amountMicros
              currency
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GuestbookBusinessCustomerGQL extends Apollo.Query<GuestbookBusinessCustomerQuery, GuestbookBusinessCustomerQueryVariables> {
    document = GuestbookBusinessCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TripSummaryHostDocument = gql`
    query TripSummaryHost($listingId: ID!) {
  hostingTeamByListing(listingId: $listingId) {
    displayName
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TripSummaryHostGQL extends Apollo.Query<TripSummaryHostQuery, TripSummaryHostQueryVariables> {
    document = TripSummaryHostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GuestbookClienteleByBusinessIdDocument = gql`
    query GuestbookClienteleByBusinessId($businessId: ID!) {
  clienteleByBusinessId(businessId: $businessId) {
    clienteleId
    businessId
    customers {
      userId
      firstName
      lastName
      email
      phoneNumber {
        countryCode
        nationalNumber
      }
      photoUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GuestbookClienteleByBusinessIdGQL extends Apollo.Query<GuestbookClienteleByBusinessIdQuery, GuestbookClienteleByBusinessIdQueryVariables> {
    document = GuestbookClienteleByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingDocument = gql`
    query ConfirmBooking($bookingId: ID!) {
  publicBooking(bookingId: $bookingId) {
    tripId
    bookingId
    status
    bookingReference
    checkin
    checkout
    nights
    numberOfGuests
    summary {
      imageUrl
      location {
        address {
          city
          countryCode
        }
      }
      name
    }
    bookingTimestamp
    originalFees {
      bookingFee {
        amountMicros
        currency
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingGQL extends Apollo.Query<ConfirmBookingQuery, ConfirmBookingQueryVariables> {
    document = ConfirmBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingAcceptDocument = gql`
    mutation ConfirmBookingAccept($input: AcceptBookingRequest!) {
  acceptBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingAcceptGQL extends Apollo.Mutation<ConfirmBookingAcceptMutation, ConfirmBookingAcceptMutationVariables> {
    document = ConfirmBookingAcceptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingDeclineDocument = gql`
    mutation ConfirmBookingDecline($input: DeclineBookingRequest!) {
  declineBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingDeclineGQL extends Apollo.Mutation<ConfirmBookingDeclineMutation, ConfirmBookingDeclineMutationVariables> {
    document = ConfirmBookingDeclineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingAssignReferenceDocument = gql`
    mutation ConfirmBookingAssignReference($input: AssignBookingReferenceCommand!) {
  assignBookingReference(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingAssignReferenceGQL extends Apollo.Mutation<ConfirmBookingAssignReferenceMutation, ConfirmBookingAssignReferenceMutationVariables> {
    document = ConfirmBookingAssignReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmListingByTravelDatesDocument = gql`
    query ConfirmListingByTravelDates($listingId: ID!, $checkin: LocalDate!, $checkout: LocalDate!, $guestCounts: [GuestCount!]!) {
  listingByTravelDetails(
    listingId: $listingId
    checkin: $checkin
    checkout: $checkout
    guestCounts: $guestCounts
  ) {
    asset {
      assetId
      assetType
    }
    checkin
    checkout
    fees {
      bookingFee {
        amountMicros
        currency
      }
    }
    listingId
    summary {
      city
      countryCode
      houseRules {
        otherRules
        rules {
          enabled
          icon
          subtitle
          title
        }
      }
      title
      subtitle
      photos {
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmListingByTravelDatesGQL extends Apollo.Query<ConfirmListingByTravelDatesQuery, ConfirmListingByTravelDatesQueryVariables> {
    document = ConfirmListingByTravelDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingCancelCheckoutDocument = gql`
    mutation ConfirmBookingCancelCheckout($input: CancelCheckoutRequest!) {
  cancelCheckout(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingCancelCheckoutGQL extends Apollo.Mutation<ConfirmBookingCancelCheckoutMutation, ConfirmBookingCancelCheckoutMutationVariables> {
    document = ConfirmBookingCancelCheckoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsumerSignupDocument = gql`
    mutation ConsumerSignup($input: SignupConsumerRequest!) {
  signupConsumer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsumerSignupGQL extends Apollo.Mutation<ConsumerSignupMutation, ConsumerSignupMutationVariables> {
    document = ConsumerSignupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsumerSignupUpdatePersonalInformationDocument = gql`
    mutation ConsumerSignupUpdatePersonalInformation($input: UpdatePersonalInformationCommand!) {
  updatePersonalInformation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsumerSignupUpdatePersonalInformationGQL extends Apollo.Mutation<ConsumerSignupUpdatePersonalInformationMutation, ConsumerSignupUpdatePersonalInformationMutationVariables> {
    document = ConsumerSignupUpdatePersonalInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsumerSignupAcceptTermsDocument = gql`
    mutation ConsumerSignupAcceptTerms($input: AcceptConsumerTermsAndConditionsCommand!) {
  acceptConsumerTermsAndConditions(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsumerSignupAcceptTermsGQL extends Apollo.Mutation<ConsumerSignupAcceptTermsMutation, ConsumerSignupAcceptTermsMutationVariables> {
    document = ConsumerSignupAcceptTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsumerSignupAccountExistsDocument = gql`
    query ConsumerSignupAccountExists {
  account {
    accountId
    accountHolderId
    personalProfile {
      email
      firstName
      lastName
      phoneNumber {
        countryCode
        nationalNumber
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsumerSignupAccountExistsGQL extends Apollo.Query<ConsumerSignupAccountExistsQuery, ConsumerSignupAccountExistsQueryVariables> {
    document = ConsumerSignupAccountExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeaturedListingListingsDocument = gql`
    query FeaturedListingListings($featuredListingCode: String!) {
  featuredListings(featuredListingCode: $featuredListingCode) {
    listingCode
    name
    publicListingEntries {
      listingId
      photos {
        url
        description
        useAsCover
      }
      city
      countryCode
      title
      decidingFactors {
        primaryDecidingFactors {
          enabled
          icon
          title
          subtitle
        }
      }
      operator {
        operatorId
        name
        logoUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FeaturedListingListingsGQL extends Apollo.Query<FeaturedListingListingsQuery, FeaturedListingListingsQueryVariables> {
    document = FeaturedListingListingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HotelHeaderHotelDocument = gql`
    query HotelHeaderHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    general {
      name
    }
    imagery {
      photos {
        url
      }
    }
    location {
      address {
        city
        countryCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HotelHeaderHotelGQL extends Apollo.Query<HotelHeaderHotelQuery, HotelHeaderHotelQueryVariables> {
    document = HotelHeaderHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelAmenitiesDocument = gql`
    mutation UpdateHotelAmenities($input: UpdateHotelAmenitiesCommand!) {
  updateHotelAmenities(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelAmenitiesGQL extends Apollo.Mutation<UpdateHotelAmenitiesMutation, UpdateHotelAmenitiesMutationVariables> {
    document = UpdateHotelAmenitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelAmenitiesHotelDocument = gql`
    query UpdateHotelAmenitiesHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    amenities {
      amenityIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelAmenitiesHotelGQL extends Apollo.Query<UpdateHotelAmenitiesHotelQuery, UpdateHotelAmenitiesHotelQueryVariables> {
    document = UpdateHotelAmenitiesHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelAmenityBundleByAssetDocument = gql`
    query UpdateHotelAmenityBundleByAsset($assetId: ID!) {
  amenityBundleByAsset(assetId: $assetId) {
    bundleId
    name
    sections {
      sectionId
      name
      amenities {
        amenityId
        name
        description
        iconName
        enabled
      }
    }
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelAmenityBundleByAssetGQL extends Apollo.Query<UpdateHotelAmenityBundleByAssetQuery, UpdateHotelAmenityBundleByAssetQueryVariables> {
    document = UpdateHotelAmenityBundleByAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelGeneralDocument = gql`
    mutation UpdateHotelGeneral($input: UpdateHotelGeneralCommand!) {
  updateHotelGeneral(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelGeneralGQL extends Apollo.Mutation<UpdateHotelGeneralMutation, UpdateHotelGeneralMutationVariables> {
    document = UpdateHotelGeneralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelGeneralHotelDocument = gql`
    query UpdateHotelGeneralHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    general {
      averageDailyRate {
        amountMicros
        currency
      }
      description
      name
      stars
      website
    }
    hotelId
    location {
      address {
        line1
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelGeneralHotelGQL extends Apollo.Query<UpdateHotelGeneralHotelQuery, UpdateHotelGeneralHotelQueryVariables> {
    document = UpdateHotelGeneralHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelHouseRulesDocument = gql`
    mutation UpdateHotelHouseRules($input: UpdateHotelHouseRulesCommand!) {
  updateHotelHouseRules(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelHouseRulesGQL extends Apollo.Mutation<UpdateHotelHouseRulesMutation, UpdateHotelHouseRulesMutationVariables> {
    document = UpdateHotelHouseRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelHouseRulesHotelDocument = gql`
    query UpdateHotelHouseRulesHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    houseRules {
      allowsChildren
      earliestCheckin
      latestCheckin
      maximumStay
      minimumStay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelHouseRulesHotelGQL extends Apollo.Query<UpdateHotelHouseRulesHotelQuery, UpdateHotelHouseRulesHotelQueryVariables> {
    document = UpdateHotelHouseRulesHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelLocationDocument = gql`
    mutation UpdateHotelLocation($input: UpdateHotelLocationCommand!) {
  updateHotelLocation(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelLocationGQL extends Apollo.Mutation<UpdateHotelLocationMutation, UpdateHotelLocationMutationVariables> {
    document = UpdateHotelLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelLocationHotelDocument = gql`
    query UpdateHotelLocationHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    location {
      address {
        additionalInstructions
        city
        countryCode
        line1
        line2
        postalCode
        region
      }
      geoLocation {
        lat
        lng
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelLocationHotelGQL extends Apollo.Query<UpdateHotelLocationHotelQuery, UpdateHotelLocationHotelQueryVariables> {
    document = UpdateHotelLocationHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelPhotosDocument = gql`
    mutation UpdateHotelPhotos($input: UpdateHotelPhotosCommand!) {
  updateHotelPhotos(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelPhotosGQL extends Apollo.Mutation<UpdateHotelPhotosMutation, UpdateHotelPhotosMutationVariables> {
    document = UpdateHotelPhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelPhotosHotelDocument = gql`
    query UpdateHotelPhotosHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    imagery {
      photos {
        description
        url
        useAsCover
        useAsFloorplan
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelPhotosHotelGQL extends Apollo.Query<UpdateHotelPhotosHotelQuery, UpdateHotelPhotosHotelQueryVariables> {
    document = UpdateHotelPhotosHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelPhotosSignedUrlDocument = gql`
    mutation UpdateHotelPhotosSignedUrl($input: HotelPhotoSignUrlRequest!) {
  hotelPhotoSignUrl(input: $input) {
    contentType
    httpMethod
    signedUrl
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelPhotosSignedUrlGQL extends Apollo.Mutation<UpdateHotelPhotosSignedUrlMutation, UpdateHotelPhotosSignedUrlMutationVariables> {
    document = UpdateHotelPhotosSignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelGoodToKnowDocument = gql`
    mutation UpdateHotelGoodToKnow($input: UpdateHotelGoodToKnowCommand!) {
  updateHotelGoodToKnow(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelGoodToKnowGQL extends Apollo.Mutation<UpdateHotelGoodToKnowMutation, UpdateHotelGoodToKnowMutationVariables> {
    document = UpdateHotelGoodToKnowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelGoodToKnowHotelDocument = gql`
    query UpdateHotelGoodToKnowHotel($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    goodToKnow {
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelGoodToKnowHotelGQL extends Apollo.Query<UpdateHotelGoodToKnowHotelQuery, UpdateHotelGoodToKnowHotelQueryVariables> {
    document = UpdateHotelGoodToKnowHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignStaffToHotelDocument = gql`
    mutation AssignStaffToHotel($input: AssignStaffToHotelCommand!) {
  assignStaffToHotel(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignStaffToHotelGQL extends Apollo.Mutation<AssignStaffToHotelMutation, AssignStaffToHotelMutationVariables> {
    document = AssignStaffToHotelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelStaffDocument = gql`
    query UpdateHotelStaff($hotelId: ID!) {
  hotelStaff(hotelId: $hotelId) {
    displayName
    email
    phoneNumber {
      countryCode
      nationalNumber
    }
    photoUrl
    staffId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelStaffGQL extends Apollo.Query<UpdateHotelStaffQuery, UpdateHotelStaffQueryVariables> {
    document = UpdateHotelStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelSupplementsDocument = gql`
    query UpdateHotelSupplements($hotelId: ID!) {
  hotel(hotelId: $hotelId) {
    rooms {
      hotelRoomId
      roomType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelSupplementsGQL extends Apollo.Query<UpdateHotelSupplementsQuery, UpdateHotelSupplementsQueryVariables> {
    document = UpdateHotelSupplementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelSupplementBundlesDocument = gql`
    query UpdateHotelSupplementBundles($assetId: ID!) {
  supplementBundleByAsset(assetId: $assetId) {
    bundleId
    name
    enabled
    sections {
      sectionId
      name
      supplements {
        supplementId
        name
        description
        iconName
        price {
          currency
          amountMicros
        }
        enabled
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelSupplementBundlesGQL extends Apollo.Query<UpdateHotelSupplementBundlesQuery, UpdateHotelSupplementBundlesQueryVariables> {
    document = UpdateHotelSupplementBundlesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelSupplementIdsListingDocument = gql`
    query UpdateHotelSupplementIdsListing($listingId: ID!) {
  listing(listingId: $listingId) {
    supplements {
      listingId
      mandatorySupplements {
        id
        price {
          currency
          amountMicros
        }
        description
      }
      optionalSupplements {
        id
        price {
          currency
          amountMicros
        }
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelSupplementIdsListingGQL extends Apollo.Query<UpdateHotelSupplementIdsListingQuery, UpdateHotelSupplementIdsListingQueryVariables> {
    document = UpdateHotelSupplementIdsListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHotelSupplementsListingDocument = gql`
    mutation UpdateHotelSupplementsListing($input: UpdateListingSupplementsCommand!) {
  updateListingSupplements(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHotelSupplementsListingGQL extends Apollo.Mutation<UpdateHotelSupplementsListingMutation, UpdateHotelSupplementsListingMutationVariables> {
    document = UpdateHotelSupplementsListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HotelsDocument = gql`
    query Hotels {
  hotels {
    general {
      name
    }
    imagery {
      photos {
        url
        useAsCover
      }
    }
    hotelId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HotelsGQL extends Apollo.Query<HotelsQuery, HotelsQueryVariables> {
    document = HotelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConversationDocument = gql`
    query Conversation($conversationId: ID!, $device: String!) {
  conversationToken(conversationId: $conversationId, device: $device) {
    identity
    token
    flokId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConversationGQL extends Apollo.Query<ConversationQuery, ConversationQueryVariables> {
    document = ConversationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendConversationMessageRequestDocument = gql`
    mutation SendConversationMessageRequest($input: SendConversationMessageRequest!) {
  sendConversationMessage(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendConversationMessageRequestGQL extends Apollo.Mutation<SendConversationMessageRequestMutation, SendConversationMessageRequestMutationVariables> {
    document = SendConversationMessageRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InboxDocument = gql`
    query Inbox {
  inbox {
    messageThreads {
      latestMessage {
        sender {
          displayName
          imageUrl
          participantId
        }
        text
        created
      }
      messageThreadId
      participants {
        chatServerIdentity
        displayName
        imageUrl
        participantId
      }
      subject {
        subjectId
        subjectType
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InboxGQL extends Apollo.Query<InboxQuery, InboxQueryVariables> {
    document = InboxDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MessageThreadBookingDocument = gql`
    query MessageThreadBooking($bookingId: ID!) {
  booking(bookingId: $bookingId) {
    bookingId
    tripId
    checkin
    checkout
    nights
    status
    summary {
      imageUrl
      location {
        address {
          city
          countryCode
        }
      }
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MessageThreadBookingGQL extends Apollo.Query<MessageThreadBookingQuery, MessageThreadBookingQueryVariables> {
    document = MessageThreadBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MessageThreadResourceScopesDocument = gql`
    query MessageThreadResourceScopes($resourceId: ID!) {
  resourceScopes(resourceId: $resourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MessageThreadResourceScopesGQL extends Apollo.Query<MessageThreadResourceScopesQuery, MessageThreadResourceScopesQueryVariables> {
    document = MessageThreadResourceScopesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyGuestDocument = gql`
    query MyGuest($bookingId: ID!) {
  myGuest(bookingId: $bookingId) {
    bookingId
    listingId
    tripId
    bookingReference
    checkin
    checkout
    guest {
      firstName
      imageUrl
      lastName
    }
    nights
    status
    summary {
      imageUrl
      location {
        address {
          city
          countryCode
        }
      }
      name
    }
    bookingSupplementsDetails {
      supplementDetails {
        supplementId
        iconName
        name
        description
        price {
          amountMicros
          currency
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyGuestGQL extends Apollo.Query<MyGuestQuery, MyGuestQueryVariables> {
    document = MyGuestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyGuestResourceScopesDocument = gql`
    query MyGuestResourceScopes($resourceId: ID!) {
  resourceScopes(resourceId: $resourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyGuestResourceScopesGQL extends Apollo.Query<MyGuestResourceScopesQuery, MyGuestResourceScopesQueryVariables> {
    document = MyGuestResourceScopesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyGuestsDocument = gql`
    query MyGuests {
  myGuests {
    bookingId
    bookingReference
    checkin
    checkout
    guest {
      firstName
      imageUrl
      lastName
    }
    listingId
    nights
    status
    tripId
    summary {
      imageUrl
      location {
        address {
          city
          countryCode
        }
      }
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyGuestsGQL extends Apollo.Query<MyGuestsQuery, MyGuestsQueryVariables> {
    document = MyGuestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyTripHostDocument = gql`
    query MyTripHost($listingId: ID!) {
  hostingTeamByListing(listingId: $listingId) {
    displayName
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyTripHostGQL extends Apollo.Query<MyTripHostQuery, MyTripHostQueryVariables> {
    document = MyTripHostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyTripDocument = gql`
    query MyTrip($tripId: ID!) {
  trip(tripId: $tripId) {
    tripId
    bookings {
      tripId
      bookingId
      bookingReference
      bookedBy {
        userId
        resellerId
      }
      checkin
      checkout
      listingId
      nights
      numberOfGuests
      guest {
        externalReference
      }
      status
      bookingTimestamp
      paymentLink {
        psp
        url
        expiresAt
      }
      paymentStatus
      fees {
        bookingFee {
          amountMicros
          currency
        }
      }
      summary {
        imageUrl
        location {
          address {
            city
            countryCode
          }
        }
        name
        subtitle
      }
      installments {
        installmentScheduleId
        installmentId
        daysPriorTo
        percentage
        bookingFeeInstallment {
          amountMicros
          currency
        }
        commissionFeesInstallment {
          commission {
            currency
            amountMicros
          }
          commissionRate
        }
        paymentStatus
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyTripGQL extends Apollo.Query<MyTripQuery, MyTripQueryVariables> {
    document = MyTripDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyTripSummaryHostDocument = gql`
    query MyTripSummaryHost($listingId: ID!) {
  hostingTeamByListing(listingId: $listingId) {
    displayName
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyTripSummaryHostGQL extends Apollo.Query<MyTripSummaryHostQuery, MyTripSummaryHostQueryVariables> {
    document = MyTripSummaryHostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyTripsDocument = gql`
    query MyTrips {
  trips {
    bookings {
      bookingId
      bookingTimestamp
      listingId
      checkin
      checkout
      status
      paymentStatus
      paymentLink {
        psp
        url
        expiresAt
      }
      summary {
        imageUrl
        location {
          address {
            city
            countryCode
          }
        }
        name
        subtitle
      }
    }
    tripId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyTripsGQL extends Apollo.Query<MyTripsQuery, MyTripsQueryVariables> {
    document = MyTripsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PasswordlessLoginExchangeAuthCodeDocument = gql`
    query PasswordlessLoginExchangeAuthCode($code: String!) {
  exchangeAuthCode(code: $code) {
    accessToken
    expiresIn
    tokenType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PasswordlessLoginExchangeAuthCodeGQL extends Apollo.Query<PasswordlessLoginExchangeAuthCodeQuery, PasswordlessLoginExchangeAuthCodeQueryVariables> {
    document = PasswordlessLoginExchangeAuthCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingsByMemberDocument = gql`
    query ListingsByMember($memberId: ID!) {
  listingsByMember(memberId: $memberId) {
    summary {
      city
      countryCode
      highlightedAmenities
      highlightedFeatures {
        features {
          iconName
          title
          description
        }
      }
      title
      subtitle
      photos {
        url
        useAsCover
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingsByMemberGQL extends Apollo.Query<ListingsByMemberQuery, ListingsByMemberQueryVariables> {
    document = ListingsByMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertiesDocument = gql`
    query Properties($skip: Int!, $limit: Int!) {
  properties(skip: $skip, limit: $limit) {
    general {
      name
    }
    imagery {
      photos {
        url
        useAsCover
      }
    }
    propertyId
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertiesGQL extends Apollo.Query<PropertiesQuery, PropertiesQueryVariables> {
    document = PropertiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertiesListingOnboardingStatusDocument = gql`
    query PropertiesListingOnboardingStatus($listingId: ID!) {
  listingOnboardingStatus(listingId: $listingId) {
    completed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertiesListingOnboardingStatusGQL extends Apollo.Query<PropertiesListingOnboardingStatusQuery, PropertiesListingOnboardingStatusQueryVariables> {
    document = PropertiesListingOnboardingStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartPropertyOnboardingDocument = gql`
    mutation StartPropertyOnboarding($input: StartPropertyOnboardingCommand!) {
  startPropertyOnboarding(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartPropertyOnboardingGQL extends Apollo.Mutation<StartPropertyOnboardingMutation, StartPropertyOnboardingMutationVariables> {
    document = StartPropertyOnboardingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportUrlDocument = gql`
    query ExportUrl($listingId: ID!) {
  exportUrl(listingId: $listingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportUrlGQL extends Apollo.Query<ExportUrlQuery, ExportUrlQueryVariables> {
    document = ExportUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingSettingsDocument = gql`
    mutation UpdateBookingSettings($input: UpdateBookingSettingsCommand!) {
  updateBookingSettings(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingSettingsGQL extends Apollo.Mutation<UpdateBookingSettingsMutation, UpdateBookingSettingsMutationVariables> {
    document = UpdateBookingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingSettingsListingDocument = gql`
    query UpdateBookingSettingsListing($listingId: ID!) {
  listing(listingId: $listingId) {
    allowInstantBook
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingSettingsListingGQL extends Apollo.Query<UpdateBookingSettingsListingQuery, UpdateBookingSettingsListingQueryVariables> {
    document = UpdateBookingSettingsListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PropertyHeaderListingDocument = gql`
    query PropertyHeaderListing($listingId: ID!) {
  listing(listingId: $listingId) {
    summary {
      city
      countryCode
      title
      subtitle
      photos {
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyHeaderListingGQL extends Apollo.Query<PropertyHeaderListingQuery, PropertyHeaderListingQueryVariables> {
    document = PropertyHeaderListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingOnboardingInProgressOnboardingStatusDocument = gql`
    query ListingOnboardingInProgressOnboardingStatus($listingId: ID!) {
  listingOnboardingStatus(listingId: $listingId) {
    completed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingOnboardingInProgressOnboardingStatusGQL extends Apollo.Query<ListingOnboardingInProgressOnboardingStatusQuery, ListingOnboardingInProgressOnboardingStatusQueryVariables> {
    document = ListingOnboardingInProgressOnboardingStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepositDaysListingDocument = gql`
    query DepositDaysListing($listingId: ID!) {
  listing(listingId: $listingId) {
    status
    asset {
      assetId
      assetType
    }
    listingId
    summary {
      city
      countryCode
      title
      subtitle
      photos {
        url
        useAsCover
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepositDaysListingGQL extends Apollo.Query<DepositDaysListingQuery, DepositDaysListingQueryVariables> {
    document = DepositDaysListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayMembershipSubscriptionDocument = gql`
    mutation PayMembershipSubscription($input: PayMembershipSubscriptionRequest!) {
  payMembershipSubscription(input: $input) {
    sessionId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayMembershipSubscriptionGQL extends Apollo.Mutation<PayMembershipSubscriptionMutation, PayMembershipSubscriptionMutationVariables> {
    document = PayMembershipSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayMembershipSubscriptionAccountDocument = gql`
    query PayMembershipSubscriptionAccount {
  account {
    accountId
    membership {
      membershipPlan {
        id
        title
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayMembershipSubscriptionAccountGQL extends Apollo.Query<PayMembershipSubscriptionAccountQuery, PayMembershipSubscriptionAccountQueryVariables> {
    document = PayMembershipSubscriptionAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayMembershipSubscriptionEligibleSubscriptionsDocument = gql`
    query PayMembershipSubscriptionEligibleSubscriptions {
  eligibleMembershipSubscriptions {
    membershipPlan {
      id
      title
      description
    }
    recurringPrice {
      amountMicros
      currency
    }
    billingPeriod
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayMembershipSubscriptionEligibleSubscriptionsGQL extends Apollo.Query<PayMembershipSubscriptionEligibleSubscriptionsQuery, PayMembershipSubscriptionEligibleSubscriptionsQueryVariables> {
    document = PayMembershipSubscriptionEligibleSubscriptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompletePropertyOnboardingAccountDocument = gql`
    query CompletePropertyOnboardingAccount {
  account {
    accountId
    membership {
      membershipPlan {
        id
        title
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompletePropertyOnboardingAccountGQL extends Apollo.Query<CompletePropertyOnboardingAccountQuery, CompletePropertyOnboardingAccountQueryVariables> {
    document = CompletePropertyOnboardingAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompletePropertyOnboardingStatusDocument = gql`
    query CompletePropertyOnboardingStatus($listingId: ID!) {
  listingOnboardingStatus(listingId: $listingId) {
    assetOnboardingCompleted
    completed
    meetsMinimumRequiredAvailability
    memberOnboardingCompleted
    canInviteOwner
    ownerAssigned
    hostingTeamAssigned
    readyForPublishing
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompletePropertyOnboardingStatusGQL extends Apollo.Query<CompletePropertyOnboardingStatusQuery, CompletePropertyOnboardingStatusQueryVariables> {
    document = CompletePropertyOnboardingStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompletePropertyOnboardingPublishListingDocument = gql`
    mutation CompletePropertyOnboardingPublishListing($input: PublishListingCommand!) {
  publishListing(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompletePropertyOnboardingPublishListingGQL extends Apollo.Mutation<CompletePropertyOnboardingPublishListingMutation, CompletePropertyOnboardingPublishListingMutationVariables> {
    document = CompletePropertyOnboardingPublishListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompletePropertyOnboardingReferMemberDocument = gql`
    mutation CompletePropertyOnboardingReferMember($input: ReferMemberCommand!) {
  referMember(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompletePropertyOnboardingReferMemberGQL extends Apollo.Mutation<CompletePropertyOnboardingReferMemberMutation, CompletePropertyOnboardingReferMemberMutationVariables> {
    document = CompletePropertyOnboardingReferMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListingOnboardingFinishedOnboardingStatusDocument = gql`
    query ListingOnboardingFinishedOnboardingStatus($listingId: ID!) {
  listingOnboardingStatus(listingId: $listingId) {
    completed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListingOnboardingFinishedOnboardingStatusGQL extends Apollo.Query<ListingOnboardingFinishedOnboardingStatusQuery, ListingOnboardingFinishedOnboardingStatusQueryVariables> {
    document = ListingOnboardingFinishedOnboardingStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicListingDocument = gql`
    query PublicListing($listingId: ID!) {
  listing(listingId: $listingId) {
    listingId
    fees {
      bookingFee {
        amountMicros
        currency
      }
      bookingToken
    }
    priceRange {
      lowest {
        bookingFee {
          currency
          amountMicros
        }
      }
      highest {
        bookingFee {
          amountMicros
          currency
        }
      }
    }
    asset {
      assetId
      assetType
      documentLibrary {
        documentLibraryId
        categories {
          documentCategoryId
          documentLibraryId
          name
          documents {
            documentId
            documentCategoryId
            documentLibraryId
            name
            url
          }
          isDefaultCategory
        }
      }
    }
    availabilityCalendar {
      dailyAllocations {
        allocated
        day
        consumed
      }
    }
    obfuscatedLocation {
      location {
        lat
        lng
      }
      range
    }
    summary {
      city
      countryCode
      title
      subtitle
      highlightedAmenities
      highlightedFeatures {
        features {
          iconName
          title
          description
        }
      }
      houseRules {
        otherRules
        rules {
          enabled
          icon
          subtitle
          title
        }
      }
      photos {
        url
        useAsCover
        description
      }
    }
    status
    allowInstantBook
    stayDurationConditions {
      minimum
    }
    operator {
      operatorId
      name
      logoUrl
    }
    installmentSchedule {
      installmentScheduleId
      installments {
        installmentScheduleId
        installmentId
        daysPriorTo
        percentage
      }
    }
    documentLibrary {
      documentLibraryId
      categories {
        documentCategoryId
        documentLibraryId
        name
        documents {
          documentId
          documentCategoryId
          documentLibraryId
          name
          url
        }
        isDefaultCategory
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicListingGQL extends Apollo.Query<PublicListingQuery, PublicListingQueryVariables> {
    document = PublicListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicWishlistListingsDocument = gql`
    query PublicWishlistListings($wishlistId: ID!) {
  publicWishlist(wishlistId: $wishlistId) {
    wishlistId
    name
    wishes {
      wishId
      travelDates {
        checkin
        checkout
      }
      guestCounts {
        key
        count
      }
      priceModification {
        adjustedBookingFee {
          currency
          amountMicros
        }
      }
      searchListing {
        asset {
          assetId
        }
        fees {
          bookingFee {
            amountMicros
            currency
          }
        }
        priceRange {
          lowest {
            bookingFee {
              amountMicros
              currency
            }
          }
          highest {
            bookingFee {
              amountMicros
              currency
            }
          }
        }
        availableFrom {
          start
          end
        }
        listingId
        status
        availabilityType
        summary {
          city
          countryCode
          highlightedFeatures {
            features {
              iconName
              title
              description
            }
          }
          decidingFactors {
            primaryDecidingFactors {
              enabled
              icon
              title
              subtitle
            }
          }
          highlightedAmenities
          title
          subtitle
          photos {
            url
            useAsCover
          }
          listingPhotos {
            url
            useAsCover
          }
          assetDescription
          listingDescription
        }
        operator {
          operatorId
          name
          logoUrl
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicWishlistListingsGQL extends Apollo.Query<PublicWishlistListingsQuery, PublicWishlistListingsQueryVariables> {
    document = PublicWishlistListingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCriteriaBrandsDocument = gql`
    query SearchCriteriaBrands {
  brands {
    brandId
    name
    logoUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCriteriaBrandsGQL extends Apollo.Query<SearchCriteriaBrandsQuery, SearchCriteriaBrandsQueryVariables> {
    document = SearchCriteriaBrandsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCriteriaVisibilityConstraintDocument = gql`
    query SearchCriteriaVisibilityConstraint {
  visibilityConstraint {
    canSeeExchangeProperties
    canSeeRentalProperties
    canSeeHotels
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCriteriaVisibilityConstraintGQL extends Apollo.Query<SearchCriteriaVisibilityConstraintQuery, SearchCriteriaVisibilityConstraintQueryVariables> {
    document = SearchCriteriaVisibilityConstraintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCriteriaWhereToMenuOptionsDocument = gql`
    query SearchCriteriaWhereToMenuOptions($includeComingSoon: Boolean!, $availabilityTypes: [AvailabilityType]!) {
  searchOptions(
    includeComingSoon: $includeComingSoon
    availabilityTypes: $availabilityTypes
  ) {
    groupedRegions {
      groupName
      regions {
        parentRegionId
        regionId
        name
        boundingBox {
          swLat
          swLng
          neLat
          neLng
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCriteriaWhereToMenuOptionsGQL extends Apollo.Query<SearchCriteriaWhereToMenuOptionsQuery, SearchCriteriaWhereToMenuOptionsQueryVariables> {
    document = SearchCriteriaWhereToMenuOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecordListingVisitDocument = gql`
    mutation RecordListingVisit($input: RecordListingVisit!) {
  recordListingVisit(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RecordListingVisitGQL extends Apollo.Mutation<RecordListingVisitMutation, RecordListingVisitMutationVariables> {
    document = RecordListingVisitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchListingsDocument = gql`
    query SearchListings($input: Criteria!) {
  searchListings(input: $input) {
    searchId
    count
    paging {
      offset
      size
      pageNumber
    }
    results {
      fees {
        bookingFee {
          amountMicros
          currency
        }
      }
      priceRange {
        lowest {
          bookingFee {
            amountMicros
            currency
          }
        }
        highest {
          bookingFee {
            amountMicros
            currency
          }
        }
      }
      commission {
        rate
      }
      availableFrom {
        start
        end
      }
      listingId
      status
      availabilityType
      summary {
        city
        countryCode
        highlightedFeatures {
          features {
            iconName
            title
            description
          }
        }
        decidingFactors {
          primaryDecidingFactors {
            enabled
            icon
            title
            subtitle
          }
        }
        highlightedAmenities
        title
        subtitle
        photos {
          url
          useAsCover
        }
      }
      obfuscatedLocation {
        location {
          lat
          lng
        }
      }
      operator {
        operatorId
        name
        logoUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchListingsGQL extends Apollo.Query<SearchListingsQuery, SearchListingsQueryVariables> {
    document = SearchListingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddToWishlistWishlistsDocument = gql`
    query AddToWishlistWishlists {
  wishlists {
    wishlistId
    userId
    name
    status
    wishes {
      wishId
      notes
      searchListing {
        listingId
      }
      travelDates {
        checkin
        checkout
      }
      guestCounts {
        key
        count
      }
      priceModification {
        adjustedBookingFee {
          currency
          amountMicros
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddToWishlistWishlistsGQL extends Apollo.Query<AddToWishlistWishlistsQuery, AddToWishlistWishlistsQueryVariables> {
    document = AddToWishlistWishlistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddWishToWishlistDocument = gql`
    mutation AddWishToWishlist($input: AddWishToWishlistCommand!) {
  addWishToWishlist(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddWishToWishlistGQL extends Apollo.Mutation<AddWishToWishlistMutation, AddWishToWishlistMutationVariables> {
    document = AddWishToWishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveWishFromWishlistDocument = gql`
    mutation RemoveWishFromWishlist($input: RemoveWishFromWishlistCommand!) {
  removeWishFromWishlist(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveWishFromWishlistGQL extends Apollo.Mutation<RemoveWishFromWishlistMutation, RemoveWishFromWishlistMutationVariables> {
    document = RemoveWishFromWishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateWishlistDocument = gql`
    mutation CreateWishlist($input: CreateWishlistCommand!) {
  createWishlist(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateWishlistGQL extends Apollo.Mutation<CreateWishlistMutation, CreateWishlistMutationVariables> {
    document = CreateWishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelectWishlistsDocument = gql`
    query SelectWishlists {
  wishlists {
    wishlistId
    userId
    name
    status
    wishes {
      wishId
      searchListing {
        listingId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelectWishlistsGQL extends Apollo.Query<SelectWishlistsQuery, SelectWishlistsQueryVariables> {
    document = SelectWishlistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWishlistDocument = gql`
    mutation UpdateWishlist($input: UpdateWishlistCommand!) {
  updateWishlist(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateWishlistGQL extends Apollo.Mutation<UpdateWishlistMutation, UpdateWishlistMutationVariables> {
    document = UpdateWishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WishlistDocument = gql`
    query Wishlist($wishlistId: ID!) {
  wishlist(wishlistId: $wishlistId) {
    wishlistId
    userId
    name
    status
    wishes {
      wishId
      travelDates {
        checkin
        checkout
      }
      guestCounts {
        key
        count
      }
      priceModification {
        adjustedBookingFee {
          currency
          amountMicros
        }
      }
      searchListing {
        fees {
          bookingFee {
            amountMicros
            currency
          }
        }
        priceRange {
          lowest {
            bookingFee {
              amountMicros
              currency
            }
          }
          highest {
            bookingFee {
              amountMicros
              currency
            }
          }
        }
        availableFrom {
          start
          end
        }
        listingId
        status
        availabilityType
        summary {
          city
          countryCode
          highlightedFeatures {
            features {
              iconName
              title
              description
            }
          }
          decidingFactors {
            primaryDecidingFactors {
              enabled
              icon
              title
              subtitle
            }
          }
          highlightedAmenities
          title
          subtitle
          photos {
            url
            useAsCover
          }
          listingPhotos {
            url
            useAsCover
          }
        }
        operator {
          operatorId
          name
          logoUrl
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WishlistGQL extends Apollo.Query<WishlistQuery, WishlistQueryVariables> {
    document = WishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WishlistsDocument = gql`
    query Wishlists {
  wishlists {
    wishlistId
    userId
    name
    status
    wishes {
      wishId
      travelDates {
        checkin
        checkout
      }
      searchListing {
        listingId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WishlistsGQL extends Apollo.Query<WishlistsQuery, WishlistsQueryVariables> {
    document = WishlistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpireWishlistDocument = gql`
    mutation ExpireWishlist($input: ExpireWishlistCommand!) {
  expireWishlist(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpireWishlistGQL extends Apollo.Mutation<ExpireWishlistMutation, ExpireWishlistMutationVariables> {
    document = ExpireWishlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }